console.log('hello');
/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function(e, t) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function(e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function(e, t) {
  "use strict";
  var n = [],
    r = e.document,
    i = Object.getPrototypeOf,
    o = n.slice,
    a = n.concat,
    s = n.push,
    u = n.indexOf,
    l = {},
    c = l.toString,
    f = l.hasOwnProperty,
    p = f.toString,
    d = p.call(Object),
    h = {},
    g = function e(t) {
      return "function" == typeof t && "number" != typeof t.nodeType;
    },
    y = function e(t) {
      return null != t && t === t.window;
    },
    v = { type: !0, src: !0, noModule: !0 };
  function m(e, t, n) {
    var i,
      o = (t = t || r).createElement("script");
    if (((o.text = e), n)) for (i in v) n[i] && (o[i] = n[i]);
    t.head.appendChild(o).parentNode.removeChild(o);
  }
  function x(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? l[c.call(e)] || "object"
      : typeof e;
  }
  var b = "3.3.1",
    w = function(e, t) {
      return new w.fn.init(e, t);
    },
    T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (w.fn = w.prototype = {
    jquery: "3.3.1",
    constructor: w,
    length: 0,
    toArray: function() {
      return o.call(this);
    },
    get: function(e) {
      return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
    },
    pushStack: function(e) {
      var t = w.merge(this.constructor(), e);
      return (t.prevObject = this), t;
    },
    each: function(e) {
      return w.each(this, e);
    },
    map: function(e) {
      return this.pushStack(
        w.map(this, function(t, n) {
          return e.call(t, n, t);
        })
      );
    },
    slice: function() {
      return this.pushStack(o.apply(this, arguments));
    },
    first: function() {
      return this.eq(0);
    },
    last: function() {
      return this.eq(-1);
    },
    eq: function(e) {
      var t = this.length,
        n = +e + (e < 0 ? t : 0);
      return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
    },
    end: function() {
      return this.prevObject || this.constructor();
    },
    push: s,
    sort: n.sort,
    splice: n.splice
  }),
    (w.extend = w.fn.extend = function() {
      var e,
        t,
        n,
        r,
        i,
        o,
        a = arguments[0] || {},
        s = 1,
        u = arguments.length,
        l = !1;
      for (
        "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
          "object" == typeof a || g(a) || (a = {}),
          s === u && ((a = this), s--);
        s < u;
        s++
      )
        if (null != (e = arguments[s]))
          for (t in e)
            (n = a[t]),
              a !== (r = e[t]) &&
                (l && r && (w.isPlainObject(r) || (i = Array.isArray(r)))
                  ? (i
                      ? ((i = !1), (o = n && Array.isArray(n) ? n : []))
                      : (o = n && w.isPlainObject(n) ? n : {}),
                    (a[t] = w.extend(l, o, r)))
                  : void 0 !== r && (a[t] = r));
      return a;
    }),
    w.extend({
      expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function(e) {
        throw new Error(e);
      },
      noop: function() {},
      isPlainObject: function(e) {
        var t, n;
        return (
          !(!e || "[object Object]" !== c.call(e)) &&
          (!(t = i(e)) ||
            ("function" ==
              typeof (n = f.call(t, "constructor") && t.constructor) &&
              p.call(n) === d))
        );
      },
      isEmptyObject: function(e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function(e) {
        m(e);
      },
      each: function(e, t) {
        var n,
          r = 0;
        if (C(e)) {
          for (n = e.length; r < n; r++)
            if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      trim: function(e) {
        return null == e ? "" : (e + "").replace(T, "");
      },
      makeArray: function(e, t) {
        var n = t || [];
        return (
          null != e &&
            (C(Object(e))
              ? w.merge(n, "string" == typeof e ? [e] : e)
              : s.call(n, e)),
          n
        );
      },
      inArray: function(e, t, n) {
        return null == t ? -1 : u.call(t, e, n);
      },
      merge: function(e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function(e, t, n) {
        for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++)
          (r = !t(e[o], o)) !== s && i.push(e[o]);
        return i;
      },
      map: function(e, t, n) {
        var r,
          i,
          o = 0,
          s = [];
        if (C(e))
          for (r = e.length; o < r; o++)
            null != (i = t(e[o], o, n)) && s.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && s.push(i);
        return a.apply([], s);
      },
      guid: 1,
      support: h
    }),
    "function" == typeof Symbol && (w.fn[Symbol.iterator] = n[Symbol.iterator]),
    w.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function(e, t) {
        l["[object " + t + "]"] = t.toLowerCase();
      }
    );
  function C(e) {
    var t = !!e && "length" in e && e.length,
      n = x(e);
    return (
      !g(e) &&
      !y(e) &&
      ("array" === n ||
        0 === t ||
        ("number" == typeof t && t > 0 && t - 1 in e))
    );
  }
  var E = (function(e) {
    var t,
      n,
      r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f,
      p,
      d,
      h,
      g,
      y,
      v,
      m,
      x,
      b = "sizzle" + 1 * new Date(),
      w = e.document,
      T = 0,
      C = 0,
      E = ae(),
      k = ae(),
      S = ae(),
      D = function(e, t) {
        return e === t && (f = !0), 0;
      },
      N = {}.hasOwnProperty,
      A = [],
      j = A.pop,
      q = A.push,
      L = A.push,
      H = A.slice,
      O = function(e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      P =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      M = "[\\x20\\t\\r\\n\\f]",
      R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
      I =
        "\\[" +
        M +
        "*(" +
        R +
        ")(?:" +
        M +
        "*([*^$|!~]?=)" +
        M +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        R +
        "))|)" +
        M +
        "*\\]",
      W =
        ":(" +
        R +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        I +
        ")*)|.*)\\)|)",
      $ = new RegExp(M + "+", "g"),
      B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
      F = new RegExp("^" + M + "*," + M + "*"),
      _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
      z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]", "g"),
      X = new RegExp(W),
      U = new RegExp("^" + R + "$"),
      V = {
        ID: new RegExp("^#(" + R + ")"),
        CLASS: new RegExp("^\\.(" + R + ")"),
        TAG: new RegExp("^(" + R + "|[*])"),
        ATTR: new RegExp("^" + I),
        PSEUDO: new RegExp("^" + W),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            M +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            M +
            "*(?:([+-]|)" +
            M +
            "*(\\d+)|))" +
            M +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + P + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            M +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            M +
            "*((?:-\\d)?\\d*)" +
            M +
            "*\\)|)(?=[^-]|$)",
          "i"
        )
      },
      G = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Q = /^[^{]+\{\s*\[native \w/,
      J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      K = /[+~]/,
      Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)", "ig"),
      ee = function(e, t, n) {
        var r = "0x" + t - 65536;
        return r !== r || n
          ? t
          : r < 0
          ? String.fromCharCode(r + 65536)
          : String.fromCharCode((r >> 10) | 55296, (1023 & r) | 56320);
      },
      te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ne = function(e, t) {
        return t
          ? "\0" === e
            ? "\ufffd"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      re = function() {
        p();
      },
      ie = me(
        function(e) {
          return !0 === e.disabled && ("form" in e || "label" in e);
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      L.apply((A = H.call(w.childNodes)), w.childNodes),
        A[w.childNodes.length].nodeType;
    } catch (e) {
      L = {
        apply: A.length
          ? function(e, t) {
              q.apply(e, H.call(t));
            }
          : function(e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            }
      };
    }
    function oe(e, t, r, i) {
      var o,
        s,
        l,
        c,
        f,
        h,
        v,
        m = t && t.ownerDocument,
        T = t ? t.nodeType : 9;
      if (
        ((r = r || []),
        "string" != typeof e || !e || (1 !== T && 9 !== T && 11 !== T))
      )
        return r;
      if (
        !i &&
        ((t ? t.ownerDocument || t : w) !== d && p(t), (t = t || d), g)
      ) {
        if (11 !== T && (f = J.exec(e)))
          if ((o = f[1])) {
            if (9 === T) {
              if (!(l = t.getElementById(o))) return r;
              if (l.id === o) return r.push(l), r;
            } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o)
              return r.push(l), r;
          } else {
            if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;
            if (
              (o = f[3]) &&
              n.getElementsByClassName &&
              t.getElementsByClassName
            )
              return L.apply(r, t.getElementsByClassName(o)), r;
          }
        if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
          if (1 !== T) (m = t), (v = e);
          else if ("object" !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute("id"))
              ? (c = c.replace(te, ne))
              : t.setAttribute("id", (c = b)),
              (s = (h = a(e)).length);
            while (s--) h[s] = "#" + c + " " + ve(h[s]);
            (v = h.join(",")), (m = (K.test(e) && ge(t.parentNode)) || t);
          }
          if (v)
            try {
              return L.apply(r, m.querySelectorAll(v)), r;
            } catch (e) {
            } finally {
              c === b && t.removeAttribute("id");
            }
        }
      }
      return u(e.replace(B, "$1"), t, r, i);
    }
    function ae() {
      var e = [];
      function t(n, i) {
        return (
          e.push(n + " ") > r.cacheLength && delete t[e.shift()],
          (t[n + " "] = i)
        );
      }
      return t;
    }
    function se(e) {
      return (e[b] = !0), e;
    }
    function ue(e) {
      var t = d.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function le(e, t) {
      var n = e.split("|"),
        i = n.length;
      while (i--) r.attrHandle[n[i]] = t;
    }
    function ce(e, t) {
      var n = t && e,
        r =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function fe(e) {
      return function(t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }
    function pe(e) {
      return function(t) {
        var n = t.nodeName.toLowerCase();
        return ("input" === n || "button" === n) && t.type === e;
      };
    }
    function de(e) {
      return function(t) {
        return "form" in t
          ? t.parentNode && !1 === t.disabled
            ? "label" in t
              ? "label" in t.parentNode
                ? t.parentNode.disabled === e
                : t.disabled === e
              : t.isDisabled === e || (t.isDisabled !== !e && ie(t) === e)
            : t.disabled === e
          : "label" in t && t.disabled === e;
      };
    }
    function he(e) {
      return se(function(t) {
        return (
          (t = +t),
          se(function(n, r) {
            var i,
              o = e([], n.length, t),
              a = o.length;
            while (a--) n[(i = o[a])] && (n[i] = !(r[i] = n[i]));
          })
        );
      });
    }
    function ge(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }
    (n = oe.support = {}),
      (o = oe.isXML = function(e) {
        var t = e && (e.ownerDocument || e).documentElement;
        return !!t && "HTML" !== t.nodeName;
      }),
      (p = oe.setDocument = function(e) {
        var t,
          i,
          a = e ? e.ownerDocument || e : w;
        return a !== d && 9 === a.nodeType && a.documentElement
          ? ((d = a),
            (h = d.documentElement),
            (g = !o(d)),
            w !== d &&
              (i = d.defaultView) &&
              i.top !== i &&
              (i.addEventListener
                ? i.addEventListener("unload", re, !1)
                : i.attachEvent && i.attachEvent("onunload", re)),
            (n.attributes = ue(function(e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (n.getElementsByTagName = ue(function(e) {
              return (
                e.appendChild(d.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (n.getElementsByClassName = Q.test(d.getElementsByClassName)),
            (n.getById = ue(function(e) {
              return (
                (h.appendChild(e).id = b),
                !d.getElementsByName || !d.getElementsByName(b).length
              );
            })),
            n.getById
              ? ((r.filter.ID = function(e) {
                  var t = e.replace(Z, ee);
                  return function(e) {
                    return e.getAttribute("id") === t;
                  };
                }),
                (r.find.ID = function(e, t) {
                  if ("undefined" != typeof t.getElementById && g) {
                    var n = t.getElementById(e);
                    return n ? [n] : [];
                  }
                }))
              : ((r.filter.ID = function(e) {
                  var t = e.replace(Z, ee);
                  return function(e) {
                    var n =
                      "undefined" != typeof e.getAttributeNode &&
                      e.getAttributeNode("id");
                    return n && n.value === t;
                  };
                }),
                (r.find.ID = function(e, t) {
                  if ("undefined" != typeof t.getElementById && g) {
                    var n,
                      r,
                      i,
                      o = t.getElementById(e);
                    if (o) {
                      if ((n = o.getAttributeNode("id")) && n.value === e)
                        return [o];
                      (i = t.getElementsByName(e)), (r = 0);
                      while ((o = i[r++]))
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                          return [o];
                    }
                    return [];
                  }
                })),
            (r.find.TAG = n.getElementsByTagName
              ? function(e, t) {
                  return "undefined" != typeof t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : n.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function(e, t) {
                  var n,
                    r = [],
                    i = 0,
                    o = t.getElementsByTagName(e);
                  if ("*" === e) {
                    while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                    return r;
                  }
                  return o;
                }),
            (r.find.CLASS =
              n.getElementsByClassName &&
              function(e, t) {
                if ("undefined" != typeof t.getElementsByClassName && g)
                  return t.getElementsByClassName(e);
              }),
            (v = []),
            (y = []),
            (n.qsa = Q.test(d.querySelectorAll)) &&
              (ue(function(e) {
                (h.appendChild(e).innerHTML =
                  "<a id='" +
                  b +
                  "'></a><select id='" +
                  b +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    y.push("[*^$]=" + M + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    y.push("\\[" + M + "*(?:value|" + P + ")"),
                  e.querySelectorAll("[id~=" + b + "-]").length || y.push("~="),
                  e.querySelectorAll(":checked").length || y.push(":checked"),
                  e.querySelectorAll("a#" + b + "+*").length ||
                    y.push(".#.+[+~]");
              }),
              ue(function(e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = d.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    y.push("name" + M + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length &&
                    y.push(":enabled", ":disabled"),
                  (h.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(":disabled").length &&
                    y.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  y.push(",.*:");
              })),
            (n.matchesSelector = Q.test(
              (m =
                h.matches ||
                h.webkitMatchesSelector ||
                h.mozMatchesSelector ||
                h.oMatchesSelector ||
                h.msMatchesSelector)
            )) &&
              ue(function(e) {
                (n.disconnectedMatch = m.call(e, "*")),
                  m.call(e, "[s!='']:x"),
                  v.push("!=", W);
              }),
            (y = y.length && new RegExp(y.join("|"))),
            (v = v.length && new RegExp(v.join("|"))),
            (t = Q.test(h.compareDocumentPosition)),
            (x =
              t || Q.test(h.contains)
                ? function(e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                      r = t && t.parentNode;
                    return (
                      e === r ||
                      !(
                        !r ||
                        1 !== r.nodeType ||
                        !(n.contains
                          ? n.contains(r)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(r))
                      )
                    );
                  }
                : function(e, t) {
                    if (t) while ((t = t.parentNode)) if (t === e) return !0;
                    return !1;
                  }),
            (D = t
              ? function(e, t) {
                  if (e === t) return (f = !0), 0;
                  var r =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    r ||
                    (1 &
                      (r =
                        (e.ownerDocument || e) === (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!n.sortDetached && t.compareDocumentPosition(e) === r)
                      ? e === d || (e.ownerDocument === w && x(w, e))
                        ? -1
                        : t === d || (t.ownerDocument === w && x(w, t))
                        ? 1
                        : c
                        ? O(c, e) - O(c, t)
                        : 0
                      : 4 & r
                      ? -1
                      : 1)
                  );
                }
              : function(e, t) {
                  if (e === t) return (f = !0), 0;
                  var n,
                    r = 0,
                    i = e.parentNode,
                    o = t.parentNode,
                    a = [e],
                    s = [t];
                  if (!i || !o)
                    return e === d
                      ? -1
                      : t === d
                      ? 1
                      : i
                      ? -1
                      : o
                      ? 1
                      : c
                      ? O(c, e) - O(c, t)
                      : 0;
                  if (i === o) return ce(e, t);
                  n = e;
                  while ((n = n.parentNode)) a.unshift(n);
                  n = t;
                  while ((n = n.parentNode)) s.unshift(n);
                  while (a[r] === s[r]) r++;
                  return r
                    ? ce(a[r], s[r])
                    : a[r] === w
                    ? -1
                    : s[r] === w
                    ? 1
                    : 0;
                }),
            d)
          : d;
      }),
      (oe.matches = function(e, t) {
        return oe(e, null, null, t);
      }),
      (oe.matchesSelector = function(e, t) {
        if (
          ((e.ownerDocument || e) !== d && p(e),
          (t = t.replace(z, "='$1']")),
          n.matchesSelector &&
            g &&
            !S[t + " "] &&
            (!v || !v.test(t)) &&
            (!y || !y.test(t)))
        )
          try {
            var r = m.call(e, t);
            if (
              r ||
              n.disconnectedMatch ||
              (e.document && 11 !== e.document.nodeType)
            )
              return r;
          } catch (e) {}
        return oe(t, d, null, [e]).length > 0;
      }),
      (oe.contains = function(e, t) {
        return (e.ownerDocument || e) !== d && p(e), x(e, t);
      }),
      (oe.attr = function(e, t) {
        (e.ownerDocument || e) !== d && p(e);
        var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
        return void 0 !== o
          ? o
          : n.attributes || !g
          ? e.getAttribute(t)
          : (o = e.getAttributeNode(t)) && o.specified
          ? o.value
          : null;
      }),
      (oe.escape = function(e) {
        return (e + "").replace(te, ne);
      }),
      (oe.error = function(e) {
        throw new Error("Syntax error, unrecognized expression: " + e);
      }),
      (oe.uniqueSort = function(e) {
        var t,
          r = [],
          i = 0,
          o = 0;
        if (
          ((f = !n.detectDuplicates),
          (c = !n.sortStable && e.slice(0)),
          e.sort(D),
          f)
        ) {
          while ((t = e[o++])) t === e[o] && (i = r.push(o));
          while (i--) e.splice(r[i], 1);
        }
        return (c = null), e;
      }),
      (i = oe.getText = function(e) {
        var t,
          n = "",
          r = 0,
          o = e.nodeType;
        if (o) {
          if (1 === o || 9 === o || 11 === o) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) n += i(e);
          } else if (3 === o || 4 === o) return e.nodeValue;
        } else while ((t = e[r++])) n += i(t);
        return n;
      }),
      ((r = oe.selectors = {
        cacheLength: 50,
        createPseudo: se,
        match: V,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(e) {
            return (
              (e[1] = e[1].replace(Z, ee)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function(e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || oe.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && oe.error(e[0]),
              e
            );
          },
          PSEUDO: function(e) {
            var t,
              n = !e[6] && e[2];
            return V.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : n &&
                    X.test(n) &&
                    (t = a(n, !0)) &&
                    (t = n.indexOf(")", n.length - t) - n.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                e.slice(0, 3));
          }
        },
        filter: {
          TAG: function(e) {
            var t = e.replace(Z, ee).toLowerCase();
            return "*" === e
              ? function() {
                  return !0;
                }
              : function(e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function(e) {
            var t = E[e + " "];
            return (
              t ||
              ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                E(e, function(e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      ("undefined" != typeof e.getAttribute &&
                        e.getAttribute("class")) ||
                      ""
                  );
                }))
            );
          },
          ATTR: function(e, t, n) {
            return function(r) {
              var i = oe.attr(r, e);
              return null == i
                ? "!=" === t
                : !t ||
                    ((i += ""),
                    "=" === t
                      ? i === n
                      : "!=" === t
                      ? i !== n
                      : "^=" === t
                      ? n && 0 === i.indexOf(n)
                      : "*=" === t
                      ? n && i.indexOf(n) > -1
                      : "$=" === t
                      ? n && i.slice(-n.length) === n
                      : "~=" === t
                      ? (" " + i.replace($, " ") + " ").indexOf(n) > -1
                      : "|=" === t &&
                        (i === n || i.slice(0, n.length + 1) === n + "-"));
            };
          },
          CHILD: function(e, t, n, r, i) {
            var o = "nth" !== e.slice(0, 3),
              a = "last" !== e.slice(-4),
              s = "of-type" === t;
            return 1 === r && 0 === i
              ? function(e) {
                  return !!e.parentNode;
                }
              : function(t, n, u) {
                  var l,
                    c,
                    f,
                    p,
                    d,
                    h,
                    g = o !== a ? "nextSibling" : "previousSibling",
                    y = t.parentNode,
                    v = s && t.nodeName.toLowerCase(),
                    m = !u && !s,
                    x = !1;
                  if (y) {
                    if (o) {
                      while (g) {
                        p = t;
                        while ((p = p[g]))
                          if (
                            s
                              ? p.nodeName.toLowerCase() === v
                              : 1 === p.nodeType
                          )
                            return !1;
                        h = g = "only" === e && !h && "nextSibling";
                      }
                      return !0;
                    }
                    if (((h = [a ? y.firstChild : y.lastChild]), a && m)) {
                      (x =
                        (d =
                          (l =
                            (c =
                              (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] ||
                              (f[p.uniqueID] = {}))[e] || [])[0] === T &&
                          l[1]) && l[2]),
                        (p = d && y.childNodes[d]);
                      while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                        if (1 === p.nodeType && ++x && p === t) {
                          c[e] = [T, d, x];
                          break;
                        }
                    } else if (
                      (m &&
                        (x = d =
                          (l =
                            (c =
                              (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] ||
                              (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]),
                      !1 === x)
                    )
                      while ((p = (++d && p && p[g]) || (x = d = 0) || h.pop()))
                        if (
                          (s
                            ? p.nodeName.toLowerCase() === v
                            : 1 === p.nodeType) &&
                          ++x &&
                          (m &&
                            ((c =
                              (f = p[b] || (p[b] = {}))[p.uniqueID] ||
                              (f[p.uniqueID] = {}))[e] = [T, x]),
                          p === t)
                        )
                          break;
                    return (x -= i) === r || (x % r == 0 && x / r >= 0);
                  }
                };
          },
          PSEUDO: function(e, t) {
            var n,
              i =
                r.pseudos[e] ||
                r.setFilters[e.toLowerCase()] ||
                oe.error("unsupported pseudo: " + e);
            return i[b]
              ? i(t)
              : i.length > 1
              ? ((n = [e, e, "", t]),
                r.setFilters.hasOwnProperty(e.toLowerCase())
                  ? se(function(e, n) {
                      var r,
                        o = i(e, t),
                        a = o.length;
                      while (a--) e[(r = O(e, o[a]))] = !(n[r] = o[a]);
                    })
                  : function(e) {
                      return i(e, 0, n);
                    })
              : i;
          }
        },
        pseudos: {
          not: se(function(e) {
            var t = [],
              n = [],
              r = s(e.replace(B, "$1"));
            return r[b]
              ? se(function(e, t, n, i) {
                  var o,
                    a = r(e, null, i, []),
                    s = e.length;
                  while (s--) (o = a[s]) && (e[s] = !(t[s] = o));
                })
              : function(e, i, o) {
                  return (t[0] = e), r(t, null, o, n), (t[0] = null), !n.pop();
                };
          }),
          has: se(function(e) {
            return function(t) {
              return oe(e, t).length > 0;
            };
          }),
          contains: se(function(e) {
            return (
              (e = e.replace(Z, ee)),
              function(t) {
                return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
              }
            );
          }),
          lang: se(function(e) {
            return (
              U.test(e || "") || oe.error("unsupported lang: " + e),
              (e = e.replace(Z, ee).toLowerCase()),
              function(t) {
                var n;
                do {
                  if (
                    (n = g
                      ? t.lang
                      : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                  )
                    return (
                      (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
                    );
                } while ((t = t.parentNode) && 1 === t.nodeType);
                return !1;
              }
            );
          }),
          target: function(t) {
            var n = e.location && e.location.hash;
            return n && n.slice(1) === t.id;
          },
          root: function(e) {
            return e === h;
          },
          focus: function(e) {
            return (
              e === d.activeElement &&
              (!d.hasFocus || d.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: de(!1),
          disabled: de(!0),
          checked: function(e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function(e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function(e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function(e) {
            return !r.pseudos.empty(e);
          },
          header: function(e) {
            return Y.test(e.nodeName);
          },
          input: function(e) {
            return G.test(e.nodeName);
          },
          button: function(e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function(e) {
            var t;
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (t = e.getAttribute("type")) ||
                "text" === t.toLowerCase())
            );
          },
          first: he(function() {
            return [0];
          }),
          last: he(function(e, t) {
            return [t - 1];
          }),
          eq: he(function(e, t, n) {
            return [n < 0 ? n + t : n];
          }),
          even: he(function(e, t) {
            for (var n = 0; n < t; n += 2) e.push(n);
            return e;
          }),
          odd: he(function(e, t) {
            for (var n = 1; n < t; n += 2) e.push(n);
            return e;
          }),
          lt: he(function(e, t, n) {
            for (var r = n < 0 ? n + t : n; --r >= 0; ) e.push(r);
            return e;
          }),
          gt: he(function(e, t, n) {
            for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
            return e;
          })
        }
      }).pseudos.nth = r.pseudos.eq);
    for (t in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
      r.pseudos[t] = fe(t);
    for (t in { submit: !0, reset: !0 }) r.pseudos[t] = pe(t);
    function ye() {}
    (ye.prototype = r.filters = r.pseudos),
      (r.setFilters = new ye()),
      (a = oe.tokenize = function(e, t) {
        var n,
          i,
          o,
          a,
          s,
          u,
          l,
          c = k[e + " "];
        if (c) return t ? 0 : c.slice(0);
        (s = e), (u = []), (l = r.preFilter);
        while (s) {
          (n && !(i = F.exec(s))) ||
            (i && (s = s.slice(i[0].length) || s), u.push((o = []))),
            (n = !1),
            (i = _.exec(s)) &&
              ((n = i.shift()),
              o.push({ value: n, type: i[0].replace(B, " ") }),
              (s = s.slice(n.length)));
          for (a in r.filter)
            !(i = V[a].exec(s)) ||
              (l[a] && !(i = l[a](i))) ||
              ((n = i.shift()),
              o.push({ value: n, type: a, matches: i }),
              (s = s.slice(n.length)));
          if (!n) break;
        }
        return t ? s.length : s ? oe.error(e) : k(e, u).slice(0);
      });
    function ve(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
      return r;
    }
    function me(e, t, n) {
      var r = t.dir,
        i = t.next,
        o = i || r,
        a = n && "parentNode" === o,
        s = C++;
      return t.first
        ? function(t, n, i) {
            while ((t = t[r])) if (1 === t.nodeType || a) return e(t, n, i);
            return !1;
          }
        : function(t, n, u) {
            var l,
              c,
              f,
              p = [T, s];
            if (u) {
              while ((t = t[r]))
                if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
            } else
              while ((t = t[r]))
                if (1 === t.nodeType || a)
                  if (
                    ((f = t[b] || (t[b] = {})),
                    (c = f[t.uniqueID] || (f[t.uniqueID] = {})),
                    i && i === t.nodeName.toLowerCase())
                  )
                    t = t[r] || t;
                  else {
                    if ((l = c[o]) && l[0] === T && l[1] === s)
                      return (p[2] = l[2]);
                    if (((c[o] = p), (p[2] = e(t, n, u)))) return !0;
                  }
            return !1;
          };
    }
    function xe(e) {
      return e.length > 1
        ? function(t, n, r) {
            var i = e.length;
            while (i--) if (!e[i](t, n, r)) return !1;
            return !0;
          }
        : e[0];
    }
    function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) oe(e, t[r], n);
      return n;
    }
    function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Te(e, t, n, r, i, o) {
      return (
        r && !r[b] && (r = Te(r)),
        i && !i[b] && (i = Te(i, o)),
        se(function(o, a, s, u) {
          var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || "*", s.nodeType ? [s] : s, []),
            y = !e || (!o && t) ? g : we(g, p, e, s, u),
            v = n ? (i || (o ? e : h || r) ? [] : a) : y;
          if ((n && n(y, v, s, u), r)) {
            (l = we(v, d)), r(l, [], s, u), (c = l.length);
            while (c--) (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
          }
          if (o) {
            if (i || e) {
              if (i) {
                (l = []), (c = v.length);
                while (c--) (f = v[c]) && l.push((y[c] = f));
                i(null, (v = []), l, u);
              }
              c = v.length;
              while (c--)
                (f = v[c]) &&
                  (l = i ? O(o, f) : p[c]) > -1 &&
                  (o[l] = !(a[l] = f));
            }
          } else (v = we(v === a ? v.splice(h, v.length) : v)), i ? i(null, a, v, u) : L.apply(a, v);
        })
      );
    }
    function Ce(e) {
      for (
        var t,
          n,
          i,
          o = e.length,
          a = r.relative[e[0].type],
          s = a || r.relative[" "],
          u = a ? 1 : 0,
          c = me(
            function(e) {
              return e === t;
            },
            s,
            !0
          ),
          f = me(
            function(e) {
              return O(t, e) > -1;
            },
            s,
            !0
          ),
          p = [
            function(e, n, r) {
              var i =
                (!a && (r || n !== l)) ||
                ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
              return (t = null), i;
            }
          ];
        u < o;
        u++
      )
        if ((n = r.relative[e[u].type])) p = [me(xe(p), n)];
        else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) if (r.relative[e[i].type]) break;
            return Te(
              u > 1 && xe(p),
              u > 1 &&
                ve(
                  e
                    .slice(0, u - 1)
                    .concat({ value: " " === e[u - 2].type ? "*" : "" })
                ).replace(B, "$1"),
              n,
              u < i && Ce(e.slice(u, i)),
              i < o && Ce((e = e.slice(i))),
              i < o && ve(e)
            );
          }
          p.push(n);
        }
      return xe(p);
    }
    function Ee(e, t) {
      var n = t.length > 0,
        i = e.length > 0,
        o = function(o, a, s, u, c) {
          var f,
            h,
            y,
            v = 0,
            m = "0",
            x = o && [],
            b = [],
            w = l,
            C = o || (i && r.find.TAG("*", c)),
            E = (T += null == w ? 1 : Math.random() || 0.1),
            k = C.length;
          for (
            c && (l = a === d || a || c);
            m !== k && null != (f = C[m]);
            m++
          ) {
            if (i && f) {
              (h = 0), a || f.ownerDocument === d || (p(f), (s = !g));
              while ((y = e[h++]))
                if (y(f, a || d, s)) {
                  u.push(f);
                  break;
                }
              c && (T = E);
            }
            n && ((f = !y && f) && v--, o && x.push(f));
          }
          if (((v += m), n && m !== v)) {
            h = 0;
            while ((y = t[h++])) y(x, b, a, s);
            if (o) {
              if (v > 0) while (m--) x[m] || b[m] || (b[m] = j.call(u));
              b = we(b);
            }
            L.apply(u, b),
              c && !o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u);
          }
          return c && ((T = E), (l = w)), x;
        };
      return n ? se(o) : o;
    }
    return (
      (s = oe.compile = function(e, t) {
        var n,
          r = [],
          i = [],
          o = S[e + " "];
        if (!o) {
          t || (t = a(e)), (n = t.length);
          while (n--) (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
          (o = S(e, Ee(i, r))).selector = e;
        }
        return o;
      }),
      (u = oe.select = function(e, t, n, i) {
        var o,
          u,
          l,
          c,
          f,
          p = "function" == typeof e && e,
          d = !i && a((e = p.selector || e));
        if (((n = n || []), 1 === d.length)) {
          if (
            (u = d[0] = d[0].slice(0)).length > 2 &&
            "ID" === (l = u[0]).type &&
            9 === t.nodeType &&
            g &&
            r.relative[u[1].type]
          ) {
            if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0]))
              return n;
            p && (t = t.parentNode), (e = e.slice(u.shift().value.length));
          }
          o = V.needsContext.test(e) ? 0 : u.length;
          while (o--) {
            if (((l = u[o]), r.relative[(c = l.type)])) break;
            if (
              (f = r.find[c]) &&
              (i = f(
                l.matches[0].replace(Z, ee),
                (K.test(u[0].type) && ge(t.parentNode)) || t
              ))
            ) {
              if ((u.splice(o, 1), !(e = i.length && ve(u))))
                return L.apply(n, i), n;
              break;
            }
          }
        }
        return (
          (p || s(e, d))(
            i,
            t,
            !g,
            n,
            !t || (K.test(e) && ge(t.parentNode)) || t
          ),
          n
        );
      }),
      (n.sortStable =
        b
          .split("")
          .sort(D)
          .join("") === b),
      (n.detectDuplicates = !!f),
      p(),
      (n.sortDetached = ue(function(e) {
        return 1 & e.compareDocumentPosition(d.createElement("fieldset"));
      })),
      ue(function(e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        le("type|href|height|width", function(e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (n.attributes &&
        ue(function(e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        le("value", function(e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ue(function(e) {
        return null == e.getAttribute("disabled");
      }) ||
        le(P, function(e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      oe
    );
  })(e);
  (w.find = E),
    (w.expr = E.selectors),
    (w.expr[":"] = w.expr.pseudos),
    (w.uniqueSort = w.unique = E.uniqueSort),
    (w.text = E.getText),
    (w.isXMLDoc = E.isXML),
    (w.contains = E.contains),
    (w.escapeSelector = E.escape);
  var k = function(e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && w(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    S = function(e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    D = w.expr.match.needsContext;
  function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function j(e, t, n) {
    return g(t)
      ? w.grep(e, function(e, r) {
          return !!t.call(e, r, e) !== n;
        })
      : t.nodeType
      ? w.grep(e, function(e) {
          return (e === t) !== n;
        })
      : "string" != typeof t
      ? w.grep(e, function(e) {
          return u.call(t, e) > -1 !== n;
        })
      : w.filter(t, e, n);
  }
  (w.filter = function(e, t, n) {
    var r = t[0];
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === r.nodeType
        ? w.find.matchesSelector(r, e)
          ? [r]
          : []
        : w.find.matches(
            e,
            w.grep(t, function(e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    w.fn.extend({
      find: function(e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ("string" != typeof e)
          return this.pushStack(
            w(e).filter(function() {
              for (t = 0; t < r; t++) if (w.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) w.find(e, i[t], n);
        return r > 1 ? w.uniqueSort(n) : n;
      },
      filter: function(e) {
        return this.pushStack(j(this, e || [], !1));
      },
      not: function(e) {
        return this.pushStack(j(this, e || [], !0));
      },
      is: function(e) {
        return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1)
          .length;
      }
    });
  var q,
    L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((w.fn.init = function(e, t, n) {
    var i, o;
    if (!e) return this;
    if (((n = n || q), "string" == typeof e)) {
      if (
        !(i =
          "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
            ? [null, e, null]
            : L.exec(e)) ||
        (!i[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (i[1]) {
        if (
          ((t = t instanceof w ? t[0] : t),
          w.merge(
            this,
            w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)
          ),
          A.test(i[1]) && w.isPlainObject(t))
        )
          for (i in t) g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        return this;
      }
      return (
        (o = r.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : g(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(w)
      : w.makeArray(e, this);
  }).prototype = w.fn),
    (q = w(r));
  var H = /^(?:parents|prev(?:Until|All))/,
    O = { children: !0, contents: !0, next: !0, prev: !0 };
  w.fn.extend({
    has: function(e) {
      var t = w(e, this),
        n = t.length;
      return this.filter(function() {
        for (var e = 0; e < n; e++) if (w.contains(this, t[e])) return !0;
      });
    },
    closest: function(e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = "string" != typeof e && w(e);
      if (!D.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a
                ? a.index(n) > -1
                : 1 === n.nodeType && w.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    },
    index: function(e) {
      return e
        ? "string" == typeof e
          ? u.call(w(e), this[0])
          : u.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function(e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    },
    addBack: function(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    }
  });
  function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  w.each(
    {
      parent: function(e) {
        var t = e.parentNode;
        return t && 11 !== t.nodeType ? t : null;
      },
      parents: function(e) {
        return k(e, "parentNode");
      },
      parentsUntil: function(e, t, n) {
        return k(e, "parentNode", n);
      },
      next: function(e) {
        return P(e, "nextSibling");
      },
      prev: function(e) {
        return P(e, "previousSibling");
      },
      nextAll: function(e) {
        return k(e, "nextSibling");
      },
      prevAll: function(e) {
        return k(e, "previousSibling");
      },
      nextUntil: function(e, t, n) {
        return k(e, "nextSibling", n);
      },
      prevUntil: function(e, t, n) {
        return k(e, "previousSibling", n);
      },
      siblings: function(e) {
        return S((e.parentNode || {}).firstChild, e);
      },
      children: function(e) {
        return S(e.firstChild);
      },
      contents: function(e) {
        return N(e, "iframe")
          ? e.contentDocument
          : (N(e, "template") && (e = e.content || e),
            w.merge([], e.childNodes));
      }
    },
    function(e, t) {
      w.fn[e] = function(n, r) {
        var i = w.map(this, t, n);
        return (
          "Until" !== e.slice(-5) && (r = n),
          r && "string" == typeof r && (i = w.filter(r, i)),
          this.length > 1 &&
            (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()),
          this.pushStack(i)
        );
      };
    }
  );
  var M = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    var t = {};
    return (
      w.each(e.match(M) || [], function(e, n) {
        t[n] = !0;
      }),
      t
    );
  }
  w.Callbacks = function(e) {
    e = "string" == typeof e ? R(e) : w.extend({}, e);
    var t,
      n,
      r,
      i,
      o = [],
      a = [],
      s = -1,
      u = function() {
        for (i = i || e.once, r = t = !0; a.length; s = -1) {
          n = a.shift();
          while (++s < o.length)
            !1 === o[s].apply(n[0], n[1]) &&
              e.stopOnFalse &&
              ((s = o.length), (n = !1));
        }
        e.memory || (n = !1), (t = !1), i && (o = n ? [] : "");
      },
      l = {
        add: function() {
          return (
            o &&
              (n && !t && ((s = o.length - 1), a.push(n)),
              (function t(n) {
                w.each(n, function(n, r) {
                  g(r)
                    ? (e.unique && l.has(r)) || o.push(r)
                    : r && r.length && "string" !== x(r) && t(r);
                });
              })(arguments),
              n && !t && u()),
            this
          );
        },
        remove: function() {
          return (
            w.each(arguments, function(e, t) {
              var n;
              while ((n = w.inArray(t, o, n)) > -1)
                o.splice(n, 1), n <= s && s--;
            }),
            this
          );
        },
        has: function(e) {
          return e ? w.inArray(e, o) > -1 : o.length > 0;
        },
        empty: function() {
          return o && (o = []), this;
        },
        disable: function() {
          return (i = a = []), (o = n = ""), this;
        },
        disabled: function() {
          return !o;
        },
        lock: function() {
          return (i = a = []), n || t || (o = n = ""), this;
        },
        locked: function() {
          return !!i;
        },
        fireWith: function(e, n) {
          return (
            i ||
              ((n = [e, (n = n || []).slice ? n.slice() : n]),
              a.push(n),
              t || u()),
            this
          );
        },
        fire: function() {
          return l.fireWith(this, arguments), this;
        },
        fired: function() {
          return !!r;
        }
      };
    return l;
  };
  function I(e) {
    return e;
  }
  function W(e) {
    throw e;
  }
  function $(e, t, n, r) {
    var i;
    try {
      e && g((i = e.promise))
        ? i
            .call(e)
            .done(t)
            .fail(n)
        : e && g((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  w.extend({
    Deferred: function(t) {
      var n = [
          [
            "notify",
            "progress",
            w.Callbacks("memory"),
            w.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            w.Callbacks("once memory"),
            w.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            w.Callbacks("once memory"),
            w.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ],
        r = "pending",
        i = {
          state: function() {
            return r;
          },
          always: function() {
            return o.done(arguments).fail(arguments), this;
          },
          catch: function(e) {
            return i.then(null, e);
          },
          pipe: function() {
            var e = arguments;
            return w
              .Deferred(function(t) {
                w.each(n, function(n, r) {
                  var i = g(e[r[4]]) && e[r[4]];
                  o[r[1]](function() {
                    var e = i && i.apply(this, arguments);
                    e && g(e.promise)
                      ? e
                          .promise()
                          .progress(t.notify)
                          .done(t.resolve)
                          .fail(t.reject)
                      : t[r[0] + "With"](this, i ? [e] : arguments);
                  });
                }),
                  (e = null);
              })
              .promise();
          },
          then: function(t, r, i) {
            var o = 0;
            function a(t, n, r, i) {
              return function() {
                var s = this,
                  u = arguments,
                  l = function() {
                    var e, l;
                    if (!(t < o)) {
                      if ((e = r.apply(s, u)) === n.promise())
                        throw new TypeError("Thenable self-resolution");
                      (l =
                        e &&
                        ("object" == typeof e || "function" == typeof e) &&
                        e.then),
                        g(l)
                          ? i
                            ? l.call(e, a(o, n, I, i), a(o, n, W, i))
                            : (o++,
                              l.call(
                                e,
                                a(o, n, I, i),
                                a(o, n, W, i),
                                a(o, n, I, n.notifyWith)
                              ))
                          : (r !== I && ((s = void 0), (u = [e])),
                            (i || n.resolveWith)(s, u));
                    }
                  },
                  c = i
                    ? l
                    : function() {
                        try {
                          l();
                        } catch (e) {
                          w.Deferred.exceptionHook &&
                            w.Deferred.exceptionHook(e, c.stackTrace),
                            t + 1 >= o &&
                              (r !== W && ((s = void 0), (u = [e])),
                              n.rejectWith(s, u));
                        }
                      };
                t
                  ? c()
                  : (w.Deferred.getStackHook &&
                      (c.stackTrace = w.Deferred.getStackHook()),
                    e.setTimeout(c));
              };
            }
            return w
              .Deferred(function(e) {
                n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)),
                  n[1][3].add(a(0, e, g(t) ? t : I)),
                  n[2][3].add(a(0, e, g(r) ? r : W));
              })
              .promise();
          },
          promise: function(e) {
            return null != e ? w.extend(e, i) : i;
          }
        },
        o = {};
      return (
        w.each(n, function(e, t) {
          var a = t[2],
            s = t[5];
          (i[t[1]] = a.add),
            s &&
              a.add(
                function() {
                  r = s;
                },
                n[3 - e][2].disable,
                n[3 - e][3].disable,
                n[0][2].lock,
                n[0][3].lock
              ),
            a.add(t[3].fire),
            (o[t[0]] = function() {
              return (
                o[t[0] + "With"](this === o ? void 0 : this, arguments), this
              );
            }),
            (o[t[0] + "With"] = a.fireWith);
        }),
        i.promise(o),
        t && t.call(o, o),
        o
      );
    },
    when: function(e) {
      var t = arguments.length,
        n = t,
        r = Array(n),
        i = o.call(arguments),
        a = w.Deferred(),
        s = function(e) {
          return function(n) {
            (r[e] = this),
              (i[e] = arguments.length > 1 ? o.call(arguments) : n),
              --t || a.resolveWith(r, i);
          };
        };
      if (
        t <= 1 &&
        ($(e, a.done(s(n)).resolve, a.reject, !t),
        "pending" === a.state() || g(i[n] && i[n].then))
      )
        return a.then();
      while (n--) $(i[n], s(n), a.reject);
      return a.promise();
    }
  });
  var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (w.Deferred.exceptionHook = function(t, n) {
    e.console &&
      e.console.warn &&
      t &&
      B.test(t.name) &&
      e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
  }),
    (w.readyException = function(t) {
      e.setTimeout(function() {
        throw t;
      });
    });
  var F = w.Deferred();
  (w.fn.ready = function(e) {
    return (
      F.then(e)["catch"](function(e) {
        w.readyException(e);
      }),
      this
    );
  }),
    w.extend({
      isReady: !1,
      readyWait: 1,
      ready: function(e) {
        (!0 === e ? --w.readyWait : w.isReady) ||
          ((w.isReady = !0),
          (!0 !== e && --w.readyWait > 0) || F.resolveWith(r, [w]));
      }
    }),
    (w.ready.then = F.then);
  function _() {
    r.removeEventListener("DOMContentLoaded", _),
      e.removeEventListener("load", _),
      w.ready();
  }
  "complete" === r.readyState ||
  ("loading" !== r.readyState && !r.documentElement.doScroll)
    ? e.setTimeout(w.ready)
    : (r.addEventListener("DOMContentLoaded", _),
      e.addEventListener("load", _));
  var z = function(e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ("object" === x(n)) {
        i = !0;
        for (s in n) z(e, t, s, n[s], !0, o, a);
      } else if (
        void 0 !== r &&
        ((i = !0),
        g(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function(e, t, n) {
                return l.call(w(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    X = /^-ms-/,
    U = /-([a-z])/g;
  function V(e, t) {
    return t.toUpperCase();
  }
  function G(e) {
    return e.replace(X, "ms-").replace(U, V);
  }
  var Y = function(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function Q() {
    this.expando = w.expando + Q.uid++;
  }
  (Q.uid = 1),
    (Q.prototype = {
      cache: function(e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0
                  }))),
          t
        );
      },
      set: function(e, t, n) {
        var r,
          i = this.cache(e);
        if ("string" == typeof t) i[G(t)] = n;
        else for (r in t) i[G(r)] = t[r];
        return i;
      },
      get: function(e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][G(t)];
      },
      access: function(e, t, n) {
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function(e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(G)
              : (t = G(t)) in r
              ? [t]
              : t.match(M) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || w.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function(e) {
        var t = e[this.expando];
        return void 0 !== t && !w.isEmptyObject(t);
      }
    });
  var J = new Q(),
    K = new Q(),
    Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    ee = /[A-Z]/g;
  function te(e) {
    return (
      "true" === e ||
      ("false" !== e &&
        ("null" === e
          ? null
          : e === +e + ""
          ? +e
          : Z.test(e)
          ? JSON.parse(e)
          : e))
    );
  }
  function ne(e, t, n) {
    var r;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = "data-" + t.replace(ee, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n = te(n);
        } catch (e) {}
        K.set(e, t, n);
      } else n = void 0;
    return n;
  }
  w.extend({
    hasData: function(e) {
      return K.hasData(e) || J.hasData(e);
    },
    data: function(e, t, n) {
      return K.access(e, t, n);
    },
    removeData: function(e, t) {
      K.remove(e, t);
    },
    _data: function(e, t, n) {
      return J.access(e, t, n);
    },
    _removeData: function(e, t) {
      J.remove(e, t);
    }
  }),
    w.fn.extend({
      data: function(e, t) {
        var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === e) {
          if (
            this.length &&
            ((i = K.get(o)), 1 === o.nodeType && !J.get(o, "hasDataAttrs"))
          ) {
            n = a.length;
            while (n--)
              a[n] &&
                0 === (r = a[n].name).indexOf("data-") &&
                ((r = G(r.slice(5))), ne(o, r, i[r]));
            J.set(o, "hasDataAttrs", !0);
          }
          return i;
        }
        return "object" == typeof e
          ? this.each(function() {
              K.set(this, e);
            })
          : z(
              this,
              function(t) {
                var n;
                if (o && void 0 === t) {
                  if (void 0 !== (n = K.get(o, e))) return n;
                  if (void 0 !== (n = ne(o, e))) return n;
                } else
                  this.each(function() {
                    K.set(this, e, t);
                  });
              },
              null,
              t,
              arguments.length > 1,
              null,
              !0
            );
      },
      removeData: function(e) {
        return this.each(function() {
          K.remove(this, e);
        });
      }
    }),
    w.extend({
      queue: function(e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (r = J.get(e, t)),
            n &&
              (!r || Array.isArray(n)
                ? (r = J.access(e, t, w.makeArray(n)))
                : r.push(n)),
            r || []
          );
      },
      dequeue: function(e, t) {
        t = t || "fx";
        var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function() {
            w.dequeue(e, t);
          };
        "inprogress" === i && ((i = n.shift()), r--),
          i &&
            ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(e, a, o)),
          !r && o && o.empty.fire();
      },
      _queueHooks: function(e, t) {
        var n = t + "queueHooks";
        return (
          J.get(e, n) ||
          J.access(e, n, {
            empty: w.Callbacks("once memory").add(function() {
              J.remove(e, [t + "queue", n]);
            })
          })
        );
      }
    }),
    w.fn.extend({
      queue: function(e, t) {
        var n = 2;
        return (
          "string" != typeof e && ((t = e), (e = "fx"), n--),
          arguments.length < n
            ? w.queue(this[0], e)
            : void 0 === t
            ? this
            : this.each(function() {
                var n = w.queue(this, e, t);
                w._queueHooks(this, e),
                  "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e);
              })
        );
      },
      dequeue: function(e) {
        return this.each(function() {
          w.dequeue(this, e);
        });
      },
      clearQueue: function(e) {
        return this.queue(e || "fx", []);
      },
      promise: function(e, t) {
        var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function() {
            --r || i.resolveWith(o, [o]);
          };
        "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
        while (a--)
          (n = J.get(o[a], e + "queueHooks")) &&
            n.empty &&
            (r++, n.empty.add(s));
        return s(), i.promise(t);
      }
    });
  var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
    oe = ["Top", "Right", "Bottom", "Left"],
    ae = function(e, t) {
      return (
        "none" === (e = t || e).style.display ||
        ("" === e.style.display &&
          w.contains(e.ownerDocument, e) &&
          "none" === w.css(e, "display"))
      );
    },
    se = function(e, t, n, r) {
      var i,
        o,
        a = {};
      for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o]);
      i = n.apply(e, r || []);
      for (o in t) e.style[o] = a[o];
      return i;
    };
  function ue(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function() {
            return r.cur();
          }
        : function() {
            return w.css(e, t, "");
          },
      u = s(),
      l = (n && n[3]) || (w.cssNumber[t] ? "" : "px"),
      c = (w.cssNumber[t] || ("px" !== l && +u)) && ie.exec(w.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        w.style(e, t, c + l),
          (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0),
          (c /= o);
      (c *= 2), w.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var le = {};
  function ce(e) {
    var t,
      n = e.ownerDocument,
      r = e.nodeName,
      i = le[r];
    return (
      i ||
      ((t = n.body.appendChild(n.createElement(r))),
      (i = w.css(t, "display")),
      t.parentNode.removeChild(t),
      "none" === i && (i = "block"),
      (le[r] = i),
      i)
    );
  }
  function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++)
      (r = e[o]).style &&
        ((n = r.style.display),
        t
          ? ("none" === n &&
              ((i[o] = J.get(r, "display") || null),
              i[o] || (r.style.display = "")),
            "" === r.style.display && ae(r) && (i[o] = ce(r)))
          : "none" !== n && ((i[o] = "none"), J.set(r, "display", n)));
    for (o = 0; o < a; o++) null != i[o] && (e[o].style.display = i[o]);
    return e;
  }
  w.fn.extend({
    show: function() {
      return fe(this, !0);
    },
    hide: function() {
      return fe(this);
    },
    toggle: function(e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function() {
            ae(this) ? w(this).show() : w(this).hide();
          });
    }
  });
  var pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i,
    ge = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
  (ge.optgroup = ge.option),
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td);
  function ye(e, t) {
    var n;
    return (
      (n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && N(e, t)) ? w.merge([e], n) : n
    );
  }
  function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"));
  }
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o,
        a,
        s,
        u,
        l,
        c,
        f = t.createDocumentFragment(),
        p = [],
        d = 0,
        h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ("object" === x(o)) w.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement("div"))),
            (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          w.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
        } else p.push(t.createTextNode(o));
    (f.textContent = ""), (d = 0);
    while ((o = p[d++]))
      if (r && w.inArray(o, r) > -1) i && i.push(o);
      else if (
        ((l = w.contains(o.ownerDocument, o)),
        (a = ye(f.appendChild(o), "script")),
        l && ve(a),
        n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || "") && n.push(o);
      }
    return f;
  }
  !(function() {
    var e = r.createDocumentFragment().appendChild(r.createElement("div")),
      t = r.createElement("input");
    t.setAttribute("type", "radio"),
      t.setAttribute("checked", "checked"),
      t.setAttribute("name", "t"),
      e.appendChild(t),
      (h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (e.innerHTML = "<textarea>x</textarea>"),
      (h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue);
  })();
  var be = r.documentElement,
    we = /^key/,
    Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    Ce = /^([^.]*)(?:\.(.+)|)/;
  function Ee() {
    return !0;
  }
  function ke() {
    return !1;
  }
  function Se() {
    try {
      return r.activeElement;
    } catch (e) {}
  }
  function De(e, t, n, r, i, o) {
    var a, s;
    if ("object" == typeof t) {
      "string" != typeof n && ((r = r || n), (n = void 0));
      for (s in t) De(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ("string" == typeof n
            ? ((i = r), (r = void 0))
            : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = ke;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function(e) {
          return w().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = w.guid++))),
      e.each(function() {
        w.event.add(this, t, i, r, n);
      })
    );
  }
  (w.event = {
    global: {},
    add: function(e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.get(e);
      if (y) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && w.find.matchesSelector(be, i),
          n.guid || (n.guid = w.guid++),
          (u = y.events) || (u = y.events = {}),
          (a = y.handle) ||
            (a = y.handle = function(t) {
              return "undefined" != typeof w && w.event.triggered !== t.type
                ? w.event.dispatch.apply(e, arguments)
                : void 0;
            }),
          (l = (t = (t || "").match(M) || [""]).length);
        while (l--)
          (d = g = (s = Ce.exec(t[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d &&
              ((f = w.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = w.event.special[d] || {}),
              (c = w.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && w.expr.match.needsContext.test(i),
                  namespace: h.join(".")
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(e, r, h, a)) ||
                  (e.addEventListener && e.addEventListener(d, a))),
              f.add &&
                (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (w.event.global[d] = !0));
      }
    },
    remove: function(e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y = J.hasData(e) && J.get(e);
      if (y && (u = y.events)) {
        l = (t = (t || "").match(M) || [""]).length;
        while (l--)
          if (
            ((s = Ce.exec(t[l]) || []),
            (d = g = s[1]),
            (h = (s[2] || "").split(".").sort()),
            d)
          ) {
            (f = w.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s =
                s[2] &&
                new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, y.handle)) ||
                w.removeEvent(e, d, y.handle),
              delete u[d]);
          } else for (d in u) w.event.remove(e, d + t[l], n, r, !0);
        w.isEmptyObject(u) && J.remove(e, "handle events");
      }
    },
    dispatch: function(e) {
      var t = w.event.fix(e),
        n,
        r,
        i,
        o,
        a,
        s,
        u = new Array(arguments.length),
        l = (J.get(this, "events") || {})[t.type] || [],
        c = w.event.special[t.type] || {};
      for (u[0] = t, n = 1; n < arguments.length; n++) u[n] = arguments[n];
      if (
        ((t.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, t))
      ) {
        (s = w.event.handlers.call(this, t, l)), (n = 0);
        while ((o = s[n++]) && !t.isPropagationStopped()) {
          (t.currentTarget = o.elem), (r = 0);
          while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped())
            (t.rnamespace && !t.rnamespace.test(a.namespace)) ||
              ((t.handleObj = a),
              (t.data = a.data),
              void 0 !==
                (i = (
                  (w.event.special[a.origType] || {}).handle || a.handler
                ).apply(o.elem, u)) &&
                !1 === (t.result = i) &&
                (t.preventDefault(), t.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    },
    handlers: function(e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !("click" === e.type && e.button >= 1))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + " ")] &&
                (a[i] = r.needsContext
                  ? w(i, this).index(l) > -1
                  : w.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({ elem: l, handlers: o });
          }
      return (
        (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s
      );
    },
    addProp: function(e, t) {
      Object.defineProperty(w.Event.prototype, e, {
        enumerable: !0,
        configurable: !0,
        get: g(t)
          ? function() {
              if (this.originalEvent) return t(this.originalEvent);
            }
          : function() {
              if (this.originalEvent) return this.originalEvent[e];
            },
        set: function(t) {
          Object.defineProperty(this, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
          });
        }
      });
    },
    fix: function(e) {
      return e[w.expando] ? e : new w.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function() {
          if (this !== Se() && this.focus) return this.focus(), !1;
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function() {
          if (this === Se() && this.blur) return this.blur(), !1;
        },
        delegateType: "focusout"
      },
      click: {
        trigger: function() {
          if ("checkbox" === this.type && this.click && N(this, "input"))
            return this.click(), !1;
        },
        _default: function(e) {
          return N(e.target, "a");
        }
      },
      beforeunload: {
        postDispatch: function(e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        }
      }
    }
  }),
    (w.removeEvent = function(e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (w.Event = function(e, t) {
      if (!(this instanceof w.Event)) return new w.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? Ee
              : ke),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && w.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[w.expando] = !0);
    }),
    (w.Event.prototype = {
      constructor: w.Event,
      isDefaultPrevented: ke,
      isPropagationStopped: ke,
      isImmediatePropagationStopped: ke,
      isSimulated: !1,
      preventDefault: function() {
        var e = this.originalEvent;
        (this.isDefaultPrevented = Ee),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function() {
        var e = this.originalEvent;
        (this.isPropagationStopped = Ee),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = Ee),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      }
    }),
    w.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
          var t = e.button;
          return null == e.which && we.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && Te.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        }
      },
      w.event.addProp
    ),
    w.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      },
      function(e, t) {
        w.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function(e) {
            var n,
              r = this,
              i = e.relatedTarget,
              o = e.handleObj;
            return (
              (i && (i === r || w.contains(r, i))) ||
                ((e.type = o.origType),
                (n = o.handler.apply(this, arguments)),
                (e.type = t)),
              n
            );
          }
        };
      }
    ),
    w.fn.extend({
      on: function(e, t, n, r) {
        return De(this, e, t, n, r);
      },
      one: function(e, t, n, r) {
        return De(this, e, t, n, r, 1);
      },
      off: function(e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            w(e.delegateTarget).off(
              r.namespace ? r.origType + "." + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = ke),
          this.each(function() {
            w.event.remove(this, e, n, t);
          })
        );
      }
    });
  var Ne = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
    Ae = /<script|<style|<link/i,
    je = /checked\s*(?:[^=]|=\s*.checked.)/i,
    qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function Le(e, t) {
    return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr")
      ? w(e).children("tbody")[0] || e
      : e;
  }
  function He(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function Oe(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function Pe(e, t) {
    var n, r, i, o, a, s, u, l;
    if (1 === t.nodeType) {
      if (
        J.hasData(e) &&
        ((o = J.access(e)), (a = J.set(t, o)), (l = o.events))
      ) {
        delete a.handle, (a.events = {});
        for (i in l)
          for (n = 0, r = l[i].length; n < r; n++) w.event.add(t, i, l[i][n]);
      }
      K.hasData(e) && ((s = K.access(e)), (u = w.extend({}, s)), K.set(t, u));
    }
  }
  function Me(e, t) {
    var n = t.nodeName.toLowerCase();
    "input" === n && pe.test(e.type)
      ? (t.checked = e.checked)
      : ("input" !== n && "textarea" !== n) ||
        (t.defaultValue = e.defaultValue);
  }
  function Re(e, t, n, r) {
    t = a.apply([], t);
    var i,
      o,
      s,
      u,
      l,
      c,
      f = 0,
      p = e.length,
      d = p - 1,
      y = t[0],
      v = g(y);
    if (v || (p > 1 && "string" == typeof y && !h.checkClone && je.test(y)))
      return e.each(function(i) {
        var o = e.eq(i);
        v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r);
      });
    if (
      p &&
      ((i = xe(t, e[0].ownerDocument, !1, e, r)),
      (o = i.firstChild),
      1 === i.childNodes.length && (i = o),
      o || r)
    ) {
      for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++)
        (l = i),
          f !== d &&
            ((l = w.clone(l, !0, !0)), u && w.merge(s, ye(l, "script"))),
          n.call(e[f], l, f);
      if (u)
        for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++)
          (l = s[f]),
            he.test(l.type || "") &&
              !J.access(l, "globalEval") &&
              w.contains(c, l) &&
              (l.src && "module" !== (l.type || "").toLowerCase()
                ? w._evalUrl && w._evalUrl(l.src)
                : m(l.textContent.replace(qe, ""), c, l));
    }
    return e;
  }
  function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || w.cleanData(ye(r)),
        r.parentNode &&
          (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")),
          r.parentNode.removeChild(r));
    return e;
  }
  w.extend({
    htmlPrefilter: function(e) {
      return e.replace(Ne, "<$1></$2>");
    },
    clone: function(e, t, n) {
      var r,
        i,
        o,
        a,
        s = e.cloneNode(!0),
        u = w.contains(e.ownerDocument, e);
      if (
        !(
          h.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          w.isXMLDoc(e)
        )
      )
        for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++)
          Me(o[r], a[r]);
      if (t)
        if (n)
          for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++)
            Pe(o[r], a[r]);
        else Pe(e, s);
      return (
        (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")), s
      );
    },
    cleanData: function(e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (Y(n)) {
          if ((t = n[J.expando])) {
            if (t.events)
              for (r in t.events)
                i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            n[J.expando] = void 0;
          }
          n[K.expando] && (n[K.expando] = void 0);
        }
    }
  }),
    w.fn.extend({
      detach: function(e) {
        return Ie(this, e, !0);
      },
      remove: function(e) {
        return Ie(this, e);
      },
      text: function(e) {
        return z(
          this,
          function(e) {
            return void 0 === e
              ? w.text(this)
              : this.empty().each(function() {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function() {
        return Re(this, arguments, function(e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            Le(this, e).appendChild(e);
        });
      },
      prepend: function() {
        return Re(this, arguments, function(e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = Le(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function() {
        return Re(this, arguments, function(e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function() {
        return Re(this, arguments, function(e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function() {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (w.cleanData(ye(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function(e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function() {
            return w.clone(this, e, t);
          })
        );
      },
      html: function(e) {
        return z(
          this,
          function(e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !Ae.test(e) &&
              !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = w.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (w.cleanData(ye(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function() {
        var e = [];
        return Re(
          this,
          arguments,
          function(t) {
            var n = this.parentNode;
            w.inArray(this, e) < 0 &&
              (w.cleanData(ye(this)), n && n.replaceChild(t, this));
          },
          e
        );
      }
    }),
    w.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      },
      function(e, t) {
        w.fn[e] = function(e) {
          for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)
            (n = a === o ? this : this.clone(!0)),
              w(i[a])[t](n),
              s.apply(r, n.get());
          return this.pushStack(r);
        };
      }
    );
  var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
    $e = function(t) {
      var n = t.ownerDocument.defaultView;
      return (n && n.opener) || (n = e), n.getComputedStyle(t);
    },
    Be = new RegExp(oe.join("|"), "i");
  !(function() {
    function t() {
      if (c) {
        (l.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (c.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          be.appendChild(l).appendChild(c);
        var t = e.getComputedStyle(c);
        (i = "1%" !== t.top),
          (u = 12 === n(t.marginLeft)),
          (c.style.right = "60%"),
          (s = 36 === n(t.right)),
          (o = 36 === n(t.width)),
          (c.style.position = "absolute"),
          (a = 36 === c.offsetWidth || "absolute"),
          be.removeChild(l),
          (c = null);
      }
    }
    function n(e) {
      return Math.round(parseFloat(e));
    }
    var i,
      o,
      a,
      s,
      u,
      l = r.createElement("div"),
      c = r.createElement("div");
    c.style &&
      ((c.style.backgroundClip = "content-box"),
      (c.cloneNode(!0).style.backgroundClip = ""),
      (h.clearCloneStyle = "content-box" === c.style.backgroundClip),
      w.extend(h, {
        boxSizingReliable: function() {
          return t(), o;
        },
        pixelBoxStyles: function() {
          return t(), s;
        },
        pixelPosition: function() {
          return t(), i;
        },
        reliableMarginLeft: function() {
          return t(), u;
        },
        scrollboxSize: function() {
          return t(), a;
        }
      }));
  })();
  function Fe(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || $e(e)) &&
        ("" !== (a = n.getPropertyValue(t) || n[t]) ||
          w.contains(e.ownerDocument, e) ||
          (a = w.style(e, t)),
        !h.pixelBoxStyles() &&
          We.test(a) &&
          Be.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + "" : a
    );
  }
  function _e(e, t) {
    return {
      get: function() {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      }
    };
  }
  var ze = /^(none|table(?!-c[ea]).+)/,
    Xe = /^--/,
    Ue = { position: "absolute", visibility: "hidden", display: "block" },
    Ve = { letterSpacing: "0", fontWeight: "400" },
    Ge = ["Webkit", "Moz", "ms"],
    Ye = r.createElement("div").style;
  function Qe(e) {
    if (e in Ye) return e;
    var t = e[0].toUpperCase() + e.slice(1),
      n = Ge.length;
    while (n--) if ((e = Ge[n] + t) in Ye) return e;
  }
  function Je(e) {
    var t = w.cssProps[e];
    return t || (t = w.cssProps[e] = Qe(e) || e), t;
  }
  function Ke(e, t, n) {
    var r = ie.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }
  function Ze(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? "border" : "content")) return 0;
    for (; a < 4; a += 2)
      "margin" === n && (u += w.css(e, n + oe[a], !0, i)),
        r
          ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)),
            "margin" !== n &&
              (u -= w.css(e, "border" + oe[a] + "Width", !0, i)))
          : ((u += w.css(e, "padding" + oe[a], !0, i)),
            "padding" !== n
              ? (u += w.css(e, "border" + oe[a] + "Width", !0, i))
              : (s += w.css(e, "border" + oe[a] + "Width", !0, i)));
    return (
      !r &&
        o >= 0 &&
        (u += Math.max(
          0,
          Math.ceil(
            e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5
          )
        )),
      u
    );
  }
  function et(e, t, n) {
    var r = $e(e),
      i = Fe(e, t, r),
      o = "border-box" === w.css(e, "boxSizing", !1, r),
      a = o;
    if (We.test(i)) {
      if (!n) return i;
      i = "auto";
    }
    return (
      (a = a && (h.boxSizingReliable() || i === e.style[t])),
      ("auto" === i ||
        (!parseFloat(i) && "inline" === w.css(e, "display", !1, r))) &&
        ((i = e["offset" + t[0].toUpperCase() + t.slice(1)]), (a = !0)),
      (i = parseFloat(i) || 0) +
        Ze(e, t, n || (o ? "border" : "content"), a, r, i) +
        "px"
    );
  }
  w.extend({
    cssHooks: {
      opacity: {
        get: function(e, t) {
          if (t) {
            var n = Fe(e, "opacity");
            return "" === n ? "1" : n;
          }
        }
      }
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0
    },
    cssProps: {},
    style: function(e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = G(t),
          u = Xe.test(t),
          l = e.style;
        if (
          (u || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]), void 0 === n)
        )
          return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        "string" == (o = typeof n) &&
          (i = ie.exec(n)) &&
          i[1] &&
          ((n = ue(e, t, i)), (o = "number")),
          null != n &&
            n === n &&
            ("number" === o &&
              (n += (i && i[3]) || (w.cssNumber[s] ? "" : "px")),
            h.clearCloneStyle ||
              "" !== n ||
              0 !== t.indexOf("background") ||
              (l[t] = "inherit"),
            (a && "set" in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function(e, t, n, r) {
      var i,
        o,
        a,
        s = G(t);
      return (
        Xe.test(t) || (t = Je(s)),
        (a = w.cssHooks[t] || w.cssHooks[s]) &&
          "get" in a &&
          (i = a.get(e, !0, n)),
        void 0 === i && (i = Fe(e, t, r)),
        "normal" === i && t in Ve && (i = Ve[t]),
        "" === n || n
          ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
          : i
      );
    }
  }),
    w.each(["height", "width"], function(e, t) {
      w.cssHooks[t] = {
        get: function(e, n, r) {
          if (n)
            return !ze.test(w.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? et(e, t, r)
              : se(e, Ue, function() {
                  return et(e, t, r);
                });
        },
        set: function(e, n, r) {
          var i,
            o = $e(e),
            a = "border-box" === w.css(e, "boxSizing", !1, o),
            s = r && Ze(e, t, r, a, o);
          return (
            a &&
              h.scrollboxSize() === o.position &&
              (s -= Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] -
                  parseFloat(o[t]) -
                  Ze(e, t, "border", !1, o) -
                  0.5
              )),
            s &&
              (i = ie.exec(n)) &&
              "px" !== (i[3] || "px") &&
              ((e.style[t] = n), (n = w.css(e, t))),
            Ke(e, n, s)
          );
        }
      };
    }),
    (w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function(e, t) {
      if (t)
        return (
          (parseFloat(Fe(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              se(e, { marginLeft: 0 }, function() {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    w.each({ margin: "", padding: "", border: "Width" }, function(e, t) {
      (w.cssHooks[e + t] = {
        expand: function(n) {
          for (
            var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n];
            r < 4;
            r++
          )
            i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
          return i;
        }
      }),
        "margin" !== e && (w.cssHooks[e + t].set = Ke);
    }),
    w.fn.extend({
      css: function(e, t) {
        return z(
          this,
          function(e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = $e(e), i = t.length; a < i; a++)
                o[t[a]] = w.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
          },
          e,
          t,
          arguments.length > 1
        );
      }
    });
  function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i);
  }
  (w.Tween = tt),
    (tt.prototype = {
      constructor: tt,
      init: function(e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || w.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (w.cssNumber[n] ? "" : "px"));
      },
      cur: function() {
        var e = tt.propHooks[this.prop];
        return e && e.get ? e.get(this) : tt.propHooks._default.get(this);
      },
      run: function(e) {
        var t,
          n = tt.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t = w.easing[this.easing](
                e,
                this.options.duration * e,
                0,
                1,
                this.options.duration
              ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : tt.propHooks._default.set(this),
          this
        );
      }
    }),
    (tt.prototype.init.prototype = tt.prototype),
    (tt.propHooks = {
      _default: {
        get: function(e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = w.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function(e) {
          w.fx.step[e.prop]
            ? w.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : w.style(e.elem, e.prop, e.now + e.unit);
        }
      }
    }),
    (tt.propHooks.scrollTop = tt.propHooks.scrollLeft = {
      set: function(e) {
        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
      }
    }),
    (w.easing = {
      linear: function(e) {
        return e;
      },
      swing: function(e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing"
    }),
    (w.fx = tt.prototype.init),
    (w.fx.step = {});
  var nt,
    rt,
    it = /^(?:toggle|show|hide)$/,
    ot = /queueHooks$/;
  function at() {
    rt &&
      (!1 === r.hidden && e.requestAnimationFrame
        ? e.requestAnimationFrame(at)
        : e.setTimeout(at, w.fx.interval),
      w.fx.tick());
  }
  function st() {
    return (
      e.setTimeout(function() {
        nt = void 0;
      }),
      (nt = Date.now())
    );
  }
  function ut(e, t) {
    var n,
      r = 0,
      i = { height: e };
    for (t = t ? 1 : 0; r < 4; r += 2 - t)
      i["margin" + (n = oe[r])] = i["padding" + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function lt(e, t, n) {
    for (
      var r,
        i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]),
        o = 0,
        a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function ct(e, t, n) {
    var r,
      i,
      o,
      a,
      s,
      u,
      l,
      c,
      f = "width" in t || "height" in t,
      p = this,
      d = {},
      h = e.style,
      g = e.nodeType && ae(e),
      y = J.get(e, "fxshow");
    n.queue ||
      (null == (a = w._queueHooks(e, "fx")).unqueued &&
        ((a.unqueued = 0),
        (s = a.empty.fire),
        (a.empty.fire = function() {
          a.unqueued || s();
        })),
      a.unqueued++,
      p.always(function() {
        p.always(function() {
          a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
        });
      }));
    for (r in t)
      if (((i = t[r]), it.test(i))) {
        if (
          (delete t[r], (o = o || "toggle" === i), i === (g ? "hide" : "show"))
        ) {
          if ("show" !== i || !y || void 0 === y[r]) continue;
          g = !0;
        }
        d[r] = (y && y[r]) || w.style(e, r);
      }
    if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f &&
        1 === e.nodeType &&
        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
        null == (l = y && y.display) && (l = J.get(e, "display")),
        "none" === (c = w.css(e, "display")) &&
          (l
            ? (c = l)
            : (fe([e], !0),
              (l = e.style.display || l),
              (c = w.css(e, "display")),
              fe([e]))),
        ("inline" === c || ("inline-block" === c && null != l)) &&
          "none" === w.css(e, "float") &&
          (u ||
            (p.done(function() {
              h.display = l;
            }),
            null == l && ((c = h.display), (l = "none" === c ? "" : c))),
          (h.display = "inline-block"))),
        n.overflow &&
          ((h.overflow = "hidden"),
          p.always(function() {
            (h.overflow = n.overflow[0]),
              (h.overflowX = n.overflow[1]),
              (h.overflowY = n.overflow[2]);
          })),
        (u = !1);
      for (r in d)
        u ||
          (y
            ? "hidden" in y && (g = y.hidden)
            : (y = J.access(e, "fxshow", { display: l })),
          o && (y.hidden = !g),
          g && fe([e], !0),
          p.done(function() {
            g || fe([e]), J.remove(e, "fxshow");
            for (r in d) w.style(e, r, d[r]);
          })),
          (u = lt(g ? y[r] : 0, r, p)),
          r in y || ((y[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
    }
  }
  function ft(e, t) {
    var n, r, i, o, a;
    for (n in e)
      if (
        ((r = G(n)),
        (i = t[r]),
        (o = e[n]),
        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
        n !== r && ((e[r] = o), delete e[n]),
        (a = w.cssHooks[r]) && "expand" in a)
      ) {
        (o = a.expand(o)), delete e[r];
        for (n in o) n in e || ((e[n] = o[n]), (t[n] = i));
      } else t[r] = i;
  }
  function pt(e, t, n) {
    var r,
      i,
      o = 0,
      a = pt.prefilters.length,
      s = w.Deferred().always(function() {
        delete u.elem;
      }),
      u = function() {
        if (i) return !1;
        for (
          var t = nt || st(),
            n = Math.max(0, l.startTime + l.duration - t),
            r = 1 - (n / l.duration || 0),
            o = 0,
            a = l.tweens.length;
          o < a;
          o++
        )
          l.tweens[o].run(r);
        return (
          s.notifyWith(e, [l, r, n]),
          r < 1 && a
            ? n
            : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
        );
      },
      l = s.promise({
        elem: e,
        props: w.extend({}, t),
        opts: w.extend(!0, { specialEasing: {}, easing: w.easing._default }, n),
        originalProperties: t,
        originalOptions: n,
        startTime: nt || st(),
        duration: n.duration,
        tweens: [],
        createTween: function(t, n) {
          var r = w.Tween(
            e,
            l.opts,
            t,
            n,
            l.opts.specialEasing[t] || l.opts.easing
          );
          return l.tweens.push(r), r;
        },
        stop: function(t) {
          var n = 0,
            r = t ? l.tweens.length : 0;
          if (i) return this;
          for (i = !0; n < r; n++) l.tweens[n].run(1);
          return (
            t
              ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t]))
              : s.rejectWith(e, [l, t]),
            this
          );
        }
      }),
      c = l.props;
    for (ft(c, l.opts.specialEasing); o < a; o++)
      if ((r = pt.prefilters[o].call(l, e, c, l.opts)))
        return (
          g(r.stop) &&
            (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)),
          r
        );
    return (
      w.map(c, lt, l),
      g(l.opts.start) && l.opts.start.call(e, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      w.fx.timer(w.extend(u, { elem: e, anim: l, queue: l.opts.queue })),
      l
    );
  }
  (w.Animation = w.extend(pt, {
    tweeners: {
      "*": [
        function(e, t) {
          var n = this.createTween(e, t);
          return ue(n.elem, e, ie.exec(t), n), n;
        }
      ]
    },
    tweener: function(e, t) {
      g(e) ? ((t = e), (e = ["*"])) : (e = e.match(M));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]),
          (pt.tweeners[n] = pt.tweeners[n] || []),
          pt.tweeners[n].unshift(t);
    },
    prefilters: [ct],
    prefilter: function(e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
    }
  })),
    (w.speed = function(e, t, n) {
      var r =
        e && "object" == typeof e
          ? w.extend({}, e)
          : {
              complete: n || (!n && t) || (g(e) && e),
              duration: e,
              easing: (n && t) || (t && !g(t) && t)
            };
      return (
        w.fx.off
          ? (r.duration = 0)
          : "number" != typeof r.duration &&
            (r.duration in w.fx.speeds
              ? (r.duration = w.fx.speeds[r.duration])
              : (r.duration = w.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
        (r.old = r.complete),
        (r.complete = function() {
          g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
        }),
        r
      );
    }),
    w.fn.extend({
      fadeTo: function(e, t, n, r) {
        return this.filter(ae)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, r);
      },
      animate: function(e, t, n, r) {
        var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function() {
            var t = pt(this, w.extend({}, e), o);
            (i || J.get(this, "finish")) && t.stop(!0);
          };
        return (
          (a.finish = a),
          i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        );
      },
      stop: function(e, t, n) {
        var r = function(e) {
          var t = e.stop;
          delete e.stop, t(n);
        };
        return (
          "string" != typeof e && ((n = t), (t = e), (e = void 0)),
          t && !1 !== e && this.queue(e || "fx", []),
          this.each(function() {
            var t = !0,
              i = null != e && e + "queueHooks",
              o = w.timers,
              a = J.get(this);
            if (i) a[i] && a[i].stop && r(a[i]);
            else for (i in a) a[i] && a[i].stop && ot.test(i) && r(a[i]);
            for (i = o.length; i--; )
              o[i].elem !== this ||
                (null != e && o[i].queue !== e) ||
                (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
            (!t && n) || w.dequeue(this, e);
          })
        );
      },
      finish: function(e) {
        return (
          !1 !== e && (e = e || "fx"),
          this.each(function() {
            var t,
              n = J.get(this),
              r = n[e + "queue"],
              i = n[e + "queueHooks"],
              o = w.timers,
              a = r ? r.length : 0;
            for (
              n.finish = !0,
                w.queue(this, e, []),
                i && i.stop && i.stop.call(this, !0),
                t = o.length;
              t--;

            )
              o[t].elem === this &&
                o[t].queue === e &&
                (o[t].anim.stop(!0), o.splice(t, 1));
            for (t = 0; t < a; t++)
              r[t] && r[t].finish && r[t].finish.call(this);
            delete n.finish;
          })
        );
      }
    }),
    w.each(["toggle", "show", "hide"], function(e, t) {
      var n = w.fn[t];
      w.fn[t] = function(e, r, i) {
        return null == e || "boolean" == typeof e
          ? n.apply(this, arguments)
          : this.animate(ut(t, !0), e, r, i);
      };
    }),
    w.each(
      {
        slideDown: ut("show"),
        slideUp: ut("hide"),
        slideToggle: ut("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" }
      },
      function(e, t) {
        w.fn[e] = function(e, n, r) {
          return this.animate(t, e, n, r);
        };
      }
    ),
    (w.timers = []),
    (w.fx.tick = function() {
      var e,
        t = 0,
        n = w.timers;
      for (nt = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || w.fx.stop(), (nt = void 0);
    }),
    (w.fx.timer = function(e) {
      w.timers.push(e), w.fx.start();
    }),
    (w.fx.interval = 13),
    (w.fx.start = function() {
      rt || ((rt = !0), at());
    }),
    (w.fx.stop = function() {
      rt = null;
    }),
    (w.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (w.fn.delay = function(t, n) {
      return (
        (t = w.fx ? w.fx.speeds[t] || t : t),
        (n = n || "fx"),
        this.queue(n, function(n, r) {
          var i = e.setTimeout(n, t);
          r.stop = function() {
            e.clearTimeout(i);
          };
        })
      );
    }),
    (function() {
      var e = r.createElement("input"),
        t = r.createElement("select").appendChild(r.createElement("option"));
      (e.type = "checkbox"),
        (h.checkOn = "" !== e.value),
        (h.optSelected = t.selected),
        ((e = r.createElement("input")).value = "t"),
        (e.type = "radio"),
        (h.radioValue = "t" === e.value);
    })();
  var dt,
    ht = w.expr.attrHandle;
  w.fn.extend({
    attr: function(e, t) {
      return z(this, w.attr, e, t, arguments.length > 1);
    },
    removeAttr: function(e) {
      return this.each(function() {
        w.removeAttr(this, e);
      });
    }
  }),
    w.extend({
      attr: function(e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return "undefined" == typeof e.getAttribute
            ? w.prop(e, t, n)
            : ((1 === o && w.isXMLDoc(e)) ||
                (i =
                  w.attrHooks[t.toLowerCase()] ||
                  (w.expr.match.bool.test(t) ? dt : void 0)),
              void 0 !== n
                ? null === n
                  ? void w.removeAttr(e, t)
                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ""), n)
                : i && "get" in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = w.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function(e, t) {
            if (!h.radioValue && "radio" === t && N(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          }
        }
      },
      removeAttr: function(e, t) {
        var n,
          r = 0,
          i = t && t.match(M);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      }
    }),
    (dt = {
      set: function(e, t, n) {
        return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
      }
    }),
    w.each(w.expr.match.bool.source.match(/\w+/g), function(e, t) {
      var n = ht[t] || w.find.attr;
      ht[t] = function(e, t, r) {
        var i,
          o,
          a = t.toLowerCase();
        return (
          r ||
            ((o = ht[a]),
            (ht[a] = i),
            (i = null != n(e, t, r) ? a : null),
            (ht[a] = o)),
          i
        );
      };
    });
  var gt = /^(?:input|select|textarea|button)$/i,
    yt = /^(?:a|area)$/i;
  w.fn.extend({
    prop: function(e, t) {
      return z(this, w.prop, e, t, arguments.length > 1);
    },
    removeProp: function(e) {
      return this.each(function() {
        delete this[w.propFix[e] || e];
      });
    }
  }),
    w.extend({
      prop: function(e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && w.isXMLDoc(e)) ||
              ((t = w.propFix[t] || t), (i = w.propHooks[t])),
            void 0 !== n
              ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && "get" in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function(e) {
            var t = w.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : gt.test(e.nodeName) || (yt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          }
        }
      },
      propFix: { for: "htmlFor", class: "className" }
    }),
    h.optSelected ||
      (w.propHooks.selected = {
        get: function(e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function(e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        }
      }),
    w.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
      ],
      function() {
        w.propFix[this.toLowerCase()] = this;
      }
    );
  function vt(e) {
    return (e.match(M) || []).join(" ");
  }
  function mt(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function xt(e) {
    return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : [];
  }
  w.fn.extend({
    addClass: function(e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function(t) {
          w(this).addClass(e.call(this, t, mt(this)));
        });
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
            a = 0;
            while ((o = t[a++])) r.indexOf(" " + o + " ") < 0 && (r += o + " ");
            i !== (s = vt(r)) && n.setAttribute("class", s);
          }
      return this;
    },
    removeClass: function(e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u = 0;
      if (g(e))
        return this.each(function(t) {
          w(this).removeClass(e.call(this, t, mt(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if ((t = xt(e)).length)
        while ((n = this[u++]))
          if (((i = mt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
            a = 0;
            while ((o = t[a++]))
              while (r.indexOf(" " + o + " ") > -1)
                r = r.replace(" " + o + " ", " ");
            i !== (s = vt(r)) && n.setAttribute("class", s);
          }
      return this;
    },
    toggleClass: function(e, t) {
      var n = typeof e,
        r = "string" === n || Array.isArray(e);
      return "boolean" == typeof t && r
        ? t
          ? this.addClass(e)
          : this.removeClass(e)
        : g(e)
        ? this.each(function(n) {
            w(this).toggleClass(e.call(this, n, mt(this), t), t);
          })
        : this.each(function() {
            var t, i, o, a;
            if (r) {
              (i = 0), (o = w(this)), (a = xt(e));
              while ((t = a[i++]))
                o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else (void 0 !== e && "boolean" !== n) || ((t = mt(this)) && J.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""));
          });
    },
    hasClass: function(e) {
      var t,
        n,
        r = 0;
      t = " " + e + " ";
      while ((n = this[r++]))
        if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1)
          return !0;
      return !1;
    }
  });
  var bt = /\r/g;
  w.fn.extend({
    val: function(e) {
      var t,
        n,
        r,
        i = this[0];
      {
        if (arguments.length)
          return (
            (r = g(e)),
            this.each(function(n) {
              var i;
              1 === this.nodeType &&
                (null == (i = r ? e.call(this, n, w(this).val()) : e)
                  ? (i = "")
                  : "number" == typeof i
                  ? (i += "")
                  : Array.isArray(i) &&
                    (i = w.map(i, function(e) {
                      return null == e ? "" : e + "";
                    })),
                ((t =
                  w.valHooks[this.type] ||
                  w.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t &&
                  void 0 !== t.set(this, i, "value")) ||
                  (this.value = i));
            })
          );
        if (i)
          return (t =
            w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) &&
            "get" in t &&
            void 0 !== (n = t.get(i, "value"))
            ? n
            : "string" == typeof (n = i.value)
            ? n.replace(bt, "")
            : null == n
            ? ""
            : n;
      }
    }
  }),
    w.extend({
      valHooks: {
        option: {
          get: function(e) {
            var t = w.find.attr(e, "value");
            return null != t ? t : vt(w.text(e));
          }
        },
        select: {
          get: function(e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))
              ) {
                if (((t = w(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function(e, t) {
            var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected =
                w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          }
        }
      }
    }),
    w.each(["radio", "checkbox"], function() {
      (w.valHooks[this] = {
        set: function(e, t) {
          if (Array.isArray(t))
            return (e.checked = w.inArray(w(e).val(), t) > -1);
        }
      }),
        h.checkOn ||
          (w.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (h.focusin = "onfocusin" in e);
  var wt = /^(?:focusinfocus|focusoutblur)$/,
    Tt = function(e) {
      e.stopPropagation();
    };
  w.extend(w.event, {
    trigger: function(t, n, i, o) {
      var a,
        s,
        u,
        l,
        c,
        p,
        d,
        h,
        v = [i || r],
        m = f.call(t, "type") ? t.type : t,
        x = f.call(t, "namespace") ? t.namespace.split(".") : [];
      if (
        ((s = h = u = i = i || r),
        3 !== i.nodeType &&
          8 !== i.nodeType &&
          !wt.test(m + w.event.triggered) &&
          (m.indexOf(".") > -1 && ((m = (x = m.split(".")).shift()), x.sort()),
          (c = m.indexOf(":") < 0 && "on" + m),
          (t = t[w.expando] ? t : new w.Event(m, "object" == typeof t && t)),
          (t.isTrigger = o ? 2 : 3),
          (t.namespace = x.join(".")),
          (t.rnamespace = t.namespace
            ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (t.result = void 0),
          t.target || (t.target = i),
          (n = null == n ? [t] : w.makeArray(n, [t])),
          (d = w.event.special[m] || {}),
          o || !d.trigger || !1 !== d.trigger.apply(i, n)))
      ) {
        if (!o && !d.noBubble && !y(i)) {
          for (
            l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode);
            s;
            s = s.parentNode
          )
            v.push(s), (u = s);
          u === (i.ownerDocument || r) &&
            v.push(u.defaultView || u.parentWindow || e);
        }
        a = 0;
        while ((s = v[a++]) && !t.isPropagationStopped())
          (h = s),
            (t.type = a > 1 ? l : d.bindType || m),
            (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) &&
              p.apply(s, n),
            (p = c && s[c]) &&
              p.apply &&
              Y(s) &&
              ((t.result = p.apply(s, n)),
              !1 === t.result && t.preventDefault());
        return (
          (t.type = m),
          o ||
            t.isDefaultPrevented() ||
            (d._default && !1 !== d._default.apply(v.pop(), n)) ||
            !Y(i) ||
            (c &&
              g(i[m]) &&
              !y(i) &&
              ((u = i[c]) && (i[c] = null),
              (w.event.triggered = m),
              t.isPropagationStopped() && h.addEventListener(m, Tt),
              i[m](),
              t.isPropagationStopped() && h.removeEventListener(m, Tt),
              (w.event.triggered = void 0),
              u && (i[c] = u))),
          t.result
        );
      }
    },
    simulate: function(e, t, n) {
      var r = w.extend(new w.Event(), n, { type: e, isSimulated: !0 });
      w.event.trigger(r, null, t);
    }
  }),
    w.fn.extend({
      trigger: function(e, t) {
        return this.each(function() {
          w.event.trigger(e, t, this);
        });
      },
      triggerHandler: function(e, t) {
        var n = this[0];
        if (n) return w.event.trigger(e, t, n, !0);
      }
    }),
    h.focusin ||
      w.each({ focus: "focusin", blur: "focusout" }, function(e, t) {
        var n = function(e) {
          w.event.simulate(t, e.target, w.event.fix(e));
        };
        w.event.special[t] = {
          setup: function() {
            var r = this.ownerDocument || this,
              i = J.access(r, t);
            i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1);
          },
          teardown: function() {
            var r = this.ownerDocument || this,
              i = J.access(r, t) - 1;
            i
              ? J.access(r, t, i)
              : (r.removeEventListener(e, n, !0), J.remove(r, t));
          }
        };
      });
  var Ct = e.location,
    Et = Date.now(),
    kt = /\?/;
  w.parseXML = function(t) {
    var n;
    if (!t || "string" != typeof t) return null;
    try {
      n = new e.DOMParser().parseFromString(t, "text/xml");
    } catch (e) {
      n = void 0;
    }
    return (
      (n && !n.getElementsByTagName("parsererror").length) ||
        w.error("Invalid XML: " + t),
      n
    );
  };
  var St = /\[\]$/,
    Dt = /\r?\n/g,
    Nt = /^(?:submit|button|image|reset|file)$/i,
    At = /^(?:input|select|textarea|keygen)/i;
  function jt(e, t, n, r) {
    var i;
    if (Array.isArray(t))
      w.each(t, function(t, i) {
        n || St.test(e)
          ? r(e, i)
          : jt(
              e + "[" + ("object" == typeof i && null != i ? t : "") + "]",
              i,
              n,
              r
            );
      });
    else if (n || "object" !== x(t)) r(e, t);
    else for (i in t) jt(e + "[" + i + "]", t[i], n, r);
  }
  (w.param = function(e, t) {
    var n,
      r = [],
      i = function(e, t) {
        var n = g(t) ? t() : t;
        r[r.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
      };
    if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
      w.each(e, function() {
        i(this.name, this.value);
      });
    else for (n in e) jt(n, e[n], t, i);
    return r.join("&");
  }),
    w.fn.extend({
      serialize: function() {
        return w.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var e = w.prop(this, "elements");
          return e ? w.makeArray(e) : this;
        })
          .filter(function() {
            var e = this.type;
            return (
              this.name &&
              !w(this).is(":disabled") &&
              At.test(this.nodeName) &&
              !Nt.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function(e, t) {
            var n = w(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? w.map(n, function(e) {
                  return { name: t.name, value: e.replace(Dt, "\r\n") };
                })
              : { name: t.name, value: n.replace(Dt, "\r\n") };
          })
          .get();
      }
    });
  var qt = /%20/g,
    Lt = /#.*$/,
    Ht = /([?&])_=[^&]*/,
    Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Mt = /^(?:GET|HEAD)$/,
    Rt = /^\/\//,
    It = {},
    Wt = {},
    $t = "*/".concat("*"),
    Bt = r.createElement("a");
  Bt.href = Ct.href;
  function Ft(e) {
    return function(t, n) {
      "string" != typeof t && ((n = t), (t = "*"));
      var r,
        i = 0,
        o = t.toLowerCase().match(M) || [];
      if (g(n))
        while ((r = o[i++]))
          "+" === r[0]
            ? ((r = r.slice(1) || "*"), (e[r] = e[r] || []).unshift(n))
            : (e[r] = e[r] || []).push(n);
    };
  }
  function _t(e, t, n, r) {
    var i = {},
      o = e === Wt;
    function a(s) {
      var u;
      return (
        (i[s] = !0),
        w.each(e[s] || [], function(e, s) {
          var l = s(t, n, r);
          return "string" != typeof l || o || i[l]
            ? o
              ? !(u = l)
              : void 0
            : (t.dataTypes.unshift(l), a(l), !1);
        }),
        u
      );
    }
    return a(t.dataTypes[0]) || (!i["*"] && a("*"));
  }
  function zt(e, t) {
    var n,
      r,
      i = w.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && w.extend(!0, e, r), e;
  }
  function Xt(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.contents,
      u = e.dataTypes;
    while ("*" === u[0])
      u.shift(),
        void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
    if (r)
      for (i in s)
        if (s[i] && s[i].test(r)) {
          u.unshift(i);
          break;
        }
    if (u[0] in n) o = u[0];
    else {
      for (i in n) {
        if (!u[0] || e.converters[i + " " + u[0]]) {
          o = i;
          break;
        }
        a || (a = i);
      }
      o = o || a;
    }
    if (o) return o !== u[0] && u.unshift(o), n[o];
  }
  function Ut(e, t, n, r) {
    var i,
      o,
      a,
      s,
      u,
      l = {},
      c = e.dataTypes.slice();
    if (c[1]) for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
    o = c.shift();
    while (o)
      if (
        (e.responseFields[o] && (n[e.responseFields[o]] = t),
        !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
        (u = o),
        (o = c.shift()))
      )
        if ("*" === o) o = u;
        else if ("*" !== u && u !== o) {
          if (!(a = l[u + " " + o] || l["* " + o]))
            for (i in l)
              if (
                (s = i.split(" "))[1] === o &&
                (a = l[u + " " + s[0]] || l["* " + s[0]])
              ) {
                !0 === a
                  ? (a = l[i])
                  : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                break;
              }
          if (!0 !== a)
            if (a && e["throws"]) t = a(t);
            else
              try {
                t = a(t);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: a ? e : "No conversion from " + u + " to " + o
                };
              }
        }
    return { state: "success", data: t };
  }
  w.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Ct.href,
      type: "GET",
      isLocal: Pt.test(Ct.protocol),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": $t,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": JSON.parse,
        "text xml": w.parseXML
      },
      flatOptions: { url: !0, context: !0 }
    },
    ajaxSetup: function(e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e);
    },
    ajaxPrefilter: Ft(It),
    ajaxTransport: Ft(Wt),
    ajax: function(t, n) {
      "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h = w.ajaxSetup({}, n),
        g = h.context || h,
        y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
        v = w.Deferred(),
        m = w.Callbacks("once memory"),
        x = h.statusCode || {},
        b = {},
        T = {},
        C = "canceled",
        E = {
          readyState: 0,
          getResponseHeader: function(e) {
            var t;
            if (c) {
              if (!s) {
                s = {};
                while ((t = Ot.exec(a))) s[t[1].toLowerCase()] = t[2];
              }
              t = s[e.toLowerCase()];
            }
            return null == t ? null : t;
          },
          getAllResponseHeaders: function() {
            return c ? a : null;
          },
          setRequestHeader: function(e, t) {
            return (
              null == c &&
                ((e = T[e.toLowerCase()] = T[e.toLowerCase()] || e),
                (b[e] = t)),
              this
            );
          },
          overrideMimeType: function(e) {
            return null == c && (h.mimeType = e), this;
          },
          statusCode: function(e) {
            var t;
            if (e)
              if (c) E.always(e[E.status]);
              else for (t in e) x[t] = [x[t], e[t]];
            return this;
          },
          abort: function(e) {
            var t = e || C;
            return i && i.abort(t), k(0, t), this;
          }
        };
      if (
        (v.promise(E),
        (h.url = ((t || h.url || Ct.href) + "").replace(
          Rt,
          Ct.protocol + "//"
        )),
        (h.type = n.method || n.type || h.method || h.type),
        (h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""]),
        null == h.crossDomain)
      ) {
        l = r.createElement("a");
        try {
          (l.href = h.url),
            (l.href = l.href),
            (h.crossDomain =
              Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host);
        } catch (e) {
          h.crossDomain = !0;
        }
      }
      if (
        (h.data &&
          h.processData &&
          "string" != typeof h.data &&
          (h.data = w.param(h.data, h.traditional)),
        _t(It, h, n, E),
        c)
      )
        return E;
      (f = w.event && h.global) &&
        0 == w.active++ &&
        w.event.trigger("ajaxStart"),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !Mt.test(h.type)),
        (o = h.url.replace(Lt, "")),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 ===
              (h.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (h.data = h.data.replace(qt, "+"))
          : ((d = h.url.slice(o.length)),
            h.data &&
              (h.processData || "string" == typeof h.data) &&
              ((o += (kt.test(o) ? "&" : "?") + h.data), delete h.data),
            !1 === h.cache &&
              ((o = o.replace(Ht, "$1")),
              (d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d)),
            (h.url = o + d)),
        h.ifModified &&
          (w.lastModified[o] &&
            E.setRequestHeader("If-Modified-Since", w.lastModified[o]),
          w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])),
        ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) &&
          E.setRequestHeader("Content-Type", h.contentType),
        E.setRequestHeader(
          "Accept",
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] +
                ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "")
            : h.accepts["*"]
        );
      for (p in h.headers) E.setRequestHeader(p, h.headers[p]);
      if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c))
        return E.abort();
      if (
        ((C = "abort"),
        m.add(h.complete),
        E.done(h.success),
        E.fail(h.error),
        (i = _t(Wt, h, n, E)))
      ) {
        if (((E.readyState = 1), f && y.trigger("ajaxSend", [E, h]), c))
          return E;
        h.async &&
          h.timeout > 0 &&
          (u = e.setTimeout(function() {
            E.abort("timeout");
          }, h.timeout));
        try {
          (c = !1), i.send(b, k);
        } catch (e) {
          if (c) throw e;
          k(-1, e);
        }
      } else k(-1, "No Transport");
      function k(t, n, r, s) {
        var l,
          p,
          d,
          b,
          T,
          C = n;
        c ||
          ((c = !0),
          u && e.clearTimeout(u),
          (i = void 0),
          (a = s || ""),
          (E.readyState = t > 0 ? 4 : 0),
          (l = (t >= 200 && t < 300) || 304 === t),
          r && (b = Xt(h, E, r)),
          (b = Ut(h, b, E, l)),
          l
            ? (h.ifModified &&
                ((T = E.getResponseHeader("Last-Modified")) &&
                  (w.lastModified[o] = T),
                (T = E.getResponseHeader("etag")) && (w.etag[o] = T)),
              204 === t || "HEAD" === h.type
                ? (C = "nocontent")
                : 304 === t
                ? (C = "notmodified")
                : ((C = b.state), (p = b.data), (l = !(d = b.error))))
            : ((d = C), (!t && C) || ((C = "error"), t < 0 && (t = 0))),
          (E.status = t),
          (E.statusText = (n || C) + ""),
          l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]),
          E.statusCode(x),
          (x = void 0),
          f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]),
          m.fireWith(g, [E, C]),
          f &&
            (y.trigger("ajaxComplete", [E, h]),
            --w.active || w.event.trigger("ajaxStop")));
      }
      return E;
    },
    getJSON: function(e, t, n) {
      return w.get(e, t, n, "json");
    },
    getScript: function(e, t) {
      return w.get(e, void 0, t, "script");
    }
  }),
    w.each(["get", "post"], function(e, t) {
      w[t] = function(e, n, r, i) {
        return (
          g(n) && ((i = i || r), (r = n), (n = void 0)),
          w.ajax(
            w.extend(
              { url: e, type: t, dataType: i, data: n, success: r },
              w.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    (w._evalUrl = function(e) {
      return w.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        throws: !0
      });
    }),
    w.fn.extend({
      wrapAll: function(e) {
        var t;
        return (
          this[0] &&
            (g(e) && (e = e.call(this[0])),
            (t = w(e, this[0].ownerDocument)
              .eq(0)
              .clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function() {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function(e) {
        return g(e)
          ? this.each(function(t) {
              w(this).wrapInner(e.call(this, t));
            })
          : this.each(function() {
              var t = w(this),
                n = t.contents();
              n.length ? n.wrapAll(e) : t.append(e);
            });
      },
      wrap: function(e) {
        var t = g(e);
        return this.each(function(n) {
          w(this).wrapAll(t ? e.call(this, n) : e);
        });
      },
      unwrap: function(e) {
        return (
          this.parent(e)
            .not("body")
            .each(function() {
              w(this).replaceWith(this.childNodes);
            }),
          this
        );
      }
    }),
    (w.expr.pseudos.hidden = function(e) {
      return !w.expr.pseudos.visible(e);
    }),
    (w.expr.pseudos.visible = function(e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (w.ajaxSettings.xhr = function() {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    });
  var Vt = { 0: 200, 1223: 204 },
    Gt = w.ajaxSettings.xhr();
  (h.cors = !!Gt && "withCredentials" in Gt),
    (h.ajax = Gt = !!Gt),
    w.ajaxTransport(function(t) {
      var n, r;
      if (h.cors || (Gt && !t.crossDomain))
        return {
          send: function(i, o) {
            var a,
              s = t.xhr();
            if (
              (s.open(t.type, t.url, t.async, t.username, t.password),
              t.xhrFields)
            )
              for (a in t.xhrFields) s[a] = t.xhrFields[a];
            t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType),
              t.crossDomain ||
                i["X-Requested-With"] ||
                (i["X-Requested-With"] = "XMLHttpRequest");
            for (a in i) s.setRequestHeader(a, i[a]);
            (n = function(e) {
              return function() {
                n &&
                  ((n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null),
                  "abort" === e
                    ? s.abort()
                    : "error" === e
                    ? "number" != typeof s.status
                      ? o(0, "error")
                      : o(s.status, s.statusText)
                    : o(
                        Vt[s.status] || s.status,
                        s.statusText,
                        "text" !== (s.responseType || "text") ||
                          "string" != typeof s.responseText
                          ? { binary: s.response }
                          : { text: s.responseText },
                        s.getAllResponseHeaders()
                      ));
              };
            }),
              (s.onload = n()),
              (r = s.onerror = s.ontimeout = n("error")),
              void 0 !== s.onabort
                ? (s.onabort = r)
                : (s.onreadystatechange = function() {
                    4 === s.readyState &&
                      e.setTimeout(function() {
                        n && r();
                      });
                  }),
              (n = n("abort"));
            try {
              s.send((t.hasContent && t.data) || null);
            } catch (e) {
              if (n) throw e;
            }
          },
          abort: function() {
            n && n();
          }
        };
    }),
    w.ajaxPrefilter(function(e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    w.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function(e) {
          return w.globalEval(e), e;
        }
      }
    }),
    w.ajaxPrefilter("script", function(e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    w.ajaxTransport("script", function(e) {
      if (e.crossDomain) {
        var t, n;
        return {
          send: function(i, o) {
            (t = w("<script>")
              .prop({ charset: e.scriptCharset, src: e.url })
              .on(
                "load error",
                (n = function(e) {
                  t.remove(),
                    (n = null),
                    e && o("error" === e.type ? 404 : 200, e.type);
                })
              )),
              r.head.appendChild(t[0]);
          },
          abort: function() {
            n && n();
          }
        };
      }
    });
  var Yt = [],
    Qt = /(=)\?(?=&|$)|\?\?/;
  w.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function() {
      var e = Yt.pop() || w.expando + "_" + Et++;
      return (this[e] = !0), e;
    }
  }),
    w.ajaxPrefilter("json jsonp", function(t, n, r) {
      var i,
        o,
        a,
        s =
          !1 !== t.jsonp &&
          (Qt.test(t.url)
            ? "url"
            : "string" == typeof t.data &&
              0 ===
                (t.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Qt.test(t.data) &&
              "data");
      if (s || "jsonp" === t.dataTypes[0])
        return (
          (i = t.jsonpCallback = g(t.jsonpCallback)
            ? t.jsonpCallback()
            : t.jsonpCallback),
          s
            ? (t[s] = t[s].replace(Qt, "$1" + i))
            : !1 !== t.jsonp &&
              (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i),
          (t.converters["script json"] = function() {
            return a || w.error(i + " was not called"), a[0];
          }),
          (t.dataTypes[0] = "json"),
          (o = e[i]),
          (e[i] = function() {
            a = arguments;
          }),
          r.always(function() {
            void 0 === o ? w(e).removeProp(i) : (e[i] = o),
              t[i] && ((t.jsonpCallback = n.jsonpCallback), Yt.push(i)),
              a && g(o) && o(a[0]),
              (a = o = void 0);
          }),
          "script"
        );
    }),
    (h.createHTMLDocument = (function() {
      var e = r.implementation.createHTMLDocument("").body;
      return (
        (e.innerHTML = "<form></form><form></form>"), 2 === e.childNodes.length
      );
    })()),
    (w.parseHTML = function(e, t, n) {
      if ("string" != typeof e) return [];
      "boolean" == typeof t && ((n = t), (t = !1));
      var i, o, a;
      return (
        t ||
          (h.createHTMLDocument
            ? (((i = (t = r.implementation.createHTMLDocument(
                ""
              )).createElement("base")).href = r.location.href),
              t.head.appendChild(i))
            : (t = r)),
        (o = A.exec(e)),
        (a = !n && []),
        o
          ? [t.createElement(o[1])]
          : ((o = xe([e], t, a)),
            a && a.length && w(a).remove(),
            w.merge([], o.childNodes))
      );
    }),
    (w.fn.load = function(e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");
      return (
        s > -1 && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
        g(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (i = "POST"),
        a.length > 0 &&
          w
            .ajax({ url: e, type: i || "GET", dataType: "html", data: t })
            .done(function(e) {
              (o = arguments),
                a.html(
                  r
                    ? w("<div>")
                        .append(w.parseHTML(e))
                        .find(r)
                    : e
                );
            })
            .always(
              n &&
                function(e, t) {
                  a.each(function() {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    w.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
      ],
      function(e, t) {
        w.fn[t] = function(e) {
          return this.on(t, e);
        };
      }
    ),
    (w.expr.pseudos.animated = function(e) {
      return w.grep(w.timers, function(t) {
        return e === t.elem;
      }).length;
    }),
    (w.offset = {
      setOffset: function(e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, "position"),
          f = w(e),
          p = {};
        "static" === c && (e.style.position = "relative"),
          (s = f.offset()),
          (o = w.css(e, "top")),
          (u = w.css(e, "left")),
          (l =
            ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1)
            ? ((a = (r = f.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          g(t) && (t = t.call(e, n, w.extend({}, s))),
          null != t.top && (p.top = t.top - s.top + a),
          null != t.left && (p.left = t.left - s.left + i),
          "using" in t ? t.using.call(e, p) : f.css(p);
      }
    }),
    w.fn.extend({
      offset: function(e) {
        if (arguments.length)
          return void 0 === e
            ? this
            : this.each(function(t) {
                w.offset.setOffset(this, e, t);
              });
        var t,
          n,
          r = this[0];
        if (r)
          return r.getClientRects().length
            ? ((t = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
            : { top: 0, left: 0 };
      },
      position: function() {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };
          if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect();
          else {
            (t = this.offset()),
              (n = r.ownerDocument),
              (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              "static" === w.css(e, "position")
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0)),
              (i.left += w.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - i.top - w.css(r, "marginTop", !0),
            left: t.left - i.left - w.css(r, "marginLeft", !0)
          };
        }
      },
      offsetParent: function() {
        return this.map(function() {
          var e = this.offsetParent;
          while (e && "static" === w.css(e, "position")) e = e.offsetParent;
          return e || be;
        });
      }
    }),
    w.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(
      e,
      t
    ) {
      var n = "pageYOffset" === t;
      w.fn[e] = function(r) {
        return z(
          this,
          function(e, r, i) {
            var o;
            if (
              (y(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView),
              void 0 === i)
            )
              return o ? o[t] : e[r];
            o
              ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset)
              : (e[r] = i);
          },
          e,
          r,
          arguments.length
        );
      };
    }),
    w.each(["top", "left"], function(e, t) {
      w.cssHooks[t] = _e(h.pixelPosition, function(e, n) {
        if (n)
          return (n = Fe(e, t)), We.test(n) ? w(e).position()[t] + "px" : n;
      });
    }),
    w.each({ Height: "height", Width: "width" }, function(e, t) {
      w.each({ padding: "inner" + e, content: t, "": "outer" + e }, function(
        n,
        r
      ) {
        w.fn[r] = function(i, o) {
          var a = arguments.length && (n || "boolean" != typeof i),
            s = n || (!0 === i || !0 === o ? "margin" : "border");
          return z(
            this,
            function(t, n, i) {
              var o;
              return y(t)
                ? 0 === r.indexOf("outer")
                  ? t["inner" + e]
                  : t.document.documentElement["client" + e]
                : 9 === t.nodeType
                ? ((o = t.documentElement),
                  Math.max(
                    t.body["scroll" + e],
                    o["scroll" + e],
                    t.body["offset" + e],
                    o["offset" + e],
                    o["client" + e]
                  ))
                : void 0 === i
                ? w.css(t, n, s)
                : w.style(t, n, i, s);
            },
            t,
            a ? i : void 0,
            a
          );
        };
      });
    }),
    w.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function(e, t) {
        w.fn[t] = function(e, n) {
          return arguments.length > 0
            ? this.on(t, null, e, n)
            : this.trigger(t);
        };
      }
    ),
    w.fn.extend({
      hover: function(e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      }
    }),
    w.fn.extend({
      bind: function(e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function(e, t) {
        return this.off(e, null, t);
      },
      delegate: function(e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function(e, t, n) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", n);
      }
    }),
    (w.proxy = function(e, t) {
      var n, r, i;
      if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
        return (
          (r = o.call(arguments, 2)),
          (i = function() {
            return e.apply(t || this, r.concat(o.call(arguments)));
          }),
          (i.guid = e.guid = e.guid || w.guid++),
          i
        );
    }),
    (w.holdReady = function(e) {
      e ? w.readyWait++ : w.ready(!0);
    }),
    (w.isArray = Array.isArray),
    (w.parseJSON = JSON.parse),
    (w.nodeName = N),
    (w.isFunction = g),
    (w.isWindow = y),
    (w.camelCase = G),
    (w.type = x),
    (w.now = Date.now),
    (w.isNumeric = function(e) {
      var t = w.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function() {
        return w;
      });
  var Jt = e.jQuery,
    Kt = e.$;
  return (
    (w.noConflict = function(t) {
      return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w;
    }),
    t || (e.jQuery = e.$ = w),
    w
  );
});

/*!
* MediaElement.js
* HTML5 <video> and <audio> shim and player
* http://mediaelementjs.com/
*
* Creates a JavaScript object that mimics HTML5 MediaElement API
* for browsers that don't understand HTML5 or can't play the provided codec
* Can play MP4 (H.264), Ogg, WebM, FLV, WMV, WMA, ACC, and MP3
*
* Copyright 2010-2014, John Dyer (http://j.hn)
* License: MIT
*
*/
// Namespace
var mejs = mejs || {};

// version number
mejs.version = '2.14.2';


// player number (for missing, same id attr)
mejs.meIndex = 0;

// media types accepted by plugins
mejs.plugins = {
  silverlight: [
    { version: [3, 0], types: ['video/mp4', 'video/m4v', 'video/mov', 'video/wmv', 'audio/wma', 'audio/m4a', 'audio/mp3', 'audio/wav', 'audio/mpeg'] }
  ],
  flash: [
    { version: [9, 0, 124], types: ['video/mp4', 'video/m4v', 'video/mov', 'video/flv', 'video/rtmp', 'video/x-flv', 'audio/flv', 'audio/x-flv', 'audio/mp3', 'audio/m4a', 'audio/mpeg', 'video/youtube', 'video/x-youtube'] }
    //,{version: [12,0], types: ['video/webm']} // for future reference (hopefully!)
  ],
  youtube: [
    { version: null, types: ['video/youtube', 'video/x-youtube', 'audio/youtube', 'audio/x-youtube'] }
  ],
  vimeo: [
    { version: null, types: ['video/vimeo', 'video/x-vimeo'] }
  ]
};

/*
Utility methods
*/
mejs.Utility = {
  encodeUrl: function (url) {
    return encodeURIComponent(url); //.replace(/\?/gi,'%3F').replace(/=/gi,'%3D').replace(/&/gi,'%26');
  },
  escapeHTML: function (s) {
    return s.toString().split('&').join('&amp;').split('<').join('&lt;').split('"').join('&quot;');
  },
  absolutizeUrl: function (url) {
    var el = document.createElement('div');
    el.innerHTML = '<a href="' + this.escapeHTML(url) + '">x</a>';
    return el.firstChild.href;
  },
  getScriptPath: function (scriptNames) {
    var
      i = 0,
      j,
      codePath = '',
      testname = '',
      slashPos,
      filenamePos,
      scriptUrl,
      scriptPath,
      scriptFilename,
      scripts = document.getElementsByTagName('script'),
      il = scripts.length,
      jl = scriptNames.length;

    // go through all <script> tags
    for (; i < il; i++) {
      scriptUrl = scripts[i].src;
      slashPos = scriptUrl.lastIndexOf('/');
      if (slashPos > -1) {
        scriptFilename = scriptUrl.substring(slashPos + 1);
        scriptPath = scriptUrl.substring(0, slashPos + 1);
      } else {
        scriptFilename = scriptUrl;
        scriptPath = '';
      }

      // see if any <script> tags have a file name that matches the 
      for (j = 0; j < jl; j++) {
        testname = scriptNames[j];
        filenamePos = scriptFilename.indexOf(testname);
        if (filenamePos > -1) {
          codePath = scriptPath;
          break;
        }
      }

      // if we found a path, then break and return it
      if (codePath !== '') {
        break;
      }
    }

    // send the best path back
    return codePath;
  },
  secondsToTimeCode: function (time, forceHours, showFrameCount, fps) {
    //add framecount
    if (typeof showFrameCount == 'undefined') {
      showFrameCount = false;
    } else if (typeof fps == 'undefined') {
      fps = 25;
    }

    var hours = Math.floor(time / 3600) % 24,
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time % 60),
      frames = Math.floor(((time % 1) * fps).toFixed(3)),
      result =
        ((forceHours || hours > 0) ? (hours < 10 ? '0' + hours : hours) + ':' : '')
        + (minutes < 10 ? '0' + minutes : minutes) + ':'
        + (seconds < 10 ? '0' + seconds : seconds)
        + ((showFrameCount) ? ':' + (frames < 10 ? '0' + frames : frames) : '');

    return result;
  },

  timeCodeToSeconds: function (hh_mm_ss_ff, forceHours, showFrameCount, fps) {
    if (typeof showFrameCount == 'undefined') {
      showFrameCount = false;
    } else if (typeof fps == 'undefined') {
      fps = 25;
    }

    var tc_array = hh_mm_ss_ff.split(":"),
      tc_hh = parseInt(tc_array[0], 10),
      tc_mm = parseInt(tc_array[1], 10),
      tc_ss = parseInt(tc_array[2], 10),
      tc_ff = 0,
      tc_in_seconds = 0;

    if (showFrameCount) {
      tc_ff = parseInt(tc_array[3]) / fps;
    }

    tc_in_seconds = (tc_hh * 3600) + (tc_mm * 60) + tc_ss + tc_ff;

    return tc_in_seconds;
  },


  convertSMPTEtoSeconds: function (SMPTE) {
    if (typeof SMPTE != 'string')
      return false;

    SMPTE = SMPTE.replace(',', '.');

    var secs = 0,
      decimalLen = (SMPTE.indexOf('.') != -1) ? SMPTE.split('.')[1].length : 0,
      multiplier = 1;

    SMPTE = SMPTE.split(':').reverse();

    for (var i = 0; i < SMPTE.length; i++) {
      multiplier = 1;
      if (i > 0) {
        multiplier = Math.pow(60, i);
      }
      secs += Number(SMPTE[i]) * multiplier;
    }
    return Number(secs.toFixed(decimalLen));
  },

  /* borrowed from SWFObject: http://code.google.com/p/swfobject/source/browse/trunk/swfobject/src/swfobject.js#474 */
  removeSwf: function (id) {
    var obj = document.getElementById(id);
    if (obj && /object|embed/i.test(obj.nodeName)) {
      if (mejs.MediaFeatures.isIE) {
        obj.style.display = "none";
        (function () {
          if (obj.readyState == 4) {
            mejs.Utility.removeObjectInIE(id);
          } else {
            setTimeout(arguments.callee, 10);
          }
        })();
      } else {
        obj.parentNode.removeChild(obj);
      }
    }
  },
  removeObjectInIE: function (id) {
    var obj = document.getElementById(id);
    if (obj) {
      for (var i in obj) {
        if (typeof obj[i] == "function") {
          obj[i] = null;
        }
      }
      obj.parentNode.removeChild(obj);
    }
  }
};


// Core detector, plugins are added below
mejs.PluginDetector = {

  // main public function to test a plug version number PluginDetector.hasPluginVersion('flash',[9,0,125]);
  hasPluginVersion: function (plugin, v) {
    var pv = this.plugins[plugin];
    v[1] = v[1] || 0;
    v[2] = v[2] || 0;
    return (pv[0] > v[0] || (pv[0] == v[0] && pv[1] > v[1]) || (pv[0] == v[0] && pv[1] == v[1] && pv[2] >= v[2])) ? true : false;
  },

  // cached values
  nav: window.navigator,
  ua: window.navigator.userAgent.toLowerCase(),

  // stored version numbers
  plugins: [],

  // runs detectPlugin() and stores the version number
  addPlugin: function (p, pluginName, mimeType, activeX, axDetect) {
    this.plugins[p] = this.detectPlugin(pluginName, mimeType, activeX, axDetect);
  },

  // get the version number from the mimetype (all but IE) or ActiveX (IE)
  detectPlugin: function (pluginName, mimeType, activeX, axDetect) {

    var version = [0, 0, 0],
      description,
      i,
      ax;

    // Firefox, Webkit, Opera
    if (typeof (this.nav.plugins) != 'undefined' && typeof this.nav.plugins[pluginName] == 'object') {
      description = this.nav.plugins[pluginName].description;
      if (description && !(typeof this.nav.mimeTypes != 'undefined' && this.nav.mimeTypes[mimeType] && !this.nav.mimeTypes[mimeType].enabledPlugin)) {
        version = description.replace(pluginName, '').replace(/^\s+/, '').replace(/\sr/gi, '.').split('.');
        for (i = 0; i < version.length; i++) {
          version[i] = parseInt(version[i].match(/\d+/), 10);
        }
      }
      // Internet Explorer / ActiveX
    } else if (typeof (window.ActiveXObject) != 'undefined') {
      try {
        ax = new ActiveXObject(activeX);
        if (ax) {
          version = axDetect(ax);
        }
      }
      catch (e) { }
    }
    return version;
  }
};

// Add Flash detection
mejs.PluginDetector.addPlugin('flash', 'Shockwave Flash', 'application/x-shockwave-flash', 'ShockwaveFlash.ShockwaveFlash', function (ax) {
  // adapted from SWFObject
  var version = [],
    d = ax.GetVariable("$version");
  if (d) {
    d = d.split(" ")[1].split(",");
    version = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
  }
  return version;
});

// Add Silverlight detection
mejs.PluginDetector.addPlugin('silverlight', 'Silverlight Plug-In', 'application/x-silverlight-2', 'AgControl.AgControl', function (ax) {
  // Silverlight cannot report its version number to IE
  // but it does have a isVersionSupported function, so we have to loop through it to get a version number.
  // adapted from http://www.silverlightversion.com/
  var v = [0, 0, 0, 0],
    loopMatch = function (ax, v, i, n) {
      while (ax.isVersionSupported(v[0] + "." + v[1] + "." + v[2] + "." + v[3])) {
        v[i] += n;
      }
      v[i] -= n;
    };
  loopMatch(ax, v, 0, 1);
  loopMatch(ax, v, 1, 1);
  loopMatch(ax, v, 2, 10000); // the third place in the version number is usually 5 digits (4.0.xxxxx)
  loopMatch(ax, v, 2, 1000);
  loopMatch(ax, v, 2, 100);
  loopMatch(ax, v, 2, 10);
  loopMatch(ax, v, 2, 1);
  loopMatch(ax, v, 3, 1);

  return v;
});
// add adobe acrobat
/*
PluginDetector.addPlugin('acrobat','Adobe Acrobat','application/pdf','AcroPDF.PDF', function (ax) {
	var version = [],
		d = ax.GetVersions().split(',')[0].split('=')[1].split('.');

	if (d) {
		version = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
	}
	return version;
});
*/
// necessary detection (fixes for <IE9)
mejs.MediaFeatures = {
  init: function () {
    var
      t = this,
      d = document,
      nav = mejs.PluginDetector.nav,
      ua = mejs.PluginDetector.ua.toLowerCase(),
      i,
      v,
      html5Elements = ['source', 'track', 'audio', 'video'];

    // detect browsers (only the ones that have some kind of quirk we need to work around)
    t.isiPad = (ua.match(/ipad/i) !== null);
    t.isiPhone = (ua.match(/iphone/i) !== null);
    t.isiOS = t.isiPhone || t.isiPad;
    t.isAndroid = (ua.match(/android/i) !== null);
    t.isBustedAndroid = (ua.match(/android 2\.[12]/) !== null);
    t.isBustedNativeHTTPS = (location.protocol === 'https:' && (ua.match(/android [12]\./) !== null || ua.match(/macintosh.* version.* safari/) !== null));
    t.isIE = (nav.appName.toLowerCase().indexOf("microsoft") != -1 || nav.appName.toLowerCase().match(/trident/gi) !== null);
    t.isChrome = (ua.match(/chrome/gi) !== null);
    t.isFirefox = (ua.match(/firefox/gi) !== null);
    t.isWebkit = (ua.match(/webkit/gi) !== null);
    t.isGecko = (ua.match(/gecko/gi) !== null) && !t.isWebkit && !t.isIE;
    t.isOpera = (ua.match(/opera/gi) !== null);
    t.hasTouch = ('ontouchstart' in window); //  && window.ontouchstart != null); // this breaks iOS 7

    // borrowed from Modernizr
    t.svg = !!document.createElementNS &&
      !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;

    // create HTML5 media elements for IE before 9, get a <video> element for fullscreen detection
    for (i = 0; i < html5Elements.length; i++) {
      v = document.createElement(html5Elements[i]);
    }

    t.supportsMediaTag = (typeof v.canPlayType !== 'undefined' || t.isBustedAndroid);

    // Fix for IE9 on Windows 7N / Windows 7KN (Media Player not installer)
    try {
      v.canPlayType("video/mp4");
    } catch (e) {
      t.supportsMediaTag = false;
    }

    // detect native JavaScript fullscreen (Safari/Firefox only, Chrome still fails)

    // iOS
    t.hasSemiNativeFullScreen = (typeof v.webkitEnterFullscreen !== 'undefined');

    // W3C
    t.hasNativeFullscreen = (typeof v.requestFullscreen !== 'undefined');

    // webkit/firefox/IE11+
    t.hasWebkitNativeFullScreen = (typeof v.webkitRequestFullScreen !== 'undefined');
    t.hasMozNativeFullScreen = (typeof v.mozRequestFullScreen !== 'undefined');
    t.hasMsNativeFullScreen = (typeof v.msRequestFullscreen !== 'undefined');

    t.hasTrueNativeFullScreen = (t.hasWebkitNativeFullScreen || t.hasMozNativeFullScreen || t.hasMsNativeFullScreen);
    t.nativeFullScreenEnabled = t.hasTrueNativeFullScreen;

    // Enabled?
    if (t.hasMozNativeFullScreen) {
      t.nativeFullScreenEnabled = document.mozFullScreenEnabled;
    } else if (t.hasMsNativeFullScreen) {
      t.nativeFullScreenEnabled = document.msFullscreenEnabled;
    }

    if (t.isChrome) {
      t.hasSemiNativeFullScreen = false;
    }

    if (t.hasTrueNativeFullScreen) {

      t.fullScreenEventName = '';
      if (t.hasWebkitNativeFullScreen) {
        t.fullScreenEventName = 'webkitfullscreenchange';

      } else if (t.hasMozNativeFullScreen) {
        t.fullScreenEventName = 'mozfullscreenchange';

      } else if (t.hasMsNativeFullScreen) {
        t.fullScreenEventName = 'MSFullscreenChange';
      }

      t.isFullScreen = function () {
        if (v.mozRequestFullScreen) {
          return d.mozFullScreen;

        } else if (v.webkitRequestFullScreen) {
          return d.webkitIsFullScreen;

        } else if (v.hasMsNativeFullScreen) {
          return d.msFullscreenElement !== null;
        }
      }

      t.requestFullScreen = function (el) {

        if (t.hasWebkitNativeFullScreen) {
          el.webkitRequestFullScreen();

        } else if (t.hasMozNativeFullScreen) {
          el.mozRequestFullScreen();

        } else if (t.hasMsNativeFullScreen) {
          el.msRequestFullscreen();

        }
      }

      t.cancelFullScreen = function () {
        if (t.hasWebkitNativeFullScreen) {
          document.webkitCancelFullScreen();

        } else if (t.hasMozNativeFullScreen) {
          document.mozCancelFullScreen();

        } else if (t.hasMsNativeFullScreen) {
          document.msExitFullscreen();

        }
      }

    }


    // OS X 10.5 can't do this even if it says it can :(
    if (t.hasSemiNativeFullScreen && ua.match(/mac os x 10_5/i)) {
      t.hasNativeFullScreen = false;
      t.hasSemiNativeFullScreen = false;
    }

  }
};
mejs.MediaFeatures.init();

/*
extension methods to <video> or <audio> object to bring it into parity with PluginMediaElement (see below)
*/
mejs.HtmlMediaElement = {
  pluginType: 'native',
  isFullScreen: false,

  setCurrentTime: function (time) {
    this.currentTime = time;
  },

  setMuted: function (muted) {
    this.muted = muted;
  },

  setVolume: function (volume) {
    this.volume = volume;
  },

  // for parity with the plugin versions
  stop: function () {
    this.pause();
  },

  // This can be a url string
  // or an array [{src:'file.mp4',type:'video/mp4'},{src:'file.webm',type:'video/webm'}]
  setSrc: function (url) {

    // Fix for IE9 which can't set .src when there are <source> elements. Awesome, right?
    var
      existingSources = this.getElementsByTagName('source');
    while (existingSources.length > 0) {
      this.removeChild(existingSources[0]);
    }

    if (typeof url == 'string') {
      this.src = url;
    } else {
      var i, media;

      for (i = 0; i < url.length; i++) {
        media = url[i];
        if (this.canPlayType(media.type)) {
          this.src = media.src;
          break;
        }
      }
    }
  },

  setVideoSize: function (width, height) {
    this.width = width;
    this.height = height;
  }
};

/*
Mimics the <video/audio> element by calling Flash's External Interface or Silverlights [ScriptableMember]
*/
mejs.PluginMediaElement = function (pluginid, pluginType, mediaUrl) {
  this.id = pluginid;
  this.pluginType = pluginType;
  this.src = mediaUrl;
  this.events = {};
  this.attributes = {};
};

// JavaScript values and ExternalInterface methods that match HTML5 video properties methods
// http://www.adobe.com/livedocs/flash/9.0/ActionScriptLangRefV3/fl/video/FLVPlayback.html
// http://www.whatwg.org/specs/web-apps/current-work/multipage/video.html
mejs.PluginMediaElement.prototype = {

  // special
  pluginElement: null,
  pluginType: '',
  isFullScreen: false,

  // not implemented :(
  playbackRate: -1,
  defaultPlaybackRate: -1,
  seekable: [],
  played: [],

  // HTML5 read-only properties
  paused: true,
  ended: false,
  seeking: false,
  duration: 0,
  error: null,
  tagName: '',

  // HTML5 get/set properties, but only set (updated by event handlers)
  muted: false,
  volume: 1,
  currentTime: 0,

  // HTML5 methods
  play: function () {
    if (this.pluginApi != null) {
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
        this.pluginApi.playVideo();
      } else {
        this.pluginApi.playMedia();
      }
      this.paused = false;
    }
  },
  load: function () {
    if (this.pluginApi != null) {
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
      } else {
        this.pluginApi.loadMedia();
      }

      this.paused = false;
    }
  },
  pause: function () {
    if (this.pluginApi != null) {
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
        this.pluginApi.pauseVideo();
      } else {
        this.pluginApi.pauseMedia();
      }


      this.paused = true;
    }
  },
  stop: function () {
    if (this.pluginApi != null) {
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
        this.pluginApi.stopVideo();
      } else {
        this.pluginApi.stopMedia();
      }
      this.paused = true;
    }
  },
  canPlayType: function (type) {
    var i,
      j,
      pluginInfo,
      pluginVersions = mejs.plugins[this.pluginType];

    for (i = 0; i < pluginVersions.length; i++) {
      pluginInfo = pluginVersions[i];

      // test if user has the correct plugin version
      if (mejs.PluginDetector.hasPluginVersion(this.pluginType, pluginInfo.version)) {

        // test for plugin playback types
        for (j = 0; j < pluginInfo.types.length; j++) {
          // find plugin that can play the type
          if (type == pluginInfo.types[j]) {
            return 'probably';
          }
        }
      }
    }

    return '';
  },

  positionFullscreenButton: function (x, y, visibleAndAbove) {
    if (this.pluginApi != null && this.pluginApi.positionFullscreenButton) {
      this.pluginApi.positionFullscreenButton(Math.floor(x), Math.floor(y), visibleAndAbove);
    }
  },

  hideFullscreenButton: function () {
    if (this.pluginApi != null && this.pluginApi.hideFullscreenButton) {
      this.pluginApi.hideFullscreenButton();
    }
  },


  // custom methods since not all JavaScript implementations support get/set

  // This can be a url string
  // or an array [{src:'file.mp4',type:'video/mp4'},{src:'file.webm',type:'video/webm'}]
  setSrc: function (url) {
    if (typeof url == 'string') {
      this.pluginApi.setSrc(mejs.Utility.absolutizeUrl(url));
      this.src = mejs.Utility.absolutizeUrl(url);
    } else {
      var i, media;

      for (i = 0; i < url.length; i++) {
        media = url[i];
        if (this.canPlayType(media.type)) {
          this.pluginApi.setSrc(mejs.Utility.absolutizeUrl(media.src));
          this.src = mejs.Utility.absolutizeUrl(url);
          break;
        }
      }
    }

  },
  setCurrentTime: function (time) {
    if (this.pluginApi != null) {
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
        this.pluginApi.seekTo(time);
      } else {
        this.pluginApi.setCurrentTime(time);
      }



      this.currentTime = time;
    }
  },
  setVolume: function (volume) {
    if (this.pluginApi != null) {
      // same on YouTube and MEjs
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
        this.pluginApi.setVolume(volume * 100);
      } else {
        this.pluginApi.setVolume(volume);
      }
      this.volume = volume;
    }
  },
  setMuted: function (muted) {
    if (this.pluginApi != null) {
      if (this.pluginType == 'youtube' || this.pluginType == 'vimeo') {
        if (muted) {
          this.pluginApi.mute();
        } else {
          this.pluginApi.unMute();
        }
        this.muted = muted;
        this.dispatchEvent('volumechange');
      } else {
        this.pluginApi.setMuted(muted);
      }
      this.muted = muted;
    }
  },

  // additional non-HTML5 methods
  setVideoSize: function (width, height) {

    //if (this.pluginType == 'flash' || this.pluginType == 'silverlight') {
    if (this.pluginElement.style) {
      this.pluginElement.style.width = width + 'px';
      this.pluginElement.style.height = height + 'px';
    }
    if (this.pluginApi != null && this.pluginApi.setVideoSize) {
      this.pluginApi.setVideoSize(width, height);
    }
    //}
  },

  setFullscreen: function (fullscreen) {
    if (this.pluginApi != null && this.pluginApi.setFullscreen) {
      this.pluginApi.setFullscreen(fullscreen);
    }
  },

  enterFullScreen: function () {
    if (this.pluginApi != null && this.pluginApi.setFullscreen) {
      this.setFullscreen(true);
    }

  },

  exitFullScreen: function () {
    if (this.pluginApi != null && this.pluginApi.setFullscreen) {
      this.setFullscreen(false);
    }
  },

  // start: fake events
  addEventListener: function (eventName, callback, bubble) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(callback);
  },
  removeEventListener: function (eventName, callback) {
    if (!eventName) { this.events = {}; return true; }
    var callbacks = this.events[eventName];
    if (!callbacks) return true;
    if (!callback) { this.events[eventName] = []; return true; }
    for (var i = 0; i < callbacks.length; i++) {
      if (callbacks[i] === callback) {
        this.events[eventName].splice(i, 1);
        return true;
      }
    }
    return false;
  },
  dispatchEvent: function (eventName) {
    var i,
      args,
      callbacks = this.events[eventName];

    if (callbacks) {
      args = Array.prototype.slice.call(arguments, 1);
      for (i = 0; i < callbacks.length; i++) {
        callbacks[i].apply(null, args);
      }
    }
  },
  // end: fake events

  // fake DOM attribute methods
  hasAttribute: function (name) {
    return (name in this.attributes);
  },
  removeAttribute: function (name) {
    delete this.attributes[name];
  },
  getAttribute: function (name) {
    if (this.hasAttribute(name)) {
      return this.attributes[name];
    }
    return '';
  },
  setAttribute: function (name, value) {
    this.attributes[name] = value;
  },

  remove: function () {
    mejs.Utility.removeSwf(this.pluginElement.id);
    mejs.MediaPluginBridge.unregisterPluginElement(this.pluginElement.id);
  }
};

// Handles calls from Flash/Silverlight and reports them as native <video/audio> events and properties
mejs.MediaPluginBridge = {

  pluginMediaElements: {},
  htmlMediaElements: {},

  registerPluginElement: function (id, pluginMediaElement, htmlMediaElement) {
    this.pluginMediaElements[id] = pluginMediaElement;
    this.htmlMediaElements[id] = htmlMediaElement;
  },

  unregisterPluginElement: function (id) {
    delete this.pluginMediaElements[id];
    delete this.htmlMediaElements[id];
  },

  // when Flash/Silverlight is ready, it calls out to this method
  initPlugin: function (id) {

    var pluginMediaElement = this.pluginMediaElements[id],
      htmlMediaElement = this.htmlMediaElements[id];

    if (pluginMediaElement) {
      // find the javascript bridge
      switch (pluginMediaElement.pluginType) {
        case "flash":
          pluginMediaElement.pluginElement = pluginMediaElement.pluginApi = document.getElementById(id);
          break;
        case "silverlight":
          pluginMediaElement.pluginElement = document.getElementById(pluginMediaElement.id);
          pluginMediaElement.pluginApi = pluginMediaElement.pluginElement.Content.MediaElementJS;
          break;
      }

      if (pluginMediaElement.pluginApi != null && pluginMediaElement.success) {
        pluginMediaElement.success(pluginMediaElement, htmlMediaElement);
      }
    }
  },

  // receives events from Flash/Silverlight and sends them out as HTML5 media events
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/video.html
  fireEvent: function (id, eventName, values) {

    var
      e,
      i,
      bufferedTime,
      pluginMediaElement = this.pluginMediaElements[id];

    if (!pluginMediaElement) {
      return;
    }

    // fake event object to mimic real HTML media event.
    e = {
      type: eventName,
      target: pluginMediaElement
    };

    // attach all values to element and event object
    for (i in values) {
      pluginMediaElement[i] = values[i];
      e[i] = values[i];
    }

    // fake the newer W3C buffered TimeRange (loaded and total have been removed)
    bufferedTime = values.bufferedTime || 0;

    e.target.buffered = e.buffered = {
      start: function (index) {
        return 0;
      },
      end: function (index) {
        return bufferedTime;
      },
      length: 1
    };

    pluginMediaElement.dispatchEvent(e.type, e);
  }
};

/*
Default options
*/
mejs.MediaElementDefaults = {
  // allows testing on HTML5, flash, silverlight
  // auto: attempts to detect what the browser can do
  // auto_plugin: prefer plugins and then attempt native HTML5
  // native: forces HTML5 playback
  // shim: disallows HTML5, will attempt either Flash or Silverlight
  // none: forces fallback view
  mode: 'auto',
  // remove or reorder to change plugin priority and availability
  plugins: ['flash', 'silverlight', 'youtube', 'vimeo'],
  // shows debug errors on screen
  enablePluginDebug: false,
  // use plugin for browsers that have trouble with Basic Authentication on HTTPS sites
  httpsBasicAuthSite: false,
  // overrides the type specified, useful for dynamic instantiation
  type: '',
  // path to Flash and Silverlight plugins
  pluginPath: mejs.Utility.getScriptPath(['mediaelement.js', 'mediaelement.min.js', 'mediaelement-and-player.js', 'mediaelement-and-player.min.js']),
  // name of flash file
  flashName: 'flashmediaelement.swf',
  // streamer for RTMP streaming
  flashStreamer: '',
  // turns on the smoothing filter in Flash
  enablePluginSmoothing: false,
  // enabled pseudo-streaming (seek) on .mp4 files
  enablePseudoStreaming: false,
  // start query parameter sent to server for pseudo-streaming
  pseudoStreamingStartQueryParam: 'start',
  // name of silverlight file
  silverlightName: 'silverlightmediaelement.xap',
  // default if the <video width> is not specified
  defaultVideoWidth: 480,
  // default if the <video height> is not specified
  defaultVideoHeight: 270,
  // overrides <video width>
  pluginWidth: -1,
  // overrides <video height>
  pluginHeight: -1,
  // additional plugin variables in 'key=value' form
  pluginVars: [],
  // rate in milliseconds for Flash and Silverlight to fire the timeupdate event
  // larger number is less accurate, but less strain on plugin->JavaScript bridge
  timerRate: 250,
  // initial volume for player
  startVolume: 0.8,
  success: function () { },
  error: function () { }
};

/*
Determines if a browser supports the <video> or <audio> element
and returns either the native element or a Flash/Silverlight version that
mimics HTML5 MediaElement
*/
mejs.MediaElement = function (el, o) {
  return mejs.HtmlMediaElementShim.create(el, o);
};

mejs.HtmlMediaElementShim = {

  create: function (el, o) {
    var
      options = mejs.MediaElementDefaults,
      htmlMediaElement = (typeof (el) == 'string') ? document.getElementById(el) : el,
      tagName = htmlMediaElement.tagName.toLowerCase(),
      isMediaTag = (tagName === 'audio' || tagName === 'video'),
      src = (isMediaTag) ? htmlMediaElement.getAttribute('src') : htmlMediaElement.getAttribute('href'),
      poster = htmlMediaElement.getAttribute('poster'),
      autoplay = htmlMediaElement.getAttribute('autoplay'),
      preload = htmlMediaElement.getAttribute('preload'),
      controls = htmlMediaElement.getAttribute('controls'),
      playback,
      prop;

    // extend options
    for (prop in o) {
      options[prop] = o[prop];
    }

    // clean up attributes
    src = (typeof src == 'undefined' || src === null || src == '') ? null : src;
    poster = (typeof poster == 'undefined' || poster === null) ? '' : poster;
    preload = (typeof preload == 'undefined' || preload === null || preload === 'false') ? 'none' : preload;
    autoplay = !(typeof autoplay == 'undefined' || autoplay === null || autoplay === 'false');
    controls = !(typeof controls == 'undefined' || controls === null || controls === 'false');

    // test for HTML5 and plugin capabilities
    playback = this.determinePlayback(htmlMediaElement, options, mejs.MediaFeatures.supportsMediaTag, isMediaTag, src);
    playback.url = (playback.url !== null) ? mejs.Utility.absolutizeUrl(playback.url) : '';

    if (playback.method == 'native') {
      // second fix for android
      if (mejs.MediaFeatures.isBustedAndroid) {
        htmlMediaElement.src = playback.url;
        htmlMediaElement.addEventListener('click', function () {
          htmlMediaElement.play();
        }, false);
      }

      // add methods to native HTMLMediaElement
      return this.updateNative(playback, options, autoplay, preload);
    } else if (playback.method !== '') {
      // create plugin to mimic HTMLMediaElement

      return this.createPlugin(playback, options, poster, autoplay, preload, controls);
    } else {
      // boo, no HTML5, no Flash, no Silverlight.
      this.createErrorMessage(playback, options, poster);

      return this;
    }
  },

  determinePlayback: function (htmlMediaElement, options, supportsMediaTag, isMediaTag, src) {
    var
      mediaFiles = [],
      i,
      j,
      k,
      l,
      n,
      type,
      result = { method: '', url: '', htmlMediaElement: htmlMediaElement, isVideo: (htmlMediaElement.tagName.toLowerCase() != 'audio') },
      pluginName,
      pluginVersions,
      pluginInfo,
      dummy,
      media;

    // STEP 1: Get URL and type from <video src> or <source src>

    // supplied type overrides <video type> and <source type>
    if (typeof options.type != 'undefined' && options.type !== '') {

      // accept either string or array of types
      if (typeof options.type == 'string') {
        mediaFiles.push({ type: options.type, url: src });
      } else {

        for (i = 0; i < options.type.length; i++) {
          mediaFiles.push({ type: options.type[i], url: src });
        }
      }

      // test for src attribute first
    } else if (src !== null) {
      type = this.formatType(src, htmlMediaElement.getAttribute('type'));
      mediaFiles.push({ type: type, url: src });

      // then test for <source> elements
    } else {
      // test <source> types to see if they are usable
      for (i = 0; i < htmlMediaElement.childNodes.length; i++) {
        n = htmlMediaElement.childNodes[i];
        if (n.nodeType == 1 && n.tagName.toLowerCase() == 'source') {
          src = n.getAttribute('src');
          type = this.formatType(src, n.getAttribute('type'));
          media = n.getAttribute('media');

          if (!media || !window.matchMedia || (window.matchMedia && window.matchMedia(media).matches)) {
            mediaFiles.push({ type: type, url: src });
          }
        }
      }
    }

    // in the case of dynamicly created players
    // check for audio types
    if (!isMediaTag && mediaFiles.length > 0 && mediaFiles[0].url !== null && this.getTypeFromFile(mediaFiles[0].url).indexOf('audio') > -1) {
      result.isVideo = false;
    }


    // STEP 2: Test for playback method

    // special case for Android which sadly doesn't implement the canPlayType function (always returns '')
    if (mejs.MediaFeatures.isBustedAndroid) {
      htmlMediaElement.canPlayType = function (type) {
        return (type.match(/video\/(mp4|m4v)/gi) !== null) ? 'maybe' : '';
      };
    }


    // test for native playback first
    if (supportsMediaTag && (options.mode === 'auto' || options.mode === 'auto_plugin' || options.mode === 'native') && !(mejs.MediaFeatures.isBustedNativeHTTPS && options.httpsBasicAuthSite === true)) {

      if (!isMediaTag) {

        // create a real HTML5 Media Element 
        dummy = document.createElement(result.isVideo ? 'video' : 'audio');
        htmlMediaElement.parentNode.insertBefore(dummy, htmlMediaElement);
        htmlMediaElement.style.display = 'none';

        // use this one from now on
        result.htmlMediaElement = htmlMediaElement = dummy;
      }

      for (i = 0; i < mediaFiles.length; i++) {
        // normal check
        if (htmlMediaElement.canPlayType(mediaFiles[i].type).replace(/no/, '') !== ''
          // special case for Mac/Safari 5.0.3 which answers '' to canPlayType('audio/mp3') but 'maybe' to canPlayType('audio/mpeg')
          || htmlMediaElement.canPlayType(mediaFiles[i].type.replace(/mp3/, 'mpeg')).replace(/no/, '') !== ''
          // special case for m4a supported by detecting mp4 support
          || htmlMediaElement.canPlayType(mediaFiles[i].type.replace(/m4a/, 'mp4')).replace(/no/, '') !== '') {
          result.method = 'native';
          result.url = mediaFiles[i].url;
          break;
        }
      }

      if (result.method === 'native') {
        if (result.url !== null) {
          htmlMediaElement.src = result.url;
        }

        // if `auto_plugin` mode, then cache the native result but try plugins.
        if (options.mode !== 'auto_plugin') {
          return result;
        }
      }
    }

    // if native playback didn't work, then test plugins
    if (options.mode === 'auto' || options.mode === 'auto_plugin' || options.mode === 'shim') {
      for (i = 0; i < mediaFiles.length; i++) {
        type = mediaFiles[i].type;

        // test all plugins in order of preference [silverlight, flash]
        for (j = 0; j < options.plugins.length; j++) {

          pluginName = options.plugins[j];

          // test version of plugin (for future features)
          pluginVersions = mejs.plugins[pluginName];

          for (k = 0; k < pluginVersions.length; k++) {
            pluginInfo = pluginVersions[k];

            // test if user has the correct plugin version

            // for youtube/vimeo
            if (pluginInfo.version == null ||

              mejs.PluginDetector.hasPluginVersion(pluginName, pluginInfo.version)) {

              // test for plugin playback types
              for (l = 0; l < pluginInfo.types.length; l++) {
                // find plugin that can play the type
                if (type == pluginInfo.types[l]) {
                  result.method = pluginName;
                  result.url = mediaFiles[i].url;
                  return result;
                }
              }
            }
          }
        }
      }
    }

    // at this point, being in 'auto_plugin' mode implies that we tried plugins but failed.
    // if we have native support then return that.
    if (options.mode === 'auto_plugin' && result.method === 'native') {
      return result;
    }

    // what if there's nothing to play? just grab the first available
    if (result.method === '' && mediaFiles.length > 0) {
      result.url = mediaFiles[0].url;
    }

    return result;
  },

  formatType: function (url, type) {
    var ext;

    // if no type is supplied, fake it with the extension
    if (url && !type) {
      return this.getTypeFromFile(url);
    } else {
      // only return the mime part of the type in case the attribute contains the codec
      // see http://www.whatwg.org/specs/web-apps/current-work/multipage/video.html#the-source-element
      // `video/mp4; codecs="avc1.42E01E, mp4a.40.2"` becomes `video/mp4`

      if (type && ~type.indexOf(';')) {
        return type.substr(0, type.indexOf(';'));
      } else {
        return type;
      }
    }
  },

  getTypeFromFile: function (url) {
    url = url.split('?')[0];
    var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
    return (/(mp4|m4v|ogg|ogv|webm|webmv|flv|wmv|mpeg|mov)/gi.test(ext) ? 'video' : 'audio') + '/' + this.getTypeFromExtension(ext);
  },

  getTypeFromExtension: function (ext) {

    switch (ext) {
      case 'mp4':
      case 'm4v':
      case 'm4a':
        return 'mp4';
      case 'webm':
      case 'webma':
      case 'webmv':
        return 'webm';
      case 'ogg':
      case 'oga':
      case 'ogv':
        return 'ogg';
      default:
        return ext;
    }
  },

  createErrorMessage: function (playback, options, poster) {
    var
      htmlMediaElement = playback.htmlMediaElement,
      errorContainer = document.createElement('div');

    errorContainer.className = 'me-cannotplay';

    try {
      errorContainer.style.width = htmlMediaElement.width + 'px';
      errorContainer.style.height = htmlMediaElement.height + 'px';
    } catch (e) { }

    if (options.customError) {
      errorContainer.innerHTML = options.customError;
    } else {
      errorContainer.innerHTML = (poster !== '') ?
        '<a href="' + playback.url + '"><img src="' + poster + '" width="100%" height="100%" /></a>' :
        '<a href="' + playback.url + '"><span>' + mejs.i18n.t('Download File') + '</span></a>';
    }

    htmlMediaElement.parentNode.insertBefore(errorContainer, htmlMediaElement);
    htmlMediaElement.style.display = 'none';

    options.error(htmlMediaElement);
  },

  createPlugin: function (playback, options, poster, autoplay, preload, controls) {
    var
      htmlMediaElement = playback.htmlMediaElement,
      width = 1,
      height = 1,
      pluginid = 'me_' + playback.method + '_' + (mejs.meIndex++),
      pluginMediaElement = new mejs.PluginMediaElement(pluginid, playback.method, playback.url),
      container = document.createElement('div'),
      specialIEContainer,
      node,
      initVars;

    // copy tagName from html media element
    pluginMediaElement.tagName = htmlMediaElement.tagName

    // copy attributes from html media element to plugin media element
    for (var i = 0; i < htmlMediaElement.attributes.length; i++) {
      var attribute = htmlMediaElement.attributes[i];
      if (attribute.specified == true) {
        pluginMediaElement.setAttribute(attribute.name, attribute.value);
      }
    }

    // check for placement inside a <p> tag (sometimes WYSIWYG editors do this)
    node = htmlMediaElement.parentNode;
    while (node !== null && node.tagName.toLowerCase() !== 'body' && node.parentNode != null) {
      if (node.parentNode.tagName.toLowerCase() === 'p') {
        node.parentNode.parentNode.insertBefore(node, node.parentNode);
        break;
      }
      node = node.parentNode;
    }

    if (playback.isVideo) {
      width = (options.pluginWidth > 0) ? options.pluginWidth : (options.videoWidth > 0) ? options.videoWidth : (htmlMediaElement.getAttribute('width') !== null) ? htmlMediaElement.getAttribute('width') : options.defaultVideoWidth;
      height = (options.pluginHeight > 0) ? options.pluginHeight : (options.videoHeight > 0) ? options.videoHeight : (htmlMediaElement.getAttribute('height') !== null) ? htmlMediaElement.getAttribute('height') : options.defaultVideoHeight;

      // in case of '%' make sure it's encoded
      width = mejs.Utility.encodeUrl(width);
      height = mejs.Utility.encodeUrl(height);

    } else {
      if (options.enablePluginDebug) {
        width = 320;
        height = 240;
      }
    }

    // register plugin
    pluginMediaElement.success = options.success;
    mejs.MediaPluginBridge.registerPluginElement(pluginid, pluginMediaElement, htmlMediaElement);

    // add container (must be added to DOM before inserting HTML for IE)
    container.className = 'me-plugin';
    container.id = pluginid + '_container';

    if (playback.isVideo) {
      htmlMediaElement.parentNode.insertBefore(container, htmlMediaElement);
    } else {
      document.body.insertBefore(container, document.body.childNodes[0]);
    }

    // flash/silverlight vars
    initVars = [
      'id=' + pluginid,
      'isvideo=' + ((playback.isVideo) ? "true" : "false"),
      'autoplay=' + ((autoplay) ? "true" : "false"),
      'preload=' + preload,
      'width=' + width,
      'startvolume=' + options.startVolume,
      'timerrate=' + options.timerRate,
      'flashstreamer=' + options.flashStreamer,
      'height=' + height,
      'pseudostreamstart=' + options.pseudoStreamingStartQueryParam];

    if (playback.url !== null) {
      if (playback.method == 'flash') {
        initVars.push('file=' + mejs.Utility.encodeUrl(playback.url));
      } else {
        initVars.push('file=' + playback.url);
      }
    }
    if (options.enablePluginDebug) {
      initVars.push('debug=true');
    }
    if (options.enablePluginSmoothing) {
      initVars.push('smoothing=true');
    }
    if (options.enablePseudoStreaming) {
      initVars.push('pseudostreaming=true');
    }
    if (controls) {
      initVars.push('controls=true'); // shows controls in the plugin if desired
    }
    if (options.pluginVars) {
      initVars = initVars.concat(options.pluginVars);
    }

    switch (playback.method) {
      case 'silverlight':
        container.innerHTML =
          '<object data="data:application/x-silverlight-2," type="application/x-silverlight-2" id="' + pluginid + '" name="' + pluginid + '" width="' + width + '" height="' + height + '" class="mejs-shim">' +
          '<param name="initParams" value="' + initVars.join(',') + '" />' +
          '<param name="windowless" value="true" />' +
          '<param name="background" value="black" />' +
          '<param name="minRuntimeVersion" value="3.0.0.0" />' +
          '<param name="autoUpgrade" value="true" />' +
          '<param name="source" value="' + options.pluginPath + options.silverlightName + '" />' +
          '</object>';
        break;

      case 'flash':

        if (mejs.MediaFeatures.isIE) {
          specialIEContainer = document.createElement('div');
          container.appendChild(specialIEContainer);
          specialIEContainer.outerHTML =
            '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="//download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab" ' +
            'id="' + pluginid + '" width="' + width + '" height="' + height + '" class="mejs-shim">' +
            '<param name="movie" value="' + options.pluginPath + options.flashName + '?x=' + (new Date()) + '" />' +
            '<param name="flashvars" value="' + initVars.join('&amp;') + '" />' +
            '<param name="quality" value="high" />' +
            '<param name="bgcolor" value="#000000" />' +
            '<param name="wmode" value="transparent" />' +
            '<param name="allowScriptAccess" value="always" />' +
            '<param name="allowFullScreen" value="true" />' +
            '<param name="scale" value="default" />' +
            '</object>';

        } else {

          container.innerHTML =
            '<embed id="' + pluginid + '" name="' + pluginid + '" ' +
            'play="true" ' +
            'loop="false" ' +
            'quality="high" ' +
            'bgcolor="#000000" ' +
            'wmode="transparent" ' +
            'allowScriptAccess="always" ' +
            'allowFullScreen="true" ' +
            'type="application/x-shockwave-flash" pluginspage="//www.macromedia.com/go/getflashplayer" ' +
            'src="' + options.pluginPath + options.flashName + '" ' +
            'flashvars="' + initVars.join('&') + '" ' +
            'width="' + width + '" ' +
            'height="' + height + '" ' +
            'scale="default"' +
            'class="mejs-shim"></embed>';
        }
        break;

      case 'youtube':


        var videoId;
        // youtu.be url from share button
        if (playback.url.lastIndexOf("youtu.be") != -1) {
          videoId = playback.url.substr(playback.url.lastIndexOf('/') + 1);
          if (videoId.indexOf('?') != -1) {
            videoId = videoId.substr(0, videoId.indexOf('?'));
          }
        }
        else {
          videoId = playback.url.substr(playback.url.lastIndexOf('=') + 1);
        }
        youtubeSettings = {
          container: container,
          containerId: container.id,
          pluginMediaElement: pluginMediaElement,
          pluginId: pluginid,
          videoId: videoId,
          height: height,
          width: width
        };

        if (mejs.PluginDetector.hasPluginVersion('flash', [10, 0, 0])) {
          mejs.YouTubeApi.createFlash(youtubeSettings);
        } else {
          mejs.YouTubeApi.enqueueIframe(youtubeSettings);
        }

        break;

      // DEMO Code. Does NOT work.
      case 'vimeo':
        var player_id = pluginid + "_player";
        pluginMediaElement.vimeoid = playback.url.substr(playback.url.lastIndexOf('/') + 1);

        container.innerHTML = '<iframe src="//player.vimeo.com/video/' + pluginMediaElement.vimeoid + '?api=1&portrait=0&byline=0&title=0&player_id=' + player_id + '" width="' + width + '" height="' + height + '" frameborder="0" class="mejs-shim" id="' + player_id + '"></iframe>';
        if (typeof ($f) == 'function') { // froogaloop available
          var player = $f(container.childNodes[0]);
          player.addEvent('ready', function () {
            player.playVideo = function () {
              player.api('play');
            };
            player.pauseVideo = function () {
              player.api('pause');
            };
            player.seekTo = function (seconds) {
              player.api('seekTo', seconds);
            };
            function createEvent(player, pluginMediaElement, eventName, e) {
              var obj = {
                type: eventName,
                target: pluginMediaElement
              };
              if (eventName == 'timeupdate') {
                pluginMediaElement.currentTime = obj.currentTime = e.seconds;
                pluginMediaElement.duration = obj.duration = e.duration;
              }
              pluginMediaElement.dispatchEvent(obj.type, obj);
            }
            player.addEvent('play', function () {
              createEvent(player, pluginMediaElement, 'play');
              createEvent(player, pluginMediaElement, 'playing');
            });
            player.addEvent('pause', function () {
              createEvent(player, pluginMediaElement, 'pause');
            });

            player.addEvent('finish', function () {
              createEvent(player, pluginMediaElement, 'ended');
            });
            player.addEvent('playProgress', function (e) {
              createEvent(player, pluginMediaElement, 'timeupdate', e);
            });
            pluginMediaElement.pluginApi = player;

            // init mejs
            mejs.MediaPluginBridge.initPlugin(pluginid);

          });
        }
        else {
          console.warn("You need to include froogaloop for vimeo to work");
        }
        break;
    }
    // hide original element
    htmlMediaElement.style.display = 'none';
    // prevent browser from autoplaying when using a plugin
    htmlMediaElement.removeAttribute('autoplay');

    // FYI: options.success will be fired by the MediaPluginBridge

    return pluginMediaElement;
  },

  updateNative: function (playback, options, autoplay, preload) {

    var htmlMediaElement = playback.htmlMediaElement,
      m;


    // add methods to video object to bring it into parity with Flash Object
    for (m in mejs.HtmlMediaElement) {
      htmlMediaElement[m] = mejs.HtmlMediaElement[m];
    }

		/*
		Chrome now supports preload="none"
		if (mejs.MediaFeatures.isChrome) {
		
			// special case to enforce preload attribute (Chrome doesn't respect this)
			if (preload === 'none' && !autoplay) {
			
				// forces the browser to stop loading (note: fails in IE9)
				htmlMediaElement.src = '';
				htmlMediaElement.load();
				htmlMediaElement.canceledPreload = true;

				htmlMediaElement.addEventListener('play',function() {
					if (htmlMediaElement.canceledPreload) {
						htmlMediaElement.src = playback.url;
						htmlMediaElement.load();
						htmlMediaElement.play();
						htmlMediaElement.canceledPreload = false;
					}
				}, false);
			// for some reason Chrome forgets how to autoplay sometimes.
			} else if (autoplay) {
				htmlMediaElement.load();
				htmlMediaElement.play();
			}
		}
		*/

    // fire success code
    options.success(htmlMediaElement, htmlMediaElement);

    return htmlMediaElement;
  }
};

/*
 - test on IE (object vs. embed)
 - determine when to use iframe (Firefox, Safari, Mobile) vs. Flash (Chrome, IE)
 - fullscreen?
*/

// YouTube Flash and Iframe API
mejs.YouTubeApi = {
  isIframeStarted: false,
  isIframeLoaded: false,
  loadIframeApi: function () {
    if (!this.isIframeStarted) {
      var tag = document.createElement('script');
      tag.src = "//www.youtube.com/player_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      this.isIframeStarted = true;
    }
  },
  iframeQueue: [],
  enqueueIframe: function (yt) {

    if (this.isLoaded) {
      this.createIframe(yt);
    } else {
      this.loadIframeApi();
      this.iframeQueue.push(yt);
    }
  },
  createIframe: function (settings) {

    var
      pluginMediaElement = settings.pluginMediaElement,
      player = new YT.Player(settings.containerId, {
        height: settings.height,
        width: settings.width,
        videoId: settings.videoId,
        playerVars: { controls: 0 },
        events: {
          'onReady': function () {

            // hook up iframe object to MEjs
            settings.pluginMediaElement.pluginApi = player;

            // init mejs
            mejs.MediaPluginBridge.initPlugin(settings.pluginId);

            // create timer
            setInterval(function () {
              mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'timeupdate');
            }, 250);
          },
          'onStateChange': function (e) {

            mejs.YouTubeApi.handleStateChange(e.data, player, pluginMediaElement);

          }
        }
      });
  },

  createEvent: function (player, pluginMediaElement, eventName) {
    var obj = {
      type: eventName,
      target: pluginMediaElement
    };

    if (player && player.getDuration) {

      // time 
      pluginMediaElement.currentTime = obj.currentTime = player.getCurrentTime();
      pluginMediaElement.duration = obj.duration = player.getDuration();

      // state
      obj.paused = pluginMediaElement.paused;
      obj.ended = pluginMediaElement.ended;

      // sound
      obj.muted = player.isMuted();
      obj.volume = player.getVolume() / 100;

      // progress
      obj.bytesTotal = player.getVideoBytesTotal();
      obj.bufferedBytes = player.getVideoBytesLoaded();

      // fake the W3C buffered TimeRange
      var bufferedTime = obj.bufferedBytes / obj.bytesTotal * obj.duration;

      obj.target.buffered = obj.buffered = {
        start: function (index) {
          return 0;
        },
        end: function (index) {
          return bufferedTime;
        },
        length: 1
      };

    }

    // send event up the chain
    pluginMediaElement.dispatchEvent(obj.type, obj);
  },

  iFrameReady: function () {

    this.isLoaded = true;
    this.isIframeLoaded = true;

    while (this.iframeQueue.length > 0) {
      var settings = this.iframeQueue.pop();
      this.createIframe(settings);
    }
  },

  // FLASH!
  flashPlayers: {},
  createFlash: function (settings) {

    this.flashPlayers[settings.pluginId] = settings;

		/*
		settings.container.innerHTML =
			'<object type="application/x-shockwave-flash" id="' + settings.pluginId + '" data="//www.youtube.com/apiplayer?enablejsapi=1&amp;playerapiid=' + settings.pluginId  + '&amp;version=3&amp;autoplay=0&amp;controls=0&amp;modestbranding=1&loop=0" ' +
				'width="' + settings.width + '" height="' + settings.height + '" style="visibility: visible; " class="mejs-shim">' +
				'<param name="allowScriptAccess" value="always">' +
				'<param name="wmode" value="transparent">' +
			'</object>';
		*/

    var specialIEContainer,
      youtubeUrl = '//www.youtube.com/apiplayer?enablejsapi=1&amp;playerapiid=' + settings.pluginId + '&amp;version=3&amp;autoplay=0&amp;controls=0&amp;modestbranding=1&loop=0';

    if (mejs.MediaFeatures.isIE) {

      specialIEContainer = document.createElement('div');
      settings.container.appendChild(specialIEContainer);
      specialIEContainer.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="//download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab" ' +
        'id="' + settings.pluginId + '" width="' + settings.width + '" height="' + settings.height + '" class="mejs-shim">' +
        '<param name="movie" value="' + youtubeUrl + '" />' +
        '<param name="wmode" value="transparent" />' +
        '<param name="allowScriptAccess" value="always" />' +
        '<param name="allowFullScreen" value="true" />' +
        '</object>';
    } else {
      settings.container.innerHTML =
        '<object type="application/x-shockwave-flash" id="' + settings.pluginId + '" data="' + youtubeUrl + '" ' +
        'width="' + settings.width + '" height="' + settings.height + '" style="visibility: visible; " class="mejs-shim">' +
        '<param name="allowScriptAccess" value="always">' +
        '<param name="wmode" value="transparent">' +
        '</object>';
    }

  },

  flashReady: function (id) {
    var
      settings = this.flashPlayers[id],
      player = document.getElementById(id),
      pluginMediaElement = settings.pluginMediaElement;

    // hook up and return to MediaELementPlayer.success	
    pluginMediaElement.pluginApi =
      pluginMediaElement.pluginElement = player;
    mejs.MediaPluginBridge.initPlugin(id);

    // load the youtube video
    player.cueVideoById(settings.videoId);

    var callbackName = settings.containerId + '_callback';

    window[callbackName] = function (e) {
      mejs.YouTubeApi.handleStateChange(e, player, pluginMediaElement);
    }

    player.addEventListener('onStateChange', callbackName);

    setInterval(function () {
      mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'timeupdate');
    }, 250);
  },

  handleStateChange: function (youTubeState, player, pluginMediaElement) {
    switch (youTubeState) {
      case -1: // not started
        pluginMediaElement.paused = true;
        pluginMediaElement.ended = true;
        mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'loadedmetadata');
        //createYouTubeEvent(player, pluginMediaElement, 'loadeddata');
        break;
      case 0:
        pluginMediaElement.paused = false;
        pluginMediaElement.ended = true;
        mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'ended');
        break;
      case 1:
        pluginMediaElement.paused = false;
        pluginMediaElement.ended = false;
        mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'play');
        mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'playing');
        break;
      case 2:
        pluginMediaElement.paused = true;
        pluginMediaElement.ended = false;
        mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'pause');
        break;
      case 3: // buffering
        mejs.YouTubeApi.createEvent(player, pluginMediaElement, 'progress');
        break;
      case 5:
        // cued?
        break;

    }

  }
}
// IFRAME
function onYouTubePlayerAPIReady() {
  mejs.YouTubeApi.iFrameReady();
}
// FLASH
function onYouTubePlayerReady(id) {
  mejs.YouTubeApi.flashReady(id);
}

window.mejs = mejs;
window.MediaElement = mejs.MediaElement;

/*!
 * Adds Internationalization and localization to mediaelement.
 *
 * This file does not contain translations, you have to add the manually.
 * The schema is always the same: me-i18n-locale-[ISO_639-1 Code].js
 *
 * Examples are provided both for german and chinese translation.
 *
 *
 * What is the concept beyond i18n?
 *   http://en.wikipedia.org/wiki/Internationalization_and_localization
 *
 * What langcode should i use?
 *   http://en.wikipedia.org/wiki/ISO_639-1
 *
 *
 * License?
 *
 *   The i18n file uses methods from the Drupal project (drupal.js):
 *     - i18n.methods.t() (modified)
 *     - i18n.methods.checkPlain() (full copy)
 *
 *   The Drupal project is (like mediaelementjs) licensed under GPLv2.
 *    - http://drupal.org/licensing/faq/#q1
 *    - https://github.com/johndyer/mediaelement
 *    - http://www.gnu.org/licenses/old-licenses/gpl-2.0.html
 *
 *
 * @author
 *   Tim Latz (latz.tim@gmail.com)
 *
 *
 * @params
 *  - context - document, iframe ..
 *  - exports - CommonJS, window ..
 *
 */
; (function (context, exports, undefined) {
  "use strict";
  var i18n = {
    "locale": {
      "language": '',
      "strings": {}
    },
    "methods": {}
  };
  // start i18n


  /**
   * Get language, fallback to browser's language if empty
   */
  i18n.getLanguage = function () {
    var language = i18n.locale.language || window.navigator.userLanguage || window.navigator.language;
    // convert to iso 639-1 (2-letters, lower case)
    return language.substr(0, 2).toLowerCase();
  };

  // i18n fixes for compatibility with WordPress
  if (typeof mejsL10n != 'undefined') {
    i18n.locale.language = mejsL10n.language;
  }



  /**
   * Encode special characters in a plain-text string for display as HTML.
   */
  i18n.methods.checkPlain = function (str) {
    var character, regex,
      replace = {
        '&': '&amp;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;'
      };
    str = String(str);
    for (character in replace) {
      if (replace.hasOwnProperty(character)) {
        regex = new RegExp(character, 'g');
        str = str.replace(regex, replace[character]);
      }
    }
    return str;
  };

  /**
   * Translate strings to the page language or a given language.
   *
   *
   * @param str
   *   A string containing the English string to translate.
   *
   * @param options
   *   - 'context' (defaults to the default context): The context the source string
   *     belongs to.
   *
   * @return
   *   The translated string, escaped via i18n.methods.checkPlain()
   */
  i18n.methods.t = function (str, options) {

    // Fetch the localized version of the string.
    if (i18n.locale.strings && i18n.locale.strings[options.context] && i18n.locale.strings[options.context][str]) {
      str = i18n.locale.strings[options.context][str];
    }

    return i18n.methods.checkPlain(str);
  };


  /**
   * Wrapper for i18n.methods.t()
   *
   * @see i18n.methods.t()
   * @throws InvalidArgumentException
   */
  i18n.t = function (str, options) {

    if (typeof str === 'string' && str.length > 0) {

      // check every time due language can change for
      // different reasons (translation, lang switcher ..)
      var language = i18n.getLanguage();

      options = options || {
        "context": language
      };

      return i18n.methods.t(str, options);
    }
    else {
      throw {
        "name": 'InvalidArgumentException',
        "message": 'First argument is either not a string or empty.'
      };
    }
  };

  // end i18n
  exports.i18n = i18n;
}(document, mejs));

// i18n fixes for compatibility with WordPress
; (function (exports, undefined) {

  "use strict";

  if (typeof mejsL10n != 'undefined') {
    exports[mejsL10n.language] = mejsL10n.strings;
  }

}(mejs.i18n.locale.strings));

/*!
 * This is a i18n.locale language object.
 *
 * German translation by Tim Latz, latz.tim@gmail.com
 *
 * @author
 *   Tim Latz (latz.tim@gmail.com)
 *
 * @see
 *   me-i18n.js
 *
 * @params
 *  - exports - CommonJS, window ..
 */
; (function (exports, undefined) {

  "use strict";

  if (typeof exports.de === 'undefined') {
    exports.de = {
      "Fullscreen": "Vollbild",
      "Go Fullscreen": "Vollbild an",
      "Turn off Fullscreen": "Vollbild aus",
      "Close": "Schließen"
    };
  }

}(mejs.i18n.locale.strings));
/*!
 * This is a i18n.locale language object.
 *
 * Traditional chinese translation by Tim Latz, latz.tim@gmail.com
 *
 * @author
 *   Tim Latz (latz.tim@gmail.com)
 *
 * @see
 *   me-i18n.js
 *
 * @params
 *  - exports - CommonJS, window ..
 */
; (function (exports, undefined) {

  "use strict";

  if (typeof exports.zh === 'undefined') {
    exports.zh = {
      "Fullscreen": "全螢幕",
      "Go Fullscreen": "全屏模式",
      "Turn off Fullscreen": "退出全屏模式",
      "Close": "關閉"
    };
  }

}(mejs.i18n.locale.strings));


/*!
 * MediaElementPlayer
 * http://mediaelementjs.com/
 *
 * Creates a controller bar for HTML5 <video> add <audio> tags
 * using jQuery and MediaElement.js (HTML5 Flash/Silverlight wrapper)
 *
 * Copyright 2010-2013, John Dyer (http://j.hn/)
 * License: MIT
 *
 */
if (typeof jQuery != 'undefined') {
  mejs.$ = jQuery;
} else if (typeof ender != 'undefined') {
  mejs.$ = ender;
}
(function ($) {

  // default player values
  mejs.MepDefaults = {
    // url to poster (to fix iOS 3.x)
    poster: '',
    // When the video is ended, we can show the poster.
    showPosterWhenEnded: false,
    // default if the <video width> is not specified
    defaultVideoWidth: 480,
    // default if the <video height> is not specified
    defaultVideoHeight: 270,
    // if set, overrides <video width>
    videoWidth: -1,
    // if set, overrides <video height>
    videoHeight: -1,
    // default if the user doesn't specify
    defaultAudioWidth: 400,
    // default if the user doesn't specify
    defaultAudioHeight: 30,

    // default amount to move back when back key is pressed
    defaultSeekBackwardInterval: function (media) {
      return (media.duration * 0.05);
    },
    // default amount to move forward when forward key is pressed
    defaultSeekForwardInterval: function (media) {
      return (media.duration * 0.05);
    },

    // width of audio player
    audioWidth: -1,
    // height of audio player
    audioHeight: -1,
    // initial volume when the player starts (overrided by user cookie)
    startVolume: 0.8,
    // useful for <audio> player loops
    loop: false,
    // rewind to beginning when media ends
    autoRewind: true,
    // resize to media dimensions
    enableAutosize: true,
    // forces the hour marker (##:00:00)
    alwaysShowHours: false,

    // show framecount in timecode (##:00:00:00)
    showTimecodeFrameCount: false,
    // used when showTimecodeFrameCount is set to true
    framesPerSecond: 25,

    // automatically calculate the width of the progress bar based on the sizes of other elements
    autosizeProgress: true,
    // Hide controls when playing and mouse is not over the video
    alwaysShowControls: false,
    // Display the video control
    hideVideoControlsOnLoad: false,
    // Enable click video element to toggle play/pause
    clickToPlayPause: true,
    // force iPad's native controls
    iPadUseNativeControls: false,
    // force iPhone's native controls
    iPhoneUseNativeControls: false,
    // force Android's native controls
    AndroidUseNativeControls: false,
    // features to show
    features: ['playpause', 'current', 'progress', 'duration', 'tracks', 'volume', 'fullscreen'],
    // only for dynamic
    isVideo: true,

    // turns keyboard support on and off for this instance
    enableKeyboard: true,

    // whenthis player starts, it will pause other players
    pauseOtherPlayers: true,

    // array of keyboard actions such as play pause
    keyActions: [
      {
        keys: [
          32, // SPACE
          179 // GOOGLE play/pause button
        ],
        action: function (player, media) {
          if (media.paused || media.ended) {
            player.play();
          } else {
            player.pause();
          }
        }
      },
      {
        keys: [38], // UP
        action: function (player, media) {
          var newVolume = Math.min(media.volume + 0.1, 1);
          media.setVolume(newVolume);
        }
      },
      {
        keys: [40], // DOWN
        action: function (player, media) {
          var newVolume = Math.max(media.volume - 0.1, 0);
          media.setVolume(newVolume);
        }
      },
      {
        keys: [
          37, // LEFT
          227 // Google TV rewind
        ],
        action: function (player, media) {
          if (!isNaN(media.duration) && media.duration > 0) {
            if (player.isVideo) {
              player.showControls();
              player.startControlsTimer();
            }

            // 5%
            var newTime = Math.max(media.currentTime - player.options.defaultSeekBackwardInterval(media), 0);
            media.setCurrentTime(newTime);
          }
        }
      },
      {
        keys: [
          39, // RIGHT
          228 // Google TV forward
        ],
        action: function (player, media) {
          if (!isNaN(media.duration) && media.duration > 0) {
            if (player.isVideo) {
              player.showControls();
              player.startControlsTimer();
            }

            // 5%
            var newTime = Math.min(media.currentTime + player.options.defaultSeekForwardInterval(media), media.duration);
            media.setCurrentTime(newTime);
          }
        }
      },
      {
        keys: [70], // f
        action: function (player, media) {
          if (typeof player.enterFullScreen != 'undefined') {
            if (player.isFullScreen) {
              player.exitFullScreen();
            } else {
              player.enterFullScreen();
            }
          }
        }
      }
    ]
  };

  mejs.mepIndex = 0;

  mejs.players = {};

  // wraps a MediaElement object in player controls
  mejs.MediaElementPlayer = function (node, o) {
    // enforce object, even without "new" (via John Resig)
    if (!(this instanceof mejs.MediaElementPlayer)) {
      return new mejs.MediaElementPlayer(node, o);
    }

    var t = this;

    // these will be reset after the MediaElement.success fires
    t.$media = t.$node = $(node);
    t.node = t.media = t.$media[0];

    // check for existing player
    if (typeof t.node.player != 'undefined') {
      return t.node.player;
    } else {
      // attach player to DOM node for reference
      t.node.player = t;
    }


    // try to get options from data-mejsoptions
    if (typeof o == 'undefined') {
      o = t.$node.data('mejsoptions');
    }

    // extend default options
    t.options = $.extend({}, mejs.MepDefaults, o);

    // unique ID
    t.id = 'mep_' + mejs.mepIndex++;

    // add to player array (for focus events)
    mejs.players[t.id] = t;

    // start up
    t.init();

    return t;
  };

  // actual player
  mejs.MediaElementPlayer.prototype = {

    hasFocus: false,

    controlsAreVisible: true,

    init: function () {

      var
        t = this,
        mf = mejs.MediaFeatures,
        // options for MediaElement (shim)
        meOptions = $.extend(true, {}, t.options, {
          success: function (media, domNode) { t.meReady(media, domNode); },
          error: function (e) { t.handleError(e); }
        }),
        tagName = t.media.tagName.toLowerCase();

      t.isDynamic = (tagName !== 'audio' && tagName !== 'video');

      if (t.isDynamic) {
        // get video from src or href?
        t.isVideo = t.options.isVideo;
      } else {
        t.isVideo = (tagName !== 'audio' && t.options.isVideo);
      }

      // use native controls in iPad, iPhone, and Android
      if ((mf.isiPad && t.options.iPadUseNativeControls) || (mf.isiPhone && t.options.iPhoneUseNativeControls)) {

        // add controls and stop
        t.$media.attr('controls', 'controls');

        // attempt to fix iOS 3 bug
        //t.$media.removeAttr('poster');
        // no Issue found on iOS3 -ttroxell

        // override Apple's autoplay override for iPads
        if (mf.isiPad && t.media.getAttribute('autoplay') !== null) {
          t.play();
        }

      } else if (mf.isAndroid && t.options.AndroidUseNativeControls) {

        // leave default player

      } else {

        // DESKTOP: use MediaElementPlayer controls

        // remove native controls
        t.$media.removeAttr('controls');

        // build container
        t.container =
          $('<div id="' + t.id + '" class="mejs-container ' + (mejs.MediaFeatures.svg ? 'svg' : 'no-svg') + '">' +
            '<div class="mejs-inner">' +
            '<div class="mejs-mediaelement"></div>' +
            '<div class="mejs-layers"></div>' +
            '<div class="mejs-controls"></div>' +
            '<div class="mejs-clear"></div>' +
            '</div>' +
            '</div>')
            .addClass(t.$media[0].className)
            .insertBefore(t.$media);

        // add classes for user and content
        t.container.addClass(
          (mf.isAndroid ? 'mejs-android ' : '') +
          (mf.isiOS ? 'mejs-ios ' : '') +
          (mf.isiPad ? 'mejs-ipad ' : '') +
          (mf.isiPhone ? 'mejs-iphone ' : '') +
          (t.isVideo ? 'mejs-video ' : 'mejs-audio ')
        );


        // move the <video/video> tag into the right spot
        if (mf.isiOS) {

          // sadly, you can't move nodes in iOS, so we have to destroy and recreate it!
          var $newMedia = t.$media.clone();

          t.container.find('.mejs-mediaelement').append($newMedia);

          t.$media.remove();
          t.$node = t.$media = $newMedia;
          t.node = t.media = $newMedia[0]

        } else {

          // normal way of moving it into place (doesn't work on iOS)
          t.container.find('.mejs-mediaelement').append(t.$media);
        }

        // find parts
        t.controls = t.container.find('.mejs-controls');
        t.layers = t.container.find('.mejs-layers');

        // determine the size

				/* size priority:
					(1) videoWidth (forced),
					(2) style="width;height;"
					(3) width attribute,
					(4) defaultVideoWidth (for unspecified cases)
				*/

        var tagType = (t.isVideo ? 'video' : 'audio'),
          capsTagName = tagType.substring(0, 1).toUpperCase() + tagType.substring(1);


        if (t.options[tagType + 'Width'] > 0 || t.options[tagType + 'Width'].toString().indexOf('%') > -1) {
          t.width = t.options[tagType + 'Width'];
        } else if (t.media.style.width !== '' && t.media.style.width !== null) {
          t.width = t.media.style.width;
        } else if (t.media.getAttribute('width') !== null) {
          t.width = t.$media.attr('width');
        } else {
          t.width = t.options['default' + capsTagName + 'Width'];
        }

        if (t.options[tagType + 'Height'] > 0 || t.options[tagType + 'Height'].toString().indexOf('%') > -1) {
          t.height = t.options[tagType + 'Height'];
        } else if (t.media.style.height !== '' && t.media.style.height !== null) {
          t.height = t.media.style.height;
        } else if (t.$media[0].getAttribute('height') !== null) {
          t.height = t.$media.attr('height');
        } else {
          t.height = t.options['default' + capsTagName + 'Height'];
        }

        // set the size, while we wait for the plugins to load below
        t.setPlayerSize(t.width, t.height);

        // create MediaElementShim
        meOptions.pluginWidth = t.width;
        meOptions.pluginHeight = t.height;
      }

      // create MediaElement shim
      mejs.MediaElement(t.$media[0], meOptions);

      if (typeof (t.container) != 'undefined' && t.controlsAreVisible) {
        // controls are shown when loaded
        t.container.trigger('controlsshown');
      }
    },

    showControls: function (doAnimation) {
      var t = this;

      doAnimation = typeof doAnimation == 'undefined' || doAnimation;

      if (t.controlsAreVisible)
        return;

      if (doAnimation) {
        t.controls
          .css('visibility', 'visible')
          .stop(true, true).fadeIn(200, function () {
            t.controlsAreVisible = true;
            t.container.trigger('controlsshown');
          });

        // any additional controls people might add and want to hide
        t.container.find('.mejs-control')
          .css('visibility', 'visible')
          .stop(true, true).fadeIn(200, function () { t.controlsAreVisible = true; });

      } else {
        t.controls
          .css('visibility', 'visible')
          .css('display', 'block');

        // any additional controls people might add and want to hide
        t.container.find('.mejs-control')
          .css('visibility', 'visible')
          .css('display', 'block');

        t.controlsAreVisible = true;
        t.container.trigger('controlsshown');
      }

      t.setControlsSize();

    },

    hideControls: function (doAnimation) {
      var t = this;

      doAnimation = typeof doAnimation == 'undefined' || doAnimation;

      if (!t.controlsAreVisible || t.options.alwaysShowControls)
        return;

      if (doAnimation) {
        // fade out main controls
        t.controls.stop(true, true).fadeOut(200, function () {
          $(this)
            .css('visibility', 'hidden')
            .css('display', 'block');

          t.controlsAreVisible = false;
          t.container.trigger('controlshidden');
        });

        // any additional controls people might add and want to hide
        t.container.find('.mejs-control').stop(true, true).fadeOut(200, function () {
          $(this)
            .css('visibility', 'hidden')
            .css('display', 'block');
        });
      } else {

        // hide main controls
        t.controls
          .css('visibility', 'hidden')
          .css('display', 'block');

        // hide others
        t.container.find('.mejs-control')
          .css('visibility', 'hidden')
          .css('display', 'block');

        t.controlsAreVisible = false;
        t.container.trigger('controlshidden');
      }
    },

    controlsTimer: null,

    startControlsTimer: function (timeout) {

      var t = this;

      timeout = typeof timeout != 'undefined' ? timeout : 1500;

      t.killControlsTimer('start');

      t.controlsTimer = setTimeout(function () {
        //
        t.hideControls();
        t.killControlsTimer('hide');
      }, timeout);
    },

    killControlsTimer: function (src) {

      var t = this;

      if (t.controlsTimer !== null) {
        clearTimeout(t.controlsTimer);
        delete t.controlsTimer;
        t.controlsTimer = null;
      }
    },

    controlsEnabled: true,

    disableControls: function () {
      var t = this;

      t.killControlsTimer();
      t.hideControls(false);
      this.controlsEnabled = false;
    },

    enableControls: function () {
      var t = this;

      t.showControls(false);

      t.controlsEnabled = true;
    },


    // Sets up all controls and events
    meReady: function (media, domNode) {


      var t = this,
        mf = mejs.MediaFeatures,
        autoplayAttr = domNode.getAttribute('autoplay'),
        autoplay = !(typeof autoplayAttr == 'undefined' || autoplayAttr === null || autoplayAttr === 'false'),
        featureIndex,
        feature;

      // make sure it can't create itself again if a plugin reloads
      if (t.created) {
        return;
      } else {
        t.created = true;
      }

      t.media = media;
      t.domNode = domNode;

      if (!(mf.isAndroid && t.options.AndroidUseNativeControls) && !(mf.isiPad && t.options.iPadUseNativeControls) && !(mf.isiPhone && t.options.iPhoneUseNativeControls)) {

        // two built in features
        t.buildposter(t, t.controls, t.layers, t.media);
        t.buildkeyboard(t, t.controls, t.layers, t.media);
        t.buildoverlays(t, t.controls, t.layers, t.media);

        // grab for use by features
        t.findTracks();

        // add user-defined features/controls
        for (featureIndex in t.options.features) {
          feature = t.options.features[featureIndex];
          if (t['build' + feature]) {
            try {
              t['build' + feature](t, t.controls, t.layers, t.media);
            } catch (e) {
              // TODO: report control error
              //throw e;


            }
          }
        }

        t.container.trigger('controlsready');

        // reset all layers and controls
        t.setPlayerSize(t.width, t.height);
        t.setControlsSize();


        // controls fade
        if (t.isVideo) {

          if (mejs.MediaFeatures.hasTouch) {

            // for touch devices (iOS, Android)
            // show/hide without animation on touch

            t.$media.bind('touchstart', function () {


              // toggle controls
              if (t.controlsAreVisible) {
                t.hideControls(false);
              } else {
                if (t.controlsEnabled) {
                  t.showControls(false);
                }
              }
            });

          } else {

            // create callback here since it needs access to current
            // MediaElement object
            t.clickToPlayPauseCallback = function () {
              //

              if (t.options.clickToPlayPause) {
                if (t.media.paused) {
                  t.play();
                } else {
                  t.pause();
                }
              }
            };

            // click to play/pause
            t.media.addEventListener('click', t.clickToPlayPauseCallback, false);

            // show/hide controls
            t.container
              .bind('mouseenter mouseover', function () {
                if (t.controlsEnabled) {
                  if (!t.options.alwaysShowControls) {
                    t.killControlsTimer('enter');
                    t.showControls();
                    t.startControlsTimer(2500);
                  }
                }
              })
              .bind('mousemove', function () {
                if (t.controlsEnabled) {
                  if (!t.controlsAreVisible) {
                    t.showControls();
                  }
                  //t.killControlsTimer('move');
                  if (!t.options.alwaysShowControls) {
                    t.startControlsTimer(2500);
                  }
                }
              })
              .bind('mouseleave', function () {
                if (t.controlsEnabled) {
                  if (!t.media.paused && !t.options.alwaysShowControls) {
                    t.startControlsTimer(1000);
                  }
                }
              });
          }

          if (t.options.hideVideoControlsOnLoad) {
            t.hideControls(false);
          }

          // check for autoplay
          if (autoplay && !t.options.alwaysShowControls) {
            t.hideControls();
          }

          // resizer
          if (t.options.enableAutosize) {
            t.media.addEventListener('loadedmetadata', function (e) {
              // if the <video height> was not set and the options.videoHeight was not set
              // then resize to the real dimensions
              if (t.options.videoHeight <= 0 && t.domNode.getAttribute('height') === null && !isNaN(e.target.videoHeight)) {
                t.setPlayerSize(e.target.videoWidth, e.target.videoHeight);
                t.setControlsSize();
                t.media.setVideoSize(e.target.videoWidth, e.target.videoHeight);
              }
            }, false);
          }
        }

        // EVENTS

        // FOCUS: when a video starts playing, it takes focus from other players (possibily pausing them)
        media.addEventListener('play', function () {
          var playerIndex;

          // go through all other players
          for (playerIndex in mejs.players) {
            var p = mejs.players[playerIndex];
            if (p.id != t.id && t.options.pauseOtherPlayers && !p.paused && !p.ended) {
              p.pause();
            }
            p.hasFocus = false;
          }

          t.hasFocus = true;
        }, false);


        // ended for all
        t.media.addEventListener('ended', function (e) {
          if (t.options.autoRewind) {
            try {
              t.media.setCurrentTime(0);
            } catch (exp) {

            }
          }
          t.media.pause();

          if (t.setProgressRail) {
            t.setProgressRail();
          }
          if (t.setCurrentRail) {
            t.setCurrentRail();
          }

          if (t.options.loop) {
            t.play();
          } else if (!t.options.alwaysShowControls && t.controlsEnabled) {
            t.showControls();
          }
        }, false);

        // resize on the first play
        t.media.addEventListener('loadedmetadata', function (e) {
          if (t.updateDuration) {
            t.updateDuration();
          }
          if (t.updateCurrent) {
            t.updateCurrent();
          }

          if (!t.isFullScreen) {
            t.setPlayerSize(t.width, t.height);
            t.setControlsSize();
          }
        }, false);


        // webkit has trouble doing this without a delay
        setTimeout(function () {
          t.setPlayerSize(t.width, t.height);
          t.setControlsSize();
        }, 50);

        // adjust controls whenever window sizes (used to be in fullscreen only)
        t.globalBind('resize', function () {

          // don't resize for fullscreen mode
          if (!(t.isFullScreen || (mejs.MediaFeatures.hasTrueNativeFullScreen && document.webkitIsFullScreen))) {
            t.setPlayerSize(t.width, t.height);
          }

          // always adjust controls
          t.setControlsSize();
        });

        // TEMP: needs to be moved somewhere else
        if (t.media.pluginType == 'youtube') {
          t.container.find('.mejs-overlay-play').hide();
        }
      }

      // force autoplay for HTML5
      if (autoplay && media.pluginType == 'native') {
        t.play();
      }


      if (t.options.success) {

        if (typeof t.options.success == 'string') {
          window[t.options.success](t.media, t.domNode, t);
        } else {
          t.options.success(t.media, t.domNode, t);
        }
      }
    },

    handleError: function (e) {
      var t = this;

      t.controls.hide();

      // Tell user that the file cannot be played
      if (t.options.error) {
        t.options.error(e);
      }
    },

    setPlayerSize: function (width, height) {
      var t = this;

      if (typeof width != 'undefined') {
        t.width = width;
      }

      if (typeof height != 'undefined') {
        t.height = height;
      }

      // detect 100% mode - use currentStyle for IE since css() doesn't return percentages
      if (t.height.toString().indexOf('%') > 0 || t.$node.css('max-width') === '100%' || parseInt(t.$node.css('max-width').replace(/px/, ''), 10) / t.$node.offsetParent().width() === 1 || (t.$node[0].currentStyle && t.$node[0].currentStyle.maxWidth === '100%')) {

        // do we have the native dimensions yet?
        var
          nativeWidth = t.isVideo ? ((t.media.videoWidth && t.media.videoWidth > 0) ? t.media.videoWidth : t.options.defaultVideoWidth) : t.options.defaultAudioWidth,
          nativeHeight = t.isVideo ? ((t.media.videoHeight && t.media.videoHeight > 0) ? t.media.videoHeight : t.options.defaultVideoHeight) : t.options.defaultAudioHeight,
          parentWidth = t.container.parent().closest(':visible').width(),
          newHeight = t.isVideo || !t.options.autosizeProgress ? parseInt(parentWidth * nativeHeight / nativeWidth, 10) : nativeHeight;

        // When we use percent, the newHeight can't be calculated so we get the container height
        if (isNaN(newHeight)) {
          newHeight = t.container.parent().closest(':visible').height();
        }

        if (t.container.parent()[0].tagName.toLowerCase() === 'body') { // && t.container.siblings().count == 0) {
          parentWidth = $(window).width();
          newHeight = $(window).height();
        }

        if (newHeight != 0 && parentWidth != 0) {
          // set outer container size
          t.container
            .width(parentWidth)
            .height(newHeight);

          // set native <video> or <audio> and shims
          t.$media.add(t.container.find('.mejs-shim'))
            .width('100%')
            .height('100%');

          // if shim is ready, send the size to the embeded plugin
          if (t.isVideo) {
            if (t.media.setVideoSize) {
              t.media.setVideoSize(parentWidth, newHeight);
            }
          }

          // set the layers
          t.layers.children('.mejs-layer')
            .width('100%')
            .height('100%');
        }


      } else {

        t.container
          .width(t.width)
          .height(t.height);

        t.layers.children('.mejs-layer')
          .width(t.width)
          .height(t.height);

      }

      // special case for big play button so it doesn't go over the controls area
      var playLayer = t.layers.find('.mejs-overlay-play'),
        playButton = playLayer.find('.mejs-overlay-button');

      playLayer.height(t.container.height() - t.controls.height());
      playButton.css('margin-top', '-' + (playButton.height() / 2 - t.controls.height() / 2).toString() + 'px');

    },

    setControlsSize: function () {
      var t = this,
        usedWidth = 0,
        railWidth = 0,
        rail = t.controls.find('.mejs-time-rail'),
        total = t.controls.find('.mejs-time-total'),
        current = t.controls.find('.mejs-time-current'),
        loaded = t.controls.find('.mejs-time-loaded'),
        others = rail.siblings(),
        lastControl = others.last(),
        lastControlPosition = null;

      // skip calculation if hidden
      if (!t.container.is(':visible') || !rail.length || !rail.is(':visible')) {
        return;
      }


      // allow the size to come from custom CSS
      if (t.options && !t.options.autosizeProgress) {
        // Also, frontends devs can be more flexible
        // due the opportunity of absolute positioning.
        railWidth = parseInt(rail.css('width'));
      }

      // attempt to autosize
      if (railWidth === 0 || !railWidth) {

        // find the size of all the other controls besides the rail
        others.each(function () {
          var $this = $(this);
          if ($this.css('position') != 'absolute' && $this.is(':visible')) {
            usedWidth += $(this).outerWidth(true);
          }
        });

        // fit the rail into the remaining space
        railWidth = t.controls.width() - usedWidth - (rail.outerWidth(true) - rail.width());
      }

      // resize the rail,
      // but then check if the last control (say, the fullscreen button) got pushed down
      // this often happens when zoomed
      do {
        // outer area
        rail.width(railWidth);
        // dark space
        total.width(railWidth - (total.outerWidth(true) - total.width()));

        if (lastControl.css('position') != 'absolute') {
          lastControlPosition = lastControl.position();
          railWidth--;
        }
      } while (lastControlPosition != null && lastControlPosition.top > 0 && railWidth > 0);

      if (t.setProgressRail)
        t.setProgressRail();
      if (t.setCurrentRail)
        t.setCurrentRail();
    },


    buildposter: function (player, controls, layers, media) {
      var t = this,
        poster =
          $('<div class="mejs-poster mejs-layer">' +
            '</div>')
            .appendTo(layers),
        posterUrl = player.$media.attr('poster');

      // prioriy goes to option (this is useful if you need to support iOS 3.x (iOS completely fails with poster)
      if (player.options.poster !== '') {
        posterUrl = player.options.poster;
      }

      // second, try the real poster
      if (posterUrl !== '' && posterUrl != null) {
        t.setPoster(posterUrl);
      } else {
        poster.hide();
      }

      media.addEventListener('play', function () {
        poster.hide();
      }, false);

      if (player.options.showPosterWhenEnded && player.options.autoRewind) {
        media.addEventListener('ended', function () {
          poster.show();
        }, false);
      }
    },

    setPoster: function (url) {
      var t = this,
        posterDiv = t.container.find('.mejs-poster'),
        posterImg = posterDiv.find('img');

      if (posterImg.length == 0) {
        posterImg = $('<img width="100%" height="100%" />').appendTo(posterDiv);
      }

      posterImg.attr('src', url);
      posterDiv.css({ 'background-image': 'url(' + url + ')' });
    },

    buildoverlays: function (player, controls, layers, media) {
      var t = this;
      if (!player.isVideo)
        return;

      var
        loading =
          $('<div class="mejs-overlay mejs-layer">' +
            '<div class="mejs-overlay-loading"><span></span></div>' +
            '</div>')
            .hide() // start out hidden
            .appendTo(layers),
        error =
          $('<div class="mejs-overlay mejs-layer">' +
            '<div class="mejs-overlay-error"></div>' +
            '</div>')
            .hide() // start out hidden
            .appendTo(layers),
        // this needs to come last so it's on top
        bigPlay =
          $('<div class="mejs-overlay mejs-layer mejs-overlay-play">' +
            '<div class="mejs-overlay-button"></div>' +
            '</div>')
            .appendTo(layers)
            .bind('click touchstart', function () {
              if (t.options.clickToPlayPause) {
                if (media.paused) {
                  media.play();
                }
              }
            });

			/*
			if (mejs.MediaFeatures.isiOS || mejs.MediaFeatures.isAndroid) {
				bigPlay.remove();
				loading.remove();
			}
			*/


      // show/hide big play button
      media.addEventListener('play', function () {
        bigPlay.hide();
        loading.hide();
        controls.find('.mejs-time-buffering').hide();
        error.hide();
      }, false);

      media.addEventListener('playing', function () {
        bigPlay.hide();
        loading.hide();
        controls.find('.mejs-time-buffering').hide();
        error.hide();
      }, false);

      media.addEventListener('seeking', function () {
        loading.show();
        controls.find('.mejs-time-buffering').show();
      }, false);

      media.addEventListener('seeked', function () {
        loading.hide();
        controls.find('.mejs-time-buffering').hide();
      }, false);

      media.addEventListener('pause', function () {
        if (!mejs.MediaFeatures.isiPhone) {
          bigPlay.show();
        }
      }, false);

      media.addEventListener('waiting', function () {
        loading.show();
        controls.find('.mejs-time-buffering').show();
      }, false);


      // show/hide loading
      media.addEventListener('loadeddata', function () {
        // for some reason Chrome is firing this event
        //if (mejs.MediaFeatures.isChrome && media.getAttribute && media.getAttribute('preload') === 'none')
        //	return;

        loading.show();
        controls.find('.mejs-time-buffering').show();
      }, false);
      media.addEventListener('canplay', function () {
        loading.hide();
        controls.find('.mejs-time-buffering').hide();
      }, false);

      // error handling
      media.addEventListener('error', function () {
        loading.hide();
        controls.find('.mejs-time-buffering').hide();
        error.show();
        error.find('mejs-overlay-error').html("Error loading this resource");
      }, false);
    },

    buildkeyboard: function (player, controls, layers, media) {

      var t = this;

      // listen for key presses
      t.globalBind('keydown', function (e) {

        if (player.hasFocus && player.options.enableKeyboard) {

          // find a matching key
          for (var i = 0, il = player.options.keyActions.length; i < il; i++) {
            var keyAction = player.options.keyActions[i];

            for (var j = 0, jl = keyAction.keys.length; j < jl; j++) {
              if (e.keyCode == keyAction.keys[j]) {
                e.preventDefault();
                keyAction.action(player, media, e.keyCode);
                return false;
              }
            }
          }
        }

        return true;
      });

      // check if someone clicked outside a player region, then kill its focus
      t.globalBind('click', function (event) {
        player.hasFocus = $(event.target).closest('.mejs-container').length != 0;
      });

    },

    findTracks: function () {
      var t = this,
        tracktags = t.$media.find('track');

      // store for use by plugins
      t.tracks = [];
      tracktags.each(function (index, track) {

        track = $(track);

        t.tracks.push({
          srclang: (track.attr('srclang')) ? track.attr('srclang').toLowerCase() : '',
          src: track.attr('src'),
          kind: track.attr('kind'),
          label: track.attr('label') || '',
          entries: [],
          isLoaded: false
        });
      });
    },
    changeSkin: function (className) {
      this.container[0].className = 'mejs-container ' + className;
      this.setPlayerSize(this.width, this.height);
      this.setControlsSize();
    },
    play: function () {
      this.load();
      this.media.play();
    },
    pause: function () {
      try {
        this.media.pause();
      } catch (e) { }
    },
    load: function () {
      if (!this.isLoaded) {
        this.media.load();
      }

      this.isLoaded = true;
    },
    setMuted: function (muted) {
      this.media.setMuted(muted);
    },
    setCurrentTime: function (time) {
      this.media.setCurrentTime(time);
    },
    getCurrentTime: function () {
      return this.media.currentTime;
    },
    setVolume: function (volume) {
      this.media.setVolume(volume);
    },
    getVolume: function () {
      return this.media.volume;
    },
    setSrc: function (src) {
      this.media.setSrc(src);
    },
    remove: function () {
      var t = this, featureIndex, feature;

      // invoke features cleanup
      for (featureIndex in t.options.features) {
        feature = t.options.features[featureIndex];
        if (t['clean' + feature]) {
          try {
            t['clean' + feature](t);
          } catch (e) {
            // TODO: report control error
            //throw e;
            //
            //
          }
        }
      }

      // grab video and put it back in place
      if (!t.isDynamic) {
        t.$media.prop('controls', true);
        // detach events from the video
        // TODO: detach event listeners better than this;
        //       also detach ONLY the events attached by this plugin!
        t.$node.clone().show().insertBefore(t.container);
        t.$node.remove();
      } else {
        t.$node.insertBefore(t.container);
      }

      if (t.media.pluginType !== 'native') {
        t.media.remove();
      }

      // Remove the player from the mejs.players object so that pauseOtherPlayers doesn't blow up when trying to pause a non existance flash api.
      delete mejs.players[t.id];

      if (typeof t.container == 'object') {
        t.container.remove();
      }
      t.globalUnbind();
      delete t.node.player;
    }
  };

  (function () {
    var rwindow = /^((after|before)print|(before)?unload|hashchange|message|o(ff|n)line|page(hide|show)|popstate|resize|storage)\b/;

    function splitEvents(events, id) {
      // add player ID as an event namespace so it's easier to unbind them all later
      var ret = { d: [], w: [] };
      $.each((events || '').split(' '), function (k, v) {
        var eventname = v + '.' + id;
        if (eventname.indexOf('.') === 0) {
          ret.d.push(eventname);
          ret.w.push(eventname);
        }
        else {
          ret[rwindow.test(v) ? 'w' : 'd'].push(eventname);
        }
      });
      ret.d = ret.d.join(' ');
      ret.w = ret.w.join(' ');
      return ret;
    }

    mejs.MediaElementPlayer.prototype.globalBind = function (events, data, callback) {
      var t = this;
      events = splitEvents(events, t.id);
      if (events.d) $(document).bind(events.d, data, callback);
      if (events.w) $(window).bind(events.w, data, callback);
    };

    mejs.MediaElementPlayer.prototype.globalUnbind = function (events, callback) {
      var t = this;
      events = splitEvents(events, t.id);
      if (events.d) $(document).unbind(events.d, callback);
      if (events.w) $(window).unbind(events.w, callback);
    };
  })();

  // turn into jQuery plugin
  if (typeof jQuery != 'undefined') {
    jQuery.fn.mediaelementplayer = function (options) {
      if (options === false) {
        this.each(function () {
          var player = jQuery(this).data('mediaelementplayer');
          if (player) {
            player.remove();
          }
          jQuery(this).removeData('mediaelementplayer');
        });
      }
      else {
        this.each(function () {
          jQuery(this).data('mediaelementplayer', new mejs.MediaElementPlayer(this, options));
        });
      }
      return this;
    };
  }

  $(document).ready(function () {
    // auto enable using JSON attribute
    $('.mejs-player').mediaelementplayer();
  });

  // push out to window
  window.MediaElementPlayer = mejs.MediaElementPlayer;

})(mejs.$);

(function ($) {

  $.extend(mejs.MepDefaults, {
    playpauseText: mejs.i18n.t('Play/Pause')
  });

  // PLAY/pause BUTTON
  $.extend(MediaElementPlayer.prototype, {
    buildplaypause: function (player, controls, layers, media) {
      var
        t = this,
        play =
          $('<div class="mejs-button mejs-playpause-button mejs-play" >' +
            '<button type="button" aria-controls="' + t.id + '" title="' + t.options.playpauseText + '" aria-label="' + t.options.playpauseText + '"></button>' +
            '</div>')
            .appendTo(controls)
            .click(function (e) {
              e.preventDefault();

              if (media.paused) {
                media.play();
              } else {
                media.pause();
              }

              return false;
            });

      media.addEventListener('play', function () {
        play.removeClass('mejs-play').addClass('mejs-pause');
      }, false);
      media.addEventListener('playing', function () {
        play.removeClass('mejs-play').addClass('mejs-pause');
      }, false);


      media.addEventListener('pause', function () {
        play.removeClass('mejs-pause').addClass('mejs-play');
      }, false);
      media.addEventListener('paused', function () {
        play.removeClass('mejs-pause').addClass('mejs-play');
      }, false);
    }
  });

})(mejs.$);

(function ($) {

  $.extend(mejs.MepDefaults, {
    stopText: 'Stop'
  });

  // STOP BUTTON
  $.extend(MediaElementPlayer.prototype, {
    buildstop: function (player, controls, layers, media) {
      var t = this,
        stop =
          $('<div class="mejs-button mejs-stop-button mejs-stop">' +
            '<button type="button" aria-controls="' + t.id + '" title="' + t.options.stopText + '" aria-label="' + t.options.stopText + '"></button>' +
            '</div>')
            .appendTo(controls)
            .click(function () {
              if (!media.paused) {
                media.pause();
              }
              if (media.currentTime > 0) {
                media.setCurrentTime(0);
                media.pause();
                controls.find('.mejs-time-current').width('0px');
                controls.find('.mejs-time-handle').css('left', '0px');
                controls.find('.mejs-time-float-current').html(mejs.Utility.secondsToTimeCode(0));
                controls.find('.mejs-currenttime').html(mejs.Utility.secondsToTimeCode(0));
                layers.find('.mejs-poster').show();
              }
            });
    }
  });

})(mejs.$);

(function ($) {
  // progress/loaded bar
  $.extend(MediaElementPlayer.prototype, {
    buildprogress: function (player, controls, layers, media) {

      $('<div class="mejs-time-rail">' +
        '<span class="mejs-time-total">' +
        '<span class="mejs-time-buffering"></span>' +
        '<span class="mejs-time-loaded"></span>' +
        '<span class="mejs-time-current"></span>' +
        '<span class="mejs-time-handle"></span>' +
        '<span class="mejs-time-float">' +
        '<span class="mejs-time-float-current">00:00</span>' +
        '<span class="mejs-time-float-corner"></span>' +
        '</span>' +
        '</span>' +
        '</div>')
        .appendTo(controls);
      controls.find('.mejs-time-buffering').hide();

      var
        t = this,
        total = controls.find('.mejs-time-total'),
        loaded = controls.find('.mejs-time-loaded'),
        current = controls.find('.mejs-time-current'),
        handle = controls.find('.mejs-time-handle'),
        timefloat = controls.find('.mejs-time-float'),
        timefloatcurrent = controls.find('.mejs-time-float-current'),
        handleMouseMove = function (e) {
          // mouse or touch position relative to the object
          if (e.originalEvent.changedTouches) {
            var x = e.originalEvent.changedTouches[0].pageX;
          } else {
            var x = e.pageX;
          }

          var offset = total.offset(),
            width = total.outerWidth(true),
            percentage = 0,
            newTime = 0,
            pos = 0;


          if (media.duration) {
            if (x < offset.left) {
              x = offset.left;
            } else if (x > width + offset.left) {
              x = width + offset.left;
            }

            pos = x - offset.left;
            percentage = (pos / width);
            newTime = (percentage <= 0.02) ? 0 : percentage * media.duration;

            // seek to where the mouse is
            if (mouseIsDown && newTime !== media.currentTime) {
              media.setCurrentTime(newTime);
            }

            // position floating time box
            if (!mejs.MediaFeatures.hasTouch) {
              timefloat.css('left', pos);
              timefloatcurrent.html(mejs.Utility.secondsToTimeCode(newTime));
              timefloat.show();
            }
          }
        },
        mouseIsDown = false,
        mouseIsOver = false;

      // handle clicks
      //controls.find('.mejs-time-rail').delegate('span', 'click', handleMouseMove);
      total
        .bind('mousedown touchstart', function (e) {
          // only handle left clicks or touch
          if (e.which === 1 || e.which === 0) {
            mouseIsDown = true;
            handleMouseMove(e);
            t.globalBind('mousemove.dur touchmove.dur', function (e) {
              handleMouseMove(e);
            });
            t.globalBind('mouseup.dur touchend.dur', function (e) {
              mouseIsDown = false;
              timefloat.hide();
              t.globalUnbind('.dur');
            });
            return false;
          }
        })
        .bind('mouseenter', function (e) {
          mouseIsOver = true;
          t.globalBind('mousemove.dur', function (e) {
            handleMouseMove(e);
          });
          if (!mejs.MediaFeatures.hasTouch) {
            timefloat.show();
          }
        })
        .bind('mouseleave', function (e) {
          mouseIsOver = false;
          if (!mouseIsDown) {
            t.globalUnbind('.dur');
            timefloat.hide();
          }
        });

      // loading
      media.addEventListener('progress', function (e) {
        player.setProgressRail(e);
        player.setCurrentRail(e);
      }, false);

      // current time
      media.addEventListener('timeupdate', function (e) {
        player.setProgressRail(e);
        player.setCurrentRail(e);
      }, false);


      // store for later use
      t.loaded = loaded;
      t.total = total;
      t.current = current;
      t.handle = handle;
    },
    setProgressRail: function (e) {

      var
        t = this,
        target = (e != undefined) ? e.target : t.media,
        percent = null;

      // newest HTML5 spec has buffered array (FF4, Webkit)
      if (target && target.buffered && target.buffered.length > 0 && target.buffered.end && target.duration) {
        // TODO: account for a real array with multiple values (only Firefox 4 has this so far) 
        percent = target.buffered.end(0) / target.duration;
      }
      // Some browsers (e.g., FF3.6 and Safari 5) cannot calculate target.bufferered.end()
      // to be anything other than 0. If the byte count is available we use this instead.
      // Browsers that support the else if do not seem to have the bufferedBytes value and
      // should skip to there. Tested in Safari 5, Webkit head, FF3.6, Chrome 6, IE 7/8.
      else if (target && target.bytesTotal != undefined && target.bytesTotal > 0 && target.bufferedBytes != undefined) {
        percent = target.bufferedBytes / target.bytesTotal;
      }
      // Firefox 3 with an Ogg file seems to go this way
      else if (e && e.lengthComputable && e.total != 0) {
        percent = e.loaded / e.total;
      }

      // finally update the progress bar
      if (percent !== null) {
        percent = Math.min(1, Math.max(0, percent));
        // update loaded bar
        if (t.loaded && t.total) {
          t.loaded.width(t.total.width() * percent);
        }
      }
    },
    setCurrentRail: function () {

      var t = this;

      if (t.media.currentTime != undefined && t.media.duration) {

        // update bar and handle
        if (t.total && t.handle) {
          var
            newWidth = Math.round(t.total.width() * t.media.currentTime / t.media.duration),
            handlePos = newWidth - Math.round(t.handle.outerWidth(true) / 2);

          t.current.width(newWidth);
          t.handle.css('left', handlePos);
        }
      }

    }
  });
})(mejs.$);

(function ($) {

  // options
  $.extend(mejs.MepDefaults, {
    duration: -1,
    timeAndDurationSeparator: '<span> | </span>'
  });


  // current and duration 00:00 / 00:00
  $.extend(MediaElementPlayer.prototype, {
    buildcurrent: function (player, controls, layers, media) {
      var t = this;

      $('<div class="mejs-time">' +
        '<span class="mejs-currenttime">' + (player.options.alwaysShowHours ? '00:' : '')
        + (player.options.showTimecodeFrameCount ? '00:00:00' : '00:00') + '</span>' +
        '</div>')
        .appendTo(controls);

      t.currenttime = t.controls.find('.mejs-currenttime');

      media.addEventListener('timeupdate', function () {
        player.updateCurrent();
      }, false);
    },


    buildduration: function (player, controls, layers, media) {
      var t = this;

      if (controls.children().last().find('.mejs-currenttime').length > 0) {
        $(t.options.timeAndDurationSeparator +
          '<span class="mejs-duration">' +
          (t.options.duration > 0 ?
            mejs.Utility.secondsToTimeCode(t.options.duration, t.options.alwaysShowHours || t.media.duration > 3600, t.options.showTimecodeFrameCount, t.options.framesPerSecond || 25) :
            ((player.options.alwaysShowHours ? '00:' : '') + (player.options.showTimecodeFrameCount ? '00:00:00' : '00:00'))
          ) +
          '</span>')
          .appendTo(controls.find('.mejs-time'));
      } else {

        // add class to current time
        controls.find('.mejs-currenttime').parent().addClass('mejs-currenttime-container');

        $('<div class="mejs-time mejs-duration-container">' +
          '<span class="mejs-duration">' +
          (t.options.duration > 0 ?
            mejs.Utility.secondsToTimeCode(t.options.duration, t.options.alwaysShowHours || t.media.duration > 3600, t.options.showTimecodeFrameCount, t.options.framesPerSecond || 25) :
            ((player.options.alwaysShowHours ? '00:' : '') + (player.options.showTimecodeFrameCount ? '00:00:00' : '00:00'))
          ) +
          '</span>' +
          '</div>')
          .appendTo(controls);
      }

      t.durationD = t.controls.find('.mejs-duration');

      media.addEventListener('timeupdate', function () {
        player.updateDuration();
      }, false);
    },

    updateCurrent: function () {
      var t = this;

      if (t.currenttime) {
        t.currenttime.html(mejs.Utility.secondsToTimeCode(t.media.currentTime, t.options.alwaysShowHours || t.media.duration > 3600, t.options.showTimecodeFrameCount, t.options.framesPerSecond || 25));
      }
    },

    updateDuration: function () {
      var t = this;

      //Toggle the long video class if the video is longer than an hour.
      t.container.toggleClass("mejs-long-video", t.media.duration > 3600);

      if (t.durationD && (t.options.duration > 0 || t.media.duration)) {
        t.durationD.html(mejs.Utility.secondsToTimeCode(t.options.duration > 0 ? t.options.duration : t.media.duration, t.options.alwaysShowHours, t.options.showTimecodeFrameCount, t.options.framesPerSecond || 25));
      }
    }
  });

})(mejs.$);

(function ($) {

  $.extend(mejs.MepDefaults, {
    muteText: mejs.i18n.t('Mute Toggle'),
    hideVolumeOnTouchDevices: true,

    audioVolume: 'horizontal',
    videoVolume: 'vertical'
  });

  $.extend(MediaElementPlayer.prototype, {
    buildvolume: function (player, controls, layers, media) {

      // Android and iOS don't support volume controls
      if ((mejs.MediaFeatures.isAndroid || mejs.MediaFeatures.isiOS) && this.options.hideVolumeOnTouchDevices)
        return;

      var t = this,
        mode = (t.isVideo) ? t.options.videoVolume : t.options.audioVolume,
        mute = (mode == 'horizontal') ?

          // horizontal version
          $('<div class="mejs-button mejs-volume-button mejs-mute">' +
            '<button type="button" aria-controls="' + t.id + '" title="' + t.options.muteText + '" aria-label="' + t.options.muteText + '"></button>' +
            '</div>' +
            '<div class="mejs-horizontal-volume-slider">' + // outer background
            '<div class="mejs-horizontal-volume-total"></div>' + // line background
            '<div class="mejs-horizontal-volume-current"></div>' + // current volume
            '<div class="mejs-horizontal-volume-handle"></div>' + // handle
            '</div>'
          )
            .appendTo(controls) :

          // vertical version
          $('<div class="mejs-button mejs-volume-button mejs-mute">' +
            '<button type="button" aria-controls="' + t.id + '" title="' + t.options.muteText + '" aria-label="' + t.options.muteText + '"></button>' +
            '<div class="mejs-volume-slider">' + // outer background
            '<div class="mejs-volume-total"></div>' + // line background
            '<div class="mejs-volume-current"></div>' + // current volume
            '<div class="mejs-volume-handle"></div>' + // handle
            '</div>' +
            '</div>')
            .appendTo(controls),
        volumeSlider = t.container.find('.mejs-volume-slider, .mejs-horizontal-volume-slider'),
        volumeTotal = t.container.find('.mejs-volume-total, .mejs-horizontal-volume-total'),
        volumeCurrent = t.container.find('.mejs-volume-current, .mejs-horizontal-volume-current'),
        volumeHandle = t.container.find('.mejs-volume-handle, .mejs-horizontal-volume-handle'),

        positionVolumeHandle = function (volume, secondTry) {

          if (!volumeSlider.is(':visible') && typeof secondTry == 'undefined') {
            volumeSlider.show();
            positionVolumeHandle(volume, true);
            volumeSlider.hide()
            return;
          }

          // correct to 0-1
          volume = Math.max(0, volume);
          volume = Math.min(volume, 1);

          // ajust mute button style
          if (volume == 0) {
            mute.removeClass('mejs-mute').addClass('mejs-unmute');
          } else {
            mute.removeClass('mejs-unmute').addClass('mejs-mute');
          }

          // position slider 
          if (mode == 'vertical') {
            var

              // height of the full size volume slider background
              totalHeight = volumeTotal.height(),

              // top/left of full size volume slider background
              totalPosition = volumeTotal.position(),

              // the new top position based on the current volume
              // 70% volume on 100px height == top:30px
              newTop = totalHeight - (totalHeight * volume);

            // handle
            volumeHandle.css('top', Math.round(totalPosition.top + newTop - (volumeHandle.height() / 2)));

            // show the current visibility
            volumeCurrent.height(totalHeight - newTop);
            volumeCurrent.css('top', totalPosition.top + newTop);
          } else {
            var

              // height of the full size volume slider background
              totalWidth = volumeTotal.width(),

              // top/left of full size volume slider background
              totalPosition = volumeTotal.position(),

              // the new left position based on the current volume
              newLeft = totalWidth * volume;

            // handle
            volumeHandle.css('left', Math.round(totalPosition.left + newLeft - (volumeHandle.width() / 2)));

            // rezize the current part of the volume bar
            volumeCurrent.width(Math.round(newLeft));
          }
        },
        handleVolumeMove = function (e) {

          var volume = null,
            totalOffset = volumeTotal.offset();

          // calculate the new volume based on the moust position
          if (mode == 'vertical') {

            var
              railHeight = volumeTotal.height(),
              totalTop = parseInt(volumeTotal.css('top').replace(/px/, ''), 10),
              newY = e.pageY - totalOffset.top;

            volume = (railHeight - newY) / railHeight;

            // the controls just hide themselves (usually when mouse moves too far up)
            if (totalOffset.top == 0 || totalOffset.left == 0)
              return;

          } else {
            var
              railWidth = volumeTotal.width(),
              newX = e.pageX - totalOffset.left;

            volume = newX / railWidth;
          }

          // ensure the volume isn't outside 0-1
          volume = Math.max(0, volume);
          volume = Math.min(volume, 1);

          // position the slider and handle			
          positionVolumeHandle(volume);

          // set the media object (this will trigger the volumechanged event)
          if (volume == 0) {
            media.setMuted(true);
          } else {
            media.setMuted(false);
          }
          media.setVolume(volume);
        },
        mouseIsDown = false,
        mouseIsOver = false;

      // SLIDER

      mute
        .hover(function () {
          volumeSlider.show();
          mouseIsOver = true;
        }, function () {
          mouseIsOver = false;

          if (!mouseIsDown && mode == 'vertical') {
            volumeSlider.hide();
          }
        });

      volumeSlider
        .bind('mouseover', function () {
          mouseIsOver = true;
        })
        .bind('mousedown', function (e) {
          handleVolumeMove(e);
          t.globalBind('mousemove.vol', function (e) {
            handleVolumeMove(e);
          });
          t.globalBind('mouseup.vol', function () {
            mouseIsDown = false;
            t.globalUnbind('.vol');

            if (!mouseIsOver && mode == 'vertical') {
              volumeSlider.hide();
            }
          });
          mouseIsDown = true;

          return false;
        });


      // MUTE button
      mute.find('button').click(function () {
        media.setMuted(!media.muted);
      });

      // listen for volume change events from other sources
      media.addEventListener('volumechange', function (e) {
        if (!mouseIsDown) {
          if (media.muted) {
            positionVolumeHandle(0);
            mute.removeClass('mejs-mute').addClass('mejs-unmute');
          } else {
            positionVolumeHandle(media.volume);
            mute.removeClass('mejs-unmute').addClass('mejs-mute');
          }
        }
      }, false);

      if (t.container.is(':visible')) {
        // set initial volume
        positionVolumeHandle(player.options.startVolume);

        // mutes the media and sets the volume icon muted if the initial volume is set to 0
        if (player.options.startVolume === 0) {
          media.setMuted(true);
        }

        // shim gets the startvolume as a parameter, but we have to set it on the native <video> and <audio> elements
        if (media.pluginType === 'native') {
          media.setVolume(player.options.startVolume);
        }
      }
    }
  });

})(mejs.$);

(function ($) {

  $.extend(mejs.MepDefaults, {
    usePluginFullScreen: true,
    newWindowCallback: function () { return ''; },
    fullscreenText: mejs.i18n.t('Fullscreen')
  });

  $.extend(MediaElementPlayer.prototype, {

    isFullScreen: false,

    isNativeFullScreen: false,

    isInIframe: false,

    buildfullscreen: function (player, controls, layers, media) {

      if (!player.isVideo)
        return;

      player.isInIframe = (window.location != window.parent.location);

      // native events
      if (mejs.MediaFeatures.hasTrueNativeFullScreen) {

        // chrome doesn't alays fire this in an iframe
        var func = function (e) {
          if (player.isFullScreen) {
            if (mejs.MediaFeatures.isFullScreen()) {
              player.isNativeFullScreen = true;
              // reset the controls once we are fully in full screen
              player.setControlsSize();
            } else {
              player.isNativeFullScreen = false;
              // when a user presses ESC
              // make sure to put the player back into place
              player.exitFullScreen();
            }
          }
        };

        if (mejs.MediaFeatures.hasMozNativeFullScreen) {
          player.globalBind(mejs.MediaFeatures.fullScreenEventName, func);
        } else {
          player.container.bind(mejs.MediaFeatures.fullScreenEventName, func);
        }
      }

      var t = this,
        normalHeight = 0,
        normalWidth = 0,
        container = player.container,
        fullscreenBtn =
          $('<div class="mejs-button mejs-fullscreen-button">' +
            '<button type="button" aria-controls="' + t.id + '" title="' + t.options.fullscreenText + '" aria-label="' + t.options.fullscreenText + '"></button>' +
            '</div>')
            .appendTo(controls);

      if (t.media.pluginType === 'native' || (!t.options.usePluginFullScreen && !mejs.MediaFeatures.isFirefox)) {

        fullscreenBtn.click(function () {
          var isFullScreen = (mejs.MediaFeatures.hasTrueNativeFullScreen && mejs.MediaFeatures.isFullScreen()) || player.isFullScreen;

          if (isFullScreen) {
            player.exitFullScreen();
          } else {
            player.enterFullScreen();
          }
        });

      } else {

        var hideTimeout = null,
          supportsPointerEvents = (function () {
            // TAKEN FROM MODERNIZR
            var element = document.createElement('x'),
              documentElement = document.documentElement,
              getComputedStyle = window.getComputedStyle,
              supports;
            if (!('pointerEvents' in element.style)) {
              return false;
            }
            element.style.pointerEvents = 'auto';
            element.style.pointerEvents = 'x';
            documentElement.appendChild(element);
            supports = getComputedStyle &&
              getComputedStyle(element, '').pointerEvents === 'auto';
            documentElement.removeChild(element);
            return !!supports;
          })();

        //

        if (supportsPointerEvents && !mejs.MediaFeatures.isOpera) { // opera doesn't allow this :(

          // allows clicking through the fullscreen button and controls down directly to Flash

          /*
           When a user puts his mouse over the fullscreen button, the controls are disabled
           So we put a div over the video and another one on iether side of the fullscreen button
           that caputre mouse movement
           and restore the controls once the mouse moves outside of the fullscreen button
          */

          var fullscreenIsDisabled = false,
            restoreControls = function () {
              if (fullscreenIsDisabled) {
                // hide the hovers
                for (var i in hoverDivs) {
                  hoverDivs[i].hide();
                }

                // restore the control bar
                fullscreenBtn.css('pointer-events', '');
                t.controls.css('pointer-events', '');

                // prevent clicks from pausing video
                t.media.removeEventListener('click', t.clickToPlayPauseCallback);

                // store for later
                fullscreenIsDisabled = false;
              }
            },
            hoverDivs = {},
            hoverDivNames = ['top', 'left', 'right', 'bottom'],
            i, len,
            positionHoverDivs = function () {
              var fullScreenBtnOffsetLeft = fullscreenBtn.offset().left - t.container.offset().left,
                fullScreenBtnOffsetTop = fullscreenBtn.offset().top - t.container.offset().top,
                fullScreenBtnWidth = fullscreenBtn.outerWidth(true),
                fullScreenBtnHeight = fullscreenBtn.outerHeight(true),
                containerWidth = t.container.width(),
                containerHeight = t.container.height();

              for (i in hoverDivs) {
                hoverDivs[i].css({ position: 'absolute', top: 0, left: 0 }); //, backgroundColor: '#f00'});
              }

              // over video, but not controls
              hoverDivs['top']
                .width(containerWidth)
                .height(fullScreenBtnOffsetTop);

              // over controls, but not the fullscreen button
              hoverDivs['left']
                .width(fullScreenBtnOffsetLeft)
                .height(fullScreenBtnHeight)
                .css({ top: fullScreenBtnOffsetTop });

              // after the fullscreen button
              hoverDivs['right']
                .width(containerWidth - fullScreenBtnOffsetLeft - fullScreenBtnWidth)
                .height(fullScreenBtnHeight)
                .css({
                  top: fullScreenBtnOffsetTop,
                  left: fullScreenBtnOffsetLeft + fullScreenBtnWidth
                });

              // under the fullscreen button
              hoverDivs['bottom']
                .width(containerWidth)
                .height(containerHeight - fullScreenBtnHeight - fullScreenBtnOffsetTop)
                .css({ top: fullScreenBtnOffsetTop + fullScreenBtnHeight });
            };

          t.globalBind('resize', function () {
            positionHoverDivs();
          });

          for (i = 0, len = hoverDivNames.length; i < len; i++) {
            hoverDivs[hoverDivNames[i]] = $('<div class="mejs-fullscreen-hover" />').appendTo(t.container).mouseover(restoreControls).hide();
          }

          // on hover, kill the fullscreen button's HTML handling, allowing clicks down to Flash
          fullscreenBtn.on('mouseover', function () {

            if (!t.isFullScreen) {

              var buttonPos = fullscreenBtn.offset(),
                containerPos = player.container.offset();

              // move the button in Flash into place
              media.positionFullscreenButton(buttonPos.left - containerPos.left, buttonPos.top - containerPos.top, false);

              // allows click through
              fullscreenBtn.css('pointer-events', 'none');
              t.controls.css('pointer-events', 'none');

              // restore click-to-play
              t.media.addEventListener('click', t.clickToPlayPauseCallback);

              // show the divs that will restore things
              for (i in hoverDivs) {
                hoverDivs[i].show();
              }

              positionHoverDivs();

              fullscreenIsDisabled = true;
            }

          });

          // restore controls anytime the user enters or leaves fullscreen
          media.addEventListener('fullscreenchange', function (e) {
            t.isFullScreen = !t.isFullScreen;
            // don't allow plugin click to pause video - messes with
            // plugin's controls
            if (t.isFullScreen) {
              t.media.removeEventListener('click', t.clickToPlayPauseCallback);
            } else {
              t.media.addEventListener('click', t.clickToPlayPauseCallback);
            }
            restoreControls();
          });


          // the mouseout event doesn't work on the fullscren button, because we already killed the pointer-events
          // so we use the document.mousemove event to restore controls when the mouse moves outside the fullscreen button

          t.globalBind('mousemove', function (e) {

            // if the mouse is anywhere but the fullsceen button, then restore it all
            if (fullscreenIsDisabled) {

              var fullscreenBtnPos = fullscreenBtn.offset();


              if (e.pageY < fullscreenBtnPos.top || e.pageY > fullscreenBtnPos.top + fullscreenBtn.outerHeight(true) ||
                e.pageX < fullscreenBtnPos.left || e.pageX > fullscreenBtnPos.left + fullscreenBtn.outerWidth(true)
              ) {

                fullscreenBtn.css('pointer-events', '');
                t.controls.css('pointer-events', '');

                fullscreenIsDisabled = false;
              }
            }
          });



        } else {

          // the hover state will show the fullscreen button in Flash to hover up and click

          fullscreenBtn
            .on('mouseover', function () {

              if (hideTimeout !== null) {
                clearTimeout(hideTimeout);
                delete hideTimeout;
              }

              var buttonPos = fullscreenBtn.offset(),
                containerPos = player.container.offset();

              media.positionFullscreenButton(buttonPos.left - containerPos.left, buttonPos.top - containerPos.top, true);

            })
            .on('mouseout', function () {

              if (hideTimeout !== null) {
                clearTimeout(hideTimeout);
                delete hideTimeout;
              }

              hideTimeout = setTimeout(function () {
                media.hideFullscreenButton();
              }, 1500);


            });
        }
      }

      player.fullscreenBtn = fullscreenBtn;

      t.globalBind('keydown', function (e) {
        if (((mejs.MediaFeatures.hasTrueNativeFullScreen && mejs.MediaFeatures.isFullScreen()) || t.isFullScreen) && e.keyCode == 27) {
          player.exitFullScreen();
        }
      });

    },

    cleanfullscreen: function (player) {
      player.exitFullScreen();
    },

    containerSizeTimeout: null,

    enterFullScreen: function () {

      var t = this;

      // firefox+flash can't adjust plugin sizes without resetting :(
      if (t.media.pluginType !== 'native' && (mejs.MediaFeatures.isFirefox || t.options.usePluginFullScreen)) {
        //t.media.setFullscreen(true);
        //player.isFullScreen = true;
        return;
      }

      // set it to not show scroll bars so 100% will work
      $(document.documentElement).addClass('mejs-fullscreen');

      // store sizing
      normalHeight = t.container.height();
      normalWidth = t.container.width();

      // attempt to do true fullscreen (Safari 5.1 and Firefox Nightly only for now)
      if (t.media.pluginType === 'native') {
        if (mejs.MediaFeatures.hasTrueNativeFullScreen) {

          mejs.MediaFeatures.requestFullScreen(t.container[0]);
          //return;

          if (t.isInIframe) {
            // sometimes exiting from fullscreen doesn't work
            // notably in Chrome <iframe>. Fixed in version 17
            setTimeout(function checkFullscreen() {

              if (t.isNativeFullScreen) {
                var zoomMultiplier = window["devicePixelRatio"] || 1;
                // Use a percent error margin since devicePixelRatio is a float and not exact.
                var percentErrorMargin = 0.002; // 0.2%
                var windowWidth = zoomMultiplier * $(window).width();
                var screenWidth = screen.width;
                var absDiff = Math.abs(screenWidth - windowWidth);
                var marginError = screenWidth * percentErrorMargin;

                // check if the video is suddenly not really fullscreen
                if (absDiff > marginError) {
                  // manually exit
                  t.exitFullScreen();
                } else {
                  // test again
                  setTimeout(checkFullscreen, 500);
                }
              }


            }, 500);
          }

        } else if (mejs.MediaFeatures.hasSemiNativeFullScreen) {
          t.media.webkitEnterFullscreen();
          return;
        }
      }

      // check for iframe launch
      if (t.isInIframe) {
        var url = t.options.newWindowCallback(this);


        if (url !== '') {

          // launch immediately
          if (!mejs.MediaFeatures.hasTrueNativeFullScreen) {
            t.pause();
            window.open(url, t.id, 'top=0,left=0,width=' + screen.availWidth + ',height=' + screen.availHeight + ',resizable=yes,scrollbars=no,status=no,toolbar=no');
            return;
          } else {
            setTimeout(function () {
              if (!t.isNativeFullScreen) {
                t.pause();
                window.open(url, t.id, 'top=0,left=0,width=' + screen.availWidth + ',height=' + screen.availHeight + ',resizable=yes,scrollbars=no,status=no,toolbar=no');
              }
            }, 250);
          }
        }

      }

      // full window code



      // make full size
      t.container
        .addClass('mejs-container-fullscreen')
        .width('100%')
        .height('100%');
      //.css({position: 'fixed', left: 0, top: 0, right: 0, bottom: 0, overflow: 'hidden', width: '100%', height: '100%', 'z-index': 1000});

      // Only needed for safari 5.1 native full screen, can cause display issues elsewhere
      // Actually, it seems to be needed for IE8, too
      //if (mejs.MediaFeatures.hasTrueNativeFullScreen) {
      t.containerSizeTimeout = setTimeout(function () {
        t.container.css({ width: '100%', height: '100%' });
        t.setControlsSize();
      }, 500);
      //}

      if (t.media.pluginType === 'native') {
        t.$media
          .width('100%')
          .height('100%');
      } else {
        t.container.find('.mejs-shim')
          .width('100%')
          .height('100%');

        //if (!mejs.MediaFeatures.hasTrueNativeFullScreen) {
        t.media.setVideoSize($(window).width(), $(window).height());
        //}
      }

      t.layers.children('div')
        .width('100%')
        .height('100%');

      if (t.fullscreenBtn) {
        t.fullscreenBtn
          .removeClass('mejs-fullscreen')
          .addClass('mejs-unfullscreen');
      }

      t.setControlsSize();
      t.isFullScreen = true;
    },

    exitFullScreen: function () {

      var t = this;

      // Prevent container from attempting to stretch a second time
      clearTimeout(t.containerSizeTimeout);

      // firefox can't adjust plugins
      if (t.media.pluginType !== 'native' && mejs.MediaFeatures.isFirefox) {
        t.media.setFullscreen(false);
        //player.isFullScreen = false;
        return;
      }

      // come outo of native fullscreen
      if (mejs.MediaFeatures.hasTrueNativeFullScreen && (mejs.MediaFeatures.isFullScreen() || t.isFullScreen)) {
        mejs.MediaFeatures.cancelFullScreen();
      }

      // restore scroll bars to document
      $(document.documentElement).removeClass('mejs-fullscreen');

      t.container
        .removeClass('mejs-container-fullscreen')
        .width(normalWidth)
        .height(normalHeight);
      //.css({position: '', left: '', top: '', right: '', bottom: '', overflow: 'inherit', width: normalWidth + 'px', height: normalHeight + 'px', 'z-index': 1});

      if (t.media.pluginType === 'native') {
        t.$media
          .width(normalWidth)
          .height(normalHeight);
      } else {
        t.container.find('.mejs-shim')
          .width(normalWidth)
          .height(normalHeight);

        t.media.setVideoSize(normalWidth, normalHeight);
      }

      t.layers.children('div')
        .width(normalWidth)
        .height(normalHeight);

      t.fullscreenBtn
        .removeClass('mejs-unfullscreen')
        .addClass('mejs-fullscreen');

      t.setControlsSize();
      t.isFullScreen = false;
    }
  });

})(mejs.$);

(function ($) {

  // add extra default options 
  $.extend(mejs.MepDefaults, {
    // this will automatically turn on a <track>
    startLanguage: '',

    tracksText: mejs.i18n.t('Captions/Subtitles'),

    // option to remove the [cc] button when no <track kind="subtitles"> are present
    hideCaptionsButtonWhenEmpty: true,

    // If true and we only have one track, change captions to popup
    toggleCaptionsButtonWhenOnlyOne: false,

    // #id or .class		
    slidesSelector: ''
  });

  $.extend(MediaElementPlayer.prototype, {

    hasChapters: false,

    buildtracks: function (player, controls, layers, media) {
      if (player.tracks.length == 0)
        return;

      var t = this,
        i,
        options = '';

      if (t.domNode.textTracks) { // if browser will do native captions, prefer mejs captions, loop through tracks and hide
        for (var i = t.domNode.textTracks.length - 1; i >= 0; i--) {
          t.domNode.textTracks[i].mode = "hidden";
        }
      }
      player.chapters =
        $('<div class="mejs-chapters mejs-layer"></div>')
          .prependTo(layers).hide();
      player.captions =
        $('<div class="mejs-captions-layer mejs-layer"><div class="mejs-captions-position mejs-captions-position-hover"><span class="mejs-captions-text"></span></div></div>')
          .prependTo(layers).hide();
      player.captionsText = player.captions.find('.mejs-captions-text');
      player.captionsButton =
        $('<div class="mejs-button mejs-captions-button">' +
          '<button type="button" aria-controls="' + t.id + '" title="' + t.options.tracksText + '" aria-label="' + t.options.tracksText + '"></button>' +
          '<div class="mejs-captions-selector">' +
          '<ul>' +
          '<li>' +
          '<input type="radio" name="' + player.id + '_captions" id="' + player.id + '_captions_none" value="none" checked="checked" />' +
          '<label for="' + player.id + '_captions_none">' + mejs.i18n.t('None') + '</label>' +
          '</li>' +
          '</ul>' +
          '</div>' +
          '</div>')
          .appendTo(controls);


      var subtitleCount = 0;
      for (i = 0; i < player.tracks.length; i++) {
        if (player.tracks[i].kind == 'subtitles') {
          subtitleCount++;
        }
      }

      // if only one language then just make the button a toggle
      if (t.options.toggleCaptionsButtonWhenOnlyOne && subtitleCount == 1) {
        // click
        player.captionsButton.on('click', function () {
          if (player.selectedTrack == null) {
            var lang = player.tracks[0].srclang;
          } else {
            var lang = 'none';
          }
          player.setTrack(lang);
        });
      } else {
        // hover
        player.captionsButton.hover(function () {
          $(this).find('.mejs-captions-selector').css('visibility', 'visible');
        }, function () {
          $(this).find('.mejs-captions-selector').css('visibility', 'hidden');
        })

          // handle clicks to the language radio buttons
          .on('click', 'input[type=radio]', function () {
            lang = this.value;
            player.setTrack(lang);
          });

      }

      if (!player.options.alwaysShowControls) {
        // move with controls
        player.container
          .bind('controlsshown', function () {
            // push captions above controls
            player.container.find('.mejs-captions-position').addClass('mejs-captions-position-hover');

          })
          .bind('controlshidden', function () {
            if (!media.paused) {
              // move back to normal place
              player.container.find('.mejs-captions-position').removeClass('mejs-captions-position-hover');
            }
          });
      } else {
        player.container.find('.mejs-captions-position').addClass('mejs-captions-position-hover');
      }

      player.trackToLoad = -1;
      player.selectedTrack = null;
      player.isLoadingTrack = false;



      // add to list
      for (i = 0; i < player.tracks.length; i++) {
        if (player.tracks[i].kind == 'subtitles') {
          player.addTrackButton(player.tracks[i].srclang, player.tracks[i].label);
        }
      }

      // start loading tracks
      player.loadNextTrack();


      media.addEventListener('timeupdate', function (e) {
        player.displayCaptions();
      }, false);

      if (player.options.slidesSelector != '') {
        player.slidesContainer = $(player.options.slidesSelector);

        media.addEventListener('timeupdate', function (e) {
          player.displaySlides();
        }, false);

      }

      media.addEventListener('loadedmetadata', function (e) {
        player.displayChapters();
      }, false);

      player.container.hover(
        function () {
          // chapters
          if (player.hasChapters) {
            player.chapters.css('visibility', 'visible');
            player.chapters.fadeIn(200).height(player.chapters.find('.mejs-chapter').outerHeight());
          }
        },
        function () {
          if (player.hasChapters && !media.paused) {
            player.chapters.fadeOut(200, function () {
              $(this).css('visibility', 'hidden');
              $(this).css('display', 'block');
            });
          }
        });

      // check for autoplay
      if (player.node.getAttribute('autoplay') !== null) {
        player.chapters.css('visibility', 'hidden');
      }
    },

    setTrack: function (lang) {

      var t = this,
        i;

      if (lang == 'none') {
        t.selectedTrack = null;
        t.captionsButton.removeClass('mejs-captions-enabled');
      } else {
        for (i = 0; i < t.tracks.length; i++) {
          if (t.tracks[i].srclang == lang) {
            if (t.selectedTrack == null)
              t.captionsButton.addClass('mejs-captions-enabled');
            t.selectedTrack = t.tracks[i];
            t.captions.attr('lang', t.selectedTrack.srclang);
            t.displayCaptions();
            break;
          }
        }
      }
    },

    loadNextTrack: function () {
      var t = this;

      t.trackToLoad++;
      if (t.trackToLoad < t.tracks.length) {
        t.isLoadingTrack = true;
        t.loadTrack(t.trackToLoad);
      } else {
        // add done?
        t.isLoadingTrack = false;

        t.checkForTracks();
      }
    },

    loadTrack: function (index) {
      var
        t = this,
        track = t.tracks[index],
        after = function () {

          track.isLoaded = true;

          // create button
          //t.addTrackButton(track.srclang);
          t.enableTrackButton(track.srclang, track.label);

          t.loadNextTrack();

        };


      $.ajax({
        url: track.src,
        dataType: "text",
        success: function (d) {

          // parse the loaded file
          if (typeof d == "string" && (/<tt\s+xml/ig).exec(d)) {
            track.entries = mejs.TrackFormatParser.dfxp.parse(d);
          } else {
            track.entries = mejs.TrackFormatParser.webvvt.parse(d);
          }

          after();

          if (track.kind == 'chapters') {
            t.media.addEventListener('play', function (e) {
              if (t.media.duration > 0) {
                t.displayChapters(track);
              }
            }, false);
          }

          if (track.kind == 'slides') {
            t.setupSlides(track);
          }
        },
        error: function () {
          t.loadNextTrack();
        }
      });
    },

    enableTrackButton: function (lang, label) {
      var t = this;

      if (label === '') {
        label = mejs.language.codes[lang] || lang;
      }

      t.captionsButton
        .find('input[value=' + lang + ']')
        .prop('disabled', false)
        .siblings('label')
        .html(label);

      // auto select
      if (t.options.startLanguage == lang) {
        $('#' + t.id + '_captions_' + lang).click();
      }

      t.adjustLanguageBox();
    },

    addTrackButton: function (lang, label) {
      var t = this;
      if (label === '') {
        label = mejs.language.codes[lang] || lang;
      }

      t.captionsButton.find('ul').append(
        $('<li>' +
          '<input type="radio" name="' + t.id + '_captions" id="' + t.id + '_captions_' + lang + '" value="' + lang + '" disabled="disabled" />' +
          '<label for="' + t.id + '_captions_' + lang + '">' + label + ' (loading)' + '</label>' +
          '</li>')
      );

      t.adjustLanguageBox();

      // remove this from the dropdownlist (if it exists)
      t.container.find('.mejs-captions-translations option[value=' + lang + ']').remove();
    },

    adjustLanguageBox: function () {
      var t = this;
      // adjust the size of the outer box
      t.captionsButton.find('.mejs-captions-selector').height(
        t.captionsButton.find('.mejs-captions-selector ul').outerHeight(true) +
        t.captionsButton.find('.mejs-captions-translations').outerHeight(true)
      );
    },

    checkForTracks: function () {
      var
        t = this,
        hasSubtitles = false;

      // check if any subtitles
      if (t.options.hideCaptionsButtonWhenEmpty) {
        for (i = 0; i < t.tracks.length; i++) {
          if (t.tracks[i].kind == 'subtitles') {
            hasSubtitles = true;
            break;
          }
        }

        if (!hasSubtitles) {
          t.captionsButton.hide();
          t.setControlsSize();
        }
      }
    },

    displayCaptions: function () {

      if (typeof this.tracks == 'undefined')
        return;

      var
        t = this,
        i,
        track = t.selectedTrack;

      if (track != null && track.isLoaded) {
        for (i = 0; i < track.entries.times.length; i++) {
          if (t.media.currentTime >= track.entries.times[i].start && t.media.currentTime <= track.entries.times[i].stop) {
            t.captionsText.html(track.entries.text[i]);
            t.captions.show().height(0);
            return; // exit out if one is visible;
          }
        }
        t.captions.hide();
      } else {
        t.captions.hide();
      }
    },

    setupSlides: function (track) {
      var t = this;

      t.slides = track;
      t.slides.entries.imgs = [t.slides.entries.text.length];
      t.showSlide(0);

    },

    showSlide: function (index) {
      if (typeof this.tracks == 'undefined' || typeof this.slidesContainer == 'undefined') {
        return;
      }

      var t = this,
        url = t.slides.entries.text[index],
        img = t.slides.entries.imgs[index];

      if (typeof img == 'undefined' || typeof img.fadeIn == 'undefined') {

        t.slides.entries.imgs[index] = img = $('<img src="' + url + '">')
          .on('load', function () {
            img.appendTo(t.slidesContainer)
              .hide()
              .fadeIn()
              .siblings(':visible')
              .fadeOut();

          });

      } else {

        if (!img.is(':visible') && !img.is(':animated')) {

          //			

          img.fadeIn()
            .siblings(':visible')
            .fadeOut();
        }
      }

    },

    displaySlides: function () {

      if (typeof this.slides == 'undefined')
        return;

      var
        t = this,
        slides = t.slides,
        i;

      for (i = 0; i < slides.entries.times.length; i++) {
        if (t.media.currentTime >= slides.entries.times[i].start && t.media.currentTime <= slides.entries.times[i].stop) {

          t.showSlide(i);

          return; // exit out if one is visible;
        }
      }
    },

    displayChapters: function () {
      var
        t = this,
        i;

      for (i = 0; i < t.tracks.length; i++) {
        if (t.tracks[i].kind == 'chapters' && t.tracks[i].isLoaded) {
          t.drawChapters(t.tracks[i]);
          t.hasChapters = true;
          break;
        }
      }
    },

    drawChapters: function (chapters) {
      var
        t = this,
        i,
        dur,
        //width,
        //left,
        percent = 0,
        usedPercent = 0;

      t.chapters.empty();

      for (i = 0; i < chapters.entries.times.length; i++) {
        dur = chapters.entries.times[i].stop - chapters.entries.times[i].start;
        percent = Math.floor(dur / t.media.duration * 100);
        if (percent + usedPercent > 100 || // too large
          i == chapters.entries.times.length - 1 && percent + usedPercent < 100) // not going to fill it in
        {
          percent = 100 - usedPercent;
        }
        //width = Math.floor(t.width * dur / t.media.duration);
        //left = Math.floor(t.width * chapters.entries.times[i].start / t.media.duration);
        //if (left + width > t.width) {
        //	width = t.width - left;
        //}

        t.chapters.append($(
          '<div class="mejs-chapter" rel="' + chapters.entries.times[i].start + '" style="left: ' + usedPercent.toString() + '%;width: ' + percent.toString() + '%;">' +
          '<div class="mejs-chapter-block' + ((i == chapters.entries.times.length - 1) ? ' mejs-chapter-block-last' : '') + '">' +
          '<span class="ch-title">' + chapters.entries.text[i] + '</span>' +
          '<span class="ch-time">' + mejs.Utility.secondsToTimeCode(chapters.entries.times[i].start) + '&ndash;' + mejs.Utility.secondsToTimeCode(chapters.entries.times[i].stop) + '</span>' +
          '</div>' +
          '</div>'));
        usedPercent += percent;
      }

      t.chapters.find('div.mejs-chapter').click(function () {
        t.media.setCurrentTime(parseFloat($(this).attr('rel')));
        if (t.media.paused) {
          t.media.play();
        }
      });

      t.chapters.show();
    }
  });



  mejs.language = {
    codes: {
      af: 'Afrikaans',
      sq: 'Albanian',
      ar: 'Arabic',
      be: 'Belarusian',
      bg: 'Bulgarian',
      ca: 'Catalan',
      zh: 'Chinese',
      'zh-cn': 'Chinese Simplified',
      'zh-tw': 'Chinese Traditional',
      hr: 'Croatian',
      cs: 'Czech',
      da: 'Danish',
      nl: 'Dutch',
      en: 'English',
      et: 'Estonian',
      tl: 'Filipino',
      fi: 'Finnish',
      fr: 'French',
      gl: 'Galician',
      de: 'German',
      el: 'Greek',
      ht: 'Haitian Creole',
      iw: 'Hebrew',
      hi: 'Hindi',
      hu: 'Hungarian',
      is: 'Icelandic',
      id: 'Indonesian',
      ga: 'Irish',
      it: 'Italian',
      ja: 'Japanese',
      ko: 'Korean',
      lv: 'Latvian',
      lt: 'Lithuanian',
      mk: 'Macedonian',
      ms: 'Malay',
      mt: 'Maltese',
      no: 'Norwegian',
      fa: 'Persian',
      pl: 'Polish',
      pt: 'Portuguese',
      //'pt-pt':'Portuguese (Portugal)',
      ro: 'Romanian',
      ru: 'Russian',
      sr: 'Serbian',
      sk: 'Slovak',
      sl: 'Slovenian',
      es: 'Spanish',
      sw: 'Swahili',
      sv: 'Swedish',
      tl: 'Tagalog',
      th: 'Thai',
      tr: 'Turkish',
      uk: 'Ukrainian',
      vi: 'Vietnamese',
      cy: 'Welsh',
      yi: 'Yiddish'
    }
  };

	/*
	Parses WebVVT format which should be formatted as
	================================
	WEBVTT
	
	1
	00:00:01,1 --> 00:00:05,000
	A line of text

	2
	00:01:15,1 --> 00:02:05,000
	A second line of text
	
	===============================

	Adapted from: http://www.delphiki.com/html5/playr
	*/
  mejs.TrackFormatParser = {
    webvvt: {
      // match start "chapter-" (or anythingelse)
      pattern_identifier: /^([a-zA-z]+-)?[0-9]+$/,
      pattern_timecode: /^([0-9]{2}:[0-9]{2}:[0-9]{2}([,.][0-9]{1,3})?) --\> ([0-9]{2}:[0-9]{2}:[0-9]{2}([,.][0-9]{3})?)(.*)$/,

      parse: function (trackText) {
        var
          i = 0,
          lines = mejs.TrackFormatParser.split2(trackText, /\r?\n/),
          entries = { text: [], times: [] },
          timecode,
          text;
        for (; i < lines.length; i++) {
          // check for the line number
          if (this.pattern_identifier.exec(lines[i])) {
            // skip to the next line where the start --> end time code should be
            i++;
            timecode = this.pattern_timecode.exec(lines[i]);

            if (timecode && i < lines.length) {
              i++;
              // grab all the (possibly multi-line) text that follows
              text = lines[i];
              i++;
              while (lines[i] !== '' && i < lines.length) {
                text = text + '\n' + lines[i];
                i++;
              }
              text = $.trim(text).replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1' target='_blank'>$1</a>");
              // Text is in a different array so I can use .join
              entries.text.push(text);
              entries.times.push(
                {
                  start: (mejs.Utility.convertSMPTEtoSeconds(timecode[1]) == 0) ? 0.200 : mejs.Utility.convertSMPTEtoSeconds(timecode[1]),
                  stop: mejs.Utility.convertSMPTEtoSeconds(timecode[3]),
                  settings: timecode[5]
                });
            }
          }
        }
        return entries;
      }
    },
    // Thanks to Justin Capella: https://github.com/johndyer/mediaelement/pull/420
    dfxp: {
      parse: function (trackText) {
        trackText = $(trackText).filter("tt");
        var
          i = 0,
          container = trackText.children("div").eq(0),
          lines = container.find("p"),
          styleNode = trackText.find("#" + container.attr("style")),
          styles,
          begin,
          end,
          text,
          entries = { text: [], times: [] };


        if (styleNode.length) {
          var attributes = styleNode.removeAttr("id").get(0).attributes;
          if (attributes.length) {
            styles = {};
            for (i = 0; i < attributes.length; i++) {
              styles[attributes[i].name.split(":")[1]] = attributes[i].value;
            }
          }
        }

        for (i = 0; i < lines.length; i++) {
          var style;
          var _temp_times = {
            start: null,
            stop: null,
            style: null
          };
          if (lines.eq(i).attr("begin")) _temp_times.start = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i).attr("begin"));
          if (!_temp_times.start && lines.eq(i - 1).attr("end")) _temp_times.start = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i - 1).attr("end"));
          if (lines.eq(i).attr("end")) _temp_times.stop = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i).attr("end"));
          if (!_temp_times.stop && lines.eq(i + 1).attr("begin")) _temp_times.stop = mejs.Utility.convertSMPTEtoSeconds(lines.eq(i + 1).attr("begin"));
          if (styles) {
            style = "";
            for (var _style in styles) {
              style += _style + ":" + styles[_style] + ";";
            }
          }
          if (style) _temp_times.style = style;
          if (_temp_times.start == 0) _temp_times.start = 0.200;
          entries.times.push(_temp_times);
          text = $.trim(lines.eq(i).html()).replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1' target='_blank'>$1</a>");
          entries.text.push(text);
          if (entries.times.start == 0) entries.times.start = 2;
        }
        return entries;
      }
    },
    split2: function (text, regex) {
      // normal version for compliant browsers
      // see below for IE fix
      return text.split(regex);
    }
  };

  // test for browsers with bad String.split method.
  if ('x\n\ny'.split(/\n/gi).length != 3) {
    // add super slow IE8 and below version
    mejs.TrackFormatParser.split2 = function (text, regex) {
      var
        parts = [],
        chunk = '',
        i;

      for (i = 0; i < text.length; i++) {
        chunk += text.substring(i, i + 1);
        if (regex.test(chunk)) {
          parts.push(chunk.replace(regex, ''));
          chunk = '';
        }
      }
      parts.push(chunk);
      return parts;
    }
  }

})(mejs.$);

/*
* ContextMenu Plugin
* 
*
*/

(function ($) {

  $.extend(mejs.MepDefaults,
    {
      'contextMenuItems': [
        // demo of a fullscreen option
        {
          render: function (player) {

            // check for fullscreen plugin
            if (typeof player.enterFullScreen == 'undefined')
              return null;

            if (player.isFullScreen) {
              return mejs.i18n.t('Turn off Fullscreen');
            } else {
              return mejs.i18n.t('Go Fullscreen');
            }
          },
          click: function (player) {
            if (player.isFullScreen) {
              player.exitFullScreen();
            } else {
              player.enterFullScreen();
            }
          }
        }
        ,
        // demo of a mute/unmute button
        {
          render: function (player) {
            if (player.media.muted) {
              return mejs.i18n.t('Unmute');
            } else {
              return mejs.i18n.t('Mute');
            }
          },
          click: function (player) {
            if (player.media.muted) {
              player.setMuted(false);
            } else {
              player.setMuted(true);
            }
          }
        },
        // separator
        {
          isSeparator: true
        }
        ,
        // demo of simple download video
        {
          render: function (player) {
            return mejs.i18n.t('Download Video');
          },
          click: function (player) {
            window.location.href = player.media.currentSrc;
          }
        }
      ]
    }
  );


  $.extend(MediaElementPlayer.prototype, {
    buildcontextmenu: function (player, controls, layers, media) {

      // create context menu
      player.contextMenu = $('<div class="mejs-contextmenu"></div>')
        .appendTo($('body'))
        .hide();

      // create events for showing context menu
      player.container.bind('contextmenu', function (e) {
        if (player.isContextMenuEnabled) {
          e.preventDefault();
          player.renderContextMenu(e.clientX - 1, e.clientY - 1);
          return false;
        }
      });
      player.container.bind('click', function () {
        player.contextMenu.hide();
      });
      player.contextMenu.bind('mouseleave', function () {

        //
        player.startContextMenuTimer();

      });
    },

    cleancontextmenu: function (player) {
      player.contextMenu.remove();
    },

    isContextMenuEnabled: true,
    enableContextMenu: function () {
      this.isContextMenuEnabled = true;
    },
    disableContextMenu: function () {
      this.isContextMenuEnabled = false;
    },

    contextMenuTimeout: null,
    startContextMenuTimer: function () {
      //

      var t = this;

      t.killContextMenuTimer();

      t.contextMenuTimer = setTimeout(function () {
        t.hideContextMenu();
        t.killContextMenuTimer();
      }, 750);
    },
    killContextMenuTimer: function () {
      var timer = this.contextMenuTimer;

      //

      if (timer != null) {
        clearTimeout(timer);
        delete timer;
        timer = null;
      }
    },

    hideContextMenu: function () {
      this.contextMenu.hide();
    },

    renderContextMenu: function (x, y) {

      // alway re-render the items so that things like "turn fullscreen on" and "turn fullscreen off" are always written correctly
      var t = this,
        html = '',
        items = t.options.contextMenuItems;

      for (var i = 0, il = items.length; i < il; i++) {

        if (items[i].isSeparator) {
          html += '<div class="mejs-contextmenu-separator"></div>';
        } else {

          var rendered = items[i].render(t);

          // render can return null if the item doesn't need to be used at the moment
          if (rendered != null) {
            html += '<div class="mejs-contextmenu-item" data-itemindex="' + i + '" id="element-' + (Math.random() * 1000000) + '">' + rendered + '</div>';
          }
        }
      }

      // position and show the context menu
      t.contextMenu
        .empty()
        .append($(html))
        .css({ top: y, left: x })
        .show();

      // bind events
      t.contextMenu.find('.mejs-contextmenu-item').each(function () {

        // which one is this?
        var $dom = $(this),
          itemIndex = parseInt($dom.data('itemindex'), 10),
          item = t.options.contextMenuItems[itemIndex];

        // bind extra functionality?
        if (typeof item.show != 'undefined')
          item.show($dom, t);

        // bind click action
        $dom.click(function () {
          // perform click action
          if (typeof item.click != 'undefined')
            item.click(t);

          // close
          t.contextMenu.hide();
        });
      });

      // stop the controls from hiding
      setTimeout(function () {
        t.killControlsTimer('rev3');
      }, 100);

    }
  });

})(mejs.$);
/**
 * Postroll plugin
 */
(function ($) {

  $.extend(mejs.MepDefaults, {
    postrollCloseText: mejs.i18n.t('Close')
  });

  // Postroll
  $.extend(MediaElementPlayer.prototype, {
    buildpostroll: function (player, controls, layers, media) {
      var
        t = this,
        postrollLink = t.container.find('link[rel="postroll"]').attr('href');

      if (typeof postrollLink !== 'undefined') {
        player.postroll =
          $('<div class="mejs-postroll-layer mejs-layer"><a class="mejs-postroll-close" onclick="$(this).parent().hide();return false;">' + t.options.postrollCloseText + '</a><div class="mejs-postroll-layer-content"></div></div>').prependTo(layers).hide();

        t.media.addEventListener('ended', function (e) {
          $.ajax({
            dataType: 'html',
            url: postrollLink,
            success: function (data, textStatus) {
              layers.find('.mejs-postroll-layer-content').html(data);
            }
          });
          player.postroll.show();
        }, false);
      }
    }
  });

})(mejs.$);

$(document).ready(function () {

  window.dispatchEvent(new Event('resize'));

  // Sold out color red fix
  // if($(".ProductItem__LabelList")){
  //   let productLabels = $(".ProductItem__LabelList");
  //   productLabels.each(function(idx, productLabel){
  //     if ($(productLabel).find('span').text().toLowerCase() == "sold out"){
  //       $(productLabel).addClass("SoldOut");
  //     }
  //   })
  // }
  if(".shopping-info"){
    $(".shipping-info span").on('click', function(){
      $('.modal').fadeIn(300);
      var scrollPosition = [
        self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      ];
      var html = $('html'); // it would make more sense to apply this to body, but IE7 won't have that
      html.data('scroll-position', scrollPosition);
      html.data('previous-overflow', html.css('overflow'));
      html.css('overflow', 'hidden');
      window.scrollTo(scrollPosition[0], scrollPosition[1]);
    })

    $(".shipping-time .close").on('click', function(){
      $('.modal').fadeOut(300);
      var html = $('html');
      var scrollPosition = html.data('scroll-position');
      html.css('overflow', html.data('previous-overflow'));
      window.scrollTo(scrollPosition[0], scrollPosition[1])
    })
  }

  console.log('media player initialized');

  //**********************************//
  //*****  Initiate Audio Player *****//
  //**********************************//
  $('.audio-player2').mediaelementplayer({
    alwaysShowControls: true,
    features: ['playpause'],
    audioVolume: 'horizontal',
    audioWidth: 567,
    audioHeight: 50,
    iPadUseNativeControls: false,
    iPhoneUseNativeControls: false,
    AndroidUseNativeControls: false
  });

  //**********************************//
  //*****         iWish          *****//
  //**********************************//

  $(document).ready(function () {
    $("a[href='/apps/iwish']").click(function (e) {
      if (typeof (Storage) !== "undefined") {
        e.preventDefault();
        iWishPost('/apps/iwish', { iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid });
      }
    });
    $(".iWishAdd").click(function () {
      console.log('WISH ADDED');
      var iWishvId = $(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
      iwish_add($(this), iWishvId);
      return false;
    });
    $(".iWishAddColl").click(function () {
      var iWishvId = $(this).attr("data-variant");
      iwish_addCollection($(this), iWishvId);
      return false;
    });
    iwishCheckColl();

    if ($('.iwishProducts') && $('.ProductItem__Title') && $('.ProductItem__PriceList')){
      $('.ProductItem__Title').addClass('iwishProductItem__Title');
      $(".ProductItem__PriceList").addClass('iwishProductItem__PriceList');
    };
  });
  function iwishCheckColl() {
    if ($(".iwishcheck").length > 0) {
      $(".iwishcheck").each(function () {
        var iWishvId = $(this).attr("data-variant");
        var iWishpId = $(this).attr("data-product");
        if (isInWishlist(iWishpId, iWishvId)) { $(this).addClass("iwishAdded").html(iwish_added_txt_col); }
        $(this).removeClass("iwishcheck");
      });
    }
  }
})

  //**********************************//
  //*****         Fixing product image list being hard to scroll on iOS13          *****//
  //**********************************//

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();